// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host ::ng-deep .w-full {
  width: 100% !important;
}
:host ::ng-deep .py-4 {
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important;
}
:host ::ng-deep .grid > .col, :host ::ng-deep .grid > [class*=col] {
  box-sizing: border-box;
}
:host ::ng-deep .border-top-1 {
  border-top-width: 1px !important;
  border-top-style: solid;
}
:host ::ng-deep .surface-border {
  border-color: var(--surface-border) !important;
}
:host ::ng-deep .border-circle {
  border-radius: 50% !important;
}
:host ::ng-deep .align-items-center {
  align-items: center !important;
}
:host ::ng-deep .justify-content-center {
  justify-content: center !important;
}
:host ::ng-deep .flex {
  display: flex !important;
}
:host ::ng-deep .text-white {
  color: #fff !important;
}
:host ::ng-deep .bg-green-100 {
  background-color: var(--green-100) !important;
}
:host ::ng-deep .bg-green-500 {
  background-color: var(--green-500) !important;
}
:host ::ng-deep .bg-blue-100 {
  background-color: var(--blue-100) !important;
}
:host ::ng-deep .bg-blue-500 {
  background-color: var(--blue-500) !important;
}
:host ::ng-deep .bg-yellow-100 {
  background-color: var(--yellow-100) !important;
}
:host ::ng-deep .bg-yellow-500 {
  background-color: var(--yellow-500) !important;
}
:host ::ng-deep .bg-orange-100 {
  background-color: var(--orange-100) !important;
}
:host ::ng-deep .bg-orange-500 {
  background-color: var(--orange-500) !important;
}
:host ::ng-deep .bg-red-100 {
  background-color: var(--red-100) !important;
}
:host ::ng-deep .bg-red-500 {
  background-color: var(--red-500) !important;
}
:host ::ng-deep .p-ripple {
  overflow: hidden;
  position: relative;
}
:host ::ng-deep .text-primary {
  color: var(--primary-color) !important;
}
:host ::ng-deep a {
  text-decoration: none;
  line-height: 16px;
}
:host ::ng-deep .border-primary {
  border-color: var(--primary-color) !important;
}
:host ::ng-deep .p-2 {
  padding: 0.5rem !important;
}
:host ::ng-deep .font-medium {
  font-weight: 500 !important;
}
:host ::ng-deep .p-ink {
  display: block;
  position: absolute;
  background: rgba(255, 255, 255, 0.5);
  border-radius: 100%;
  transform: scale(0);
}
:host ::ng-deep .font-light {
  font-weight: 300 !important;
}
:host ::ng-deep .transition-duration-150 {
  transition-duration: 0.15s !important;
}
:host ::ng-deep .select-none {
  -webkit-user-select: none !important;
  user-select: none !important;
}
:host ::ng-deep .cursor-pointer {
  cursor: pointer !important;
}
:host ::ng-deep .w-10rem {
  width: 10rem !important;
}
:host ::ng-deep .border-round {
  border-radius: 8px !important;
}
:host ::ng-deep .border-1 {
  border-width: 1px !important;
  border-style: solid;
}
:host ::ng-deep .text-sm {
  font-size: 0.875rem !important;
}
:host ::ng-deep .my-auto {
  margin-top: auto !important;
  margin-bottom: auto !important;
}
:host ::ng-deep .h-8rem {
  height: 8rem !important;
}
:host ::ng-deep .w-8rem {
  width: 8rem !important;
}
:host ::ng-deep .line-normal {
  line-height: normal;
}
:host ::ng-deep .block {
  display: block !important;
}
:host ::ng-deep .text-700 {
  color: var(--surface-700) !important;
}
:host ::ng-deep .text-align-left {
  text-align: left;
}
:host ::ng-deep .text-left {
  text-align: left !important;
}
:host ::ng-deep .text-center {
  text-align: center !important;
}
:host ::ng-deep .text-justify {
  text-align: justify !important;
}
:host ::ng-deep .text-left {
  text-align: left !important;
}
:host ::ng-deep .text-right {
  text-align: right !important;
}
:host ::ng-deep .flex {
  display: flex !important;
}
:host ::ng-deep .border-round-top {
  border-top-left-radius: 8px !important;
  border-top-right-radius: 8px !important;
}
:host ::ng-deep .surface-100 {
  background-color: var(--surface-100) !important;
}
:host ::ng-deep .col-12 {
  flex: 0 0 auto;
  padding: 1rem;
  width: 100%;
}
:host ::ng-deep .border-round {
  border-radius: 8px !important;
}
:host ::ng-deep .shadow-2 {
  border: 1px solid lightgray;
}
:host ::ng-deep .mb-6 {
  margin-bottom: 3rem !important;
}
:host ::ng-deep .surface-card {
  background-color: var(--surface-card) !important;
}
:host ::ng-deep .grid-nogutter {
  margin-right: 0;
  margin-left: 0;
  margin-top: 0;
}
:host ::ng-deep .grid {
  display: flex;
  flex-wrap: wrap;
  margin-top: -1rem;
}
:host ::ng-deep .grid-nogutter {
  margin-right: 0;
  margin-left: 0;
  margin-top: 0;
}
:host ::ng-deep * {
  box-sizing: border-box;
}
:host ::ng-deep .grid-nogutter > .col, :host ::ng-deep .grid-nogutter > [class*=col-] {
  padding: 0;
}
:host ::ng-deep .my-4 {
  margin-top: 1.5rem !important;
  margin-bottom: 1.5rem !important;
}
:host ::ng-deep .align-items-center {
  align-items: center !important;
}
:host ::ng-deep .justify-content-between {
  justify-content: space-between !important;
}
:host ::ng-deep .focus\\:text-primary:focus {
  color: var(--primary-color) !important;
}
:host ::ng-deep .hover\\:text-primary:hover, :host ::ng-deep .active\\:text-primary:active {
  color: var(--primary-color) !important;
}
:host ::ng-deep .focus\\:bg-primary:focus {
  color: var(--primary-color-text) !important;
  background-color: var(--primary-color) !important;
}
:host ::ng-deep .hover\\:bg-primary:hover, :host ::ng-deep .active\\:bg-primary:active {
  color: var(--primary-color-text) !important;
  background-color: var(--primary-color) !important;
}
:host ::ng-deep .focus\\:bg-primary-reverse:focus {
  color: var(--primary-color) !important;
  background-color: var(--primary-color-text) !important;
}
:host ::ng-deep .hover\\:bg-primary-reverse:hover, :host ::ng-deep .active\\:bg-primary-reverse:active {
  color: var(--primary-color) !important;
  background-color: var(--primary-color-text) !important;
}
:host ::ng-deep .focus\\:bg-white:focus {
  background-color: #fff !important;
}
:host ::ng-deep .hover\\:bg-white:hover, :host ::ng-deep .active\\:bg-white:active {
  background-color: #fff !important;
}
:host ::ng-deep .focus\\:border-primary:focus {
  border-color: var(--primary-color) !important;
}
:host ::ng-deep .hover\\:border-primary:hover, :host ::ng-deep .active\\:border-primary:active {
  border-color: var(--primary-color) !important;
}
:host ::ng-deep .focus\\:text-white:focus {
  color: #fff !important;
}
:host ::ng-deep .hover\\:text-white:hover, :host ::ng-deep .active\\:text-white:active {
  color: #fff !important;
}
:host ::ng-deep .focus\\:border-white:focus {
  border-color: #fff !important;
}
:host ::ng-deep .hover\\:border-white:hover, :host ::ng-deep .active\\:border-white:active {
  border-color: #fff !important;
}
:host ::ng-deep .focus\\:text-color:focus {
  color: var(--text-color) !important;
}
:host ::ng-deep .hover\\:text-color:hover, :host ::ng-deep .active\\:text-color:active {
  color: var(--text-color) !important;
}
:host ::ng-deep .focus\\:text-color-secondary:focus {
  color: var(--text-color-secondary) !important;
}
:host ::ng-deep .hover\\:text-color-secondary:hover, :host ::ng-deep .active\\:text-color-secondary:active {
  color: var(--text-color-secondary) !important;
}
:host ::ng-deep .focus\\:surface-ground:focus {
  background-color: var(--surface-ground) !important;
}
:host ::ng-deep .hover\\:surface-ground:hover, :host ::ng-deep .active\\:surface-ground:active {
  background-color: var(--surface-ground) !important;
}
:host ::ng-deep .focus\\:surface-section:focus {
  background-color: var(--surface-section) !important;
}
:host ::ng-deep .hover\\:surface-section:hover, :host ::ng-deep .active\\:surface-section:active {
  background-color: var(--surface-section) !important;
}
:host ::ng-deep .focus\\:surface-card:focus {
  background-color: var(--surface-card) !important;
}
:host ::ng-deep .hover\\:surface-card:hover, :host ::ng-deep .active\\:surface-card:active {
  background-color: var(--surface-card) !important;
}
:host ::ng-deep .focus\\:surface-overlay:focus {
  background-color: var(--surface-overlay) !important;
}
:host ::ng-deep .hover\\:surface-overlay:hover, :host ::ng-deep .active\\:surface-overlay:active {
  background-color: var(--surface-overlay) !important;
}
:host ::ng-deep .focus\\:surface-hover:focus {
  background-color: var(--surface-hover) !important;
}
:host ::ng-deep .hover\\:surface-hover:hover, :host ::ng-deep .active\\:surface-hover:active {
  background-color: var(--surface-hover) !important;
}
:host ::ng-deep .focus\\:surface-border:focus {
  border-color: var(--surface-border) !important;
}
:host ::ng-deep .hover\\:surface-border:hover, :host ::ng-deep .active\\:surface-border:active {
  border-color: var(--surface-border) !important;
}

@media screen and (min-width: 768px) {
  .md\\:flex-row {
    flex-direction: row !important;
  }
  .md\\:flex-row-reverse {
    flex-direction: row-reverse !important;
  }
  .md\\:flex-column {
    flex-direction: column !important;
  }
  .md\\:flex-column-reverse {
    flex-direction: column-reverse !important;
  }
}
@media screen and (min-width: 992px) {
  .lg\\:flex-row {
    flex-direction: row !important;
  }
  .lg\\:flex-row-reverse {
    flex-direction: row-reverse !important;
  }
  .lg\\:flex-column {
    flex-direction: column !important;
  }
  .lg\\:flex-column-reverse {
    flex-direction: column-reverse !important;
  }
}
@media screen and (min-width: 1200px) {
  .xl\\:flex-row {
    flex-direction: row !important;
  }
  .xl\\:flex-row-reverse {
    flex-direction: row-reverse !important;
  }
  .xl\\:flex-column {
    flex-direction: column !important;
  }
  .xl\\:flex-column-reverse {
    flex-direction: column-reverse !important;
  }
}
.flex-order-0 {
  order: 0 !important;
}

.flex-order-1 {
  order: 1 !important;
}

.flex-order-2 {
  order: 2 !important;
}

.flex-order-3 {
  order: 3 !important;
}

.flex-order-4 {
  order: 4 !important;
}

.flex-order-5 {
  order: 5 !important;
}

.flex-order-6 {
  order: 6 !important;
}

@media screen and (min-width: 576px) {
  .sm\\:flex-order-0 {
    order: 0 !important;
  }
  .sm\\:flex-order-1 {
    order: 1 !important;
  }
  .sm\\:flex-order-2 {
    order: 2 !important;
  }
  .sm\\:flex-order-3 {
    order: 3 !important;
  }
  .sm\\:flex-order-4 {
    order: 4 !important;
  }
  .sm\\:flex-order-5 {
    order: 5 !important;
  }
  .sm\\:flex-order-6 {
    order: 6 !important;
  }
}
@media screen and (min-width: 768px) {
  .md\\:flex-order-0 {
    order: 0 !important;
  }
  .md\\:flex-order-1 {
    order: 1 !important;
  }
  .md\\:flex-order-2 {
    order: 2 !important;
  }
  .md\\:flex-order-3 {
    order: 3 !important;
  }
  .md\\:flex-order-4 {
    order: 4 !important;
  }
  .md\\:flex-order-5 {
    order: 5 !important;
  }
  .md\\:flex-order-6 {
    order: 6 !important;
  }
}
@media screen and (min-width: 992px) {
  .lg\\:flex-order-0 {
    order: 0 !important;
  }
  .lg\\:flex-order-1 {
    order: 1 !important;
  }
  .lg\\:flex-order-2 {
    order: 2 !important;
  }
  .lg\\:flex-order-3 {
    order: 3 !important;
  }
  .lg\\:flex-order-4 {
    order: 4 !important;
  }
  .lg\\:flex-order-5 {
    order: 5 !important;
  }
  .lg\\:flex-order-6 {
    order: 6 !important;
  }
}
@media screen and (min-width: 1200px) {
  .xl\\:flex-order-0 {
    order: 0 !important;
  }
  .xl\\:flex-order-1 {
    order: 1 !important;
  }
  .xl\\:flex-order-2 {
    order: 2 !important;
  }
  .xl\\:flex-order-3 {
    order: 3 !important;
  }
  .xl\\:flex-order-4 {
    order: 4 !important;
  }
  .xl\\:flex-order-5 {
    order: 5 !important;
  }
  .xl\\:flex-order-6 {
    order: 6 !important;
  }
}
.flex-1 {
  flex: 1 1 0% !important;
}

.flex-auto {
  flex: 1 1 auto !important;
}

.flex-initial {
  flex: 0 1 auto !important;
}

.flex-none {
  flex: none !important;
}

@media screen and (min-width: 576px) {
  .sm\\:flex-1 {
    flex: 1 1 0% !important;
  }
  .sm\\:flex-auto {
    flex: 1 1 auto !important;
  }
  .sm\\:flex-initial {
    flex: 0 1 auto !important;
  }
  .sm\\:flex-none {
    flex: none !important;
  }
}
@media screen and (min-width: 768px) {
  .md\\:flex-1 {
    flex: 1 1 0% !important;
  }
  .md\\:flex-auto {
    flex: 1 1 auto !important;
  }
  .md\\:flex-initial {
    flex: 0 1 auto !important;
  }
  .md\\:flex-none {
    flex: none !important;
  }
}
@media screen and (min-width: 992px) {
  .lg\\:flex-1 {
    flex: 1 1 0% !important;
  }
  .lg\\:flex-auto {
    flex: 1 1 auto !important;
  }
  .lg\\:flex-initial {
    flex: 0 1 auto !important;
  }
  .lg\\:flex-none {
    flex: none !important;
  }
}
@media screen and (min-width: 1200px) {
  .xl\\:flex-1 {
    flex: 1 1 0% !important;
  }
  .xl\\:flex-auto {
    flex: 1 1 auto !important;
  }
  .xl\\:flex-initial {
    flex: 0 1 auto !important;
  }
  .xl\\:flex-none {
    flex: none !important;
  }
}
.flex-grow-0 {
  flex-grow: 0 !important;
}

.flex-grow-1 {
  flex-grow: 1 !important;
}

@media screen and (min-width: 576px) {
  .sm\\:flex-grow-0 {
    flex-grow: 0 !important;
  }
  .sm\\:flex-grow-1 {
    flex-grow: 1 !important;
  }
}
@media screen and (min-width: 768px) {
  .md\\:flex-grow-0 {
    flex-grow: 0 !important;
  }
  .md\\:flex-grow-1 {
    flex-grow: 1 !important;
  }
}
@media screen and (min-width: 992px) {
  .lg\\:flex-grow-0 {
    flex-grow: 0 !important;
  }
  .lg\\:flex-grow-1 {
    flex-grow: 1 !important;
  }
}
@media screen and (min-width: 1200px) {
  .xl\\:flex-grow-0 {
    flex-grow: 0 !important;
  }
  .xl\\:flex-grow-1 {
    flex-grow: 1 !important;
  }
}
.flex-shrink-0 {
  flex-shrink: 0 !important;
}

.flex-shrink-1 {
  flex-shrink: 1 !important;
}

@media screen and (min-width: 576px) {
  .sm\\:flex-shrink-0 {
    flex-shrink: 0 !important;
  }
  .sm\\:flex-shrink-1 {
    flex-shrink: 1 !important;
  }
}
@media screen and (min-width: 768px) {
  .md\\:flex-shrink-0 {
    flex-shrink: 0 !important;
  }
  .md\\:flex-shrink-1 {
    flex-shrink: 1 !important;
  }
}
@media screen and (min-width: 992px) {
  .lg\\:flex-shrink-0 {
    flex-shrink: 0 !important;
  }
  .lg\\:flex-shrink-1 {
    flex-shrink: 1 !important;
  }
}
@media screen and (min-width: 1200px) {
  .xl\\:flex-shrink-0 {
    flex-shrink: 0 !important;
  }
  .xl\\:flex-shrink-1 {
    flex-shrink: 1 !important;
  }
}
.gap-0 {
  gap: 0rem !important;
}

.gap-1 {
  gap: 0.25rem !important;
}

.gap-2 {
  gap: 0.5rem !important;
}

.gap-3 {
  gap: 1rem !important;
}

.gap-4 {
  gap: 1.5rem !important;
}

.gap-5 {
  gap: 2rem !important;
}

.gap-6 {
  gap: 3rem !important;
}

.gap-7 {
  gap: 4rem !important;
}

.gap-8 {
  gap: 5rem !important;
}

.row-gap-0 {
  row-gap: 0rem !important;
}

.row-gap-1 {
  row-gap: 0.25rem !important;
}

.row-gap-2 {
  row-gap: 0.5rem !important;
}

.row-gap-3 {
  row-gap: 1rem !important;
}

.row-gap-4 {
  row-gap: 1.5rem !important;
}

.row-gap-5 {
  row-gap: 2rem !important;
}

.row-gap-6 {
  row-gap: 3rem !important;
}

.row-gap-7 {
  row-gap: 4rem !important;
}

.row-gap-8 {
  row-gap: 5rem !important;
}

.column-gap-0 {
  column-gap: 0rem !important;
}

.column-gap-1 {
  column-gap: 0.25rem !important;
}

.column-gap-2 {
  column-gap: 0.5rem !important;
}

.column-gap-3 {
  column-gap: 1rem !important;
}

.column-gap-4 {
  column-gap: 1.5rem !important;
}

.column-gap-5 {
  column-gap: 2rem !important;
}

.column-gap-6 {
  column-gap: 3rem !important;
}

.column-gap-7 {
  column-gap: 4rem !important;
}

.column-gap-8 {
  column-gap: 5rem !important;
}

@media screen and (min-width: 576px) {
  .sm\\:gap-0 {
    gap: 0rem !important;
  }
  .sm\\:gap-1 {
    gap: 0.25rem !important;
  }
  .sm\\:gap-2 {
    gap: 0.5rem !important;
  }
  .sm\\:gap-3 {
    gap: 1rem !important;
  }
  .sm\\:gap-4 {
    gap: 1.5rem !important;
  }
  .sm\\:gap-5 {
    gap: 2rem !important;
  }
  .sm\\:gap-6 {
    gap: 3rem !important;
  }
  .sm\\:gap-7 {
    gap: 4rem !important;
  }
  .sm\\:gap-8 {
    gap: 5rem !important;
  }
  .sm\\:row-gap-0 {
    row-gap: 0rem !important;
  }
  .sm\\:row-gap-1 {
    row-gap: 0.25rem !important;
  }
  .sm\\:row-gap-2 {
    row-gap: 0.5rem !important;
  }
  .sm\\:row-gap-3 {
    row-gap: 1rem !important;
  }
  .sm\\:row-gap-4 {
    row-gap: 1.5rem !important;
  }
  .sm\\:row-gap-5 {
    row-gap: 2rem !important;
  }
  .sm\\:row-gap-6 {
    row-gap: 3rem !important;
  }
  .sm\\:row-gap-7 {
    row-gap: 4rem !important;
  }
  .sm\\:row-gap-8 {
    row-gap: 5rem !important;
  }
  .sm\\:column-gap-0 {
    column-gap: 0rem !important;
  }
  .sm\\:column-gap-1 {
    column-gap: 0.25rem !important;
  }
  .sm\\:column-gap-2 {
    column-gap: 0.5rem !important;
  }
  .sm\\:column-gap-3 {
    column-gap: 1rem !important;
  }
  .sm\\:column-gap-4 {
    column-gap: 1.5rem !important;
  }
  .sm\\:column-gap-5 {
    column-gap: 2rem !important;
  }
  .sm\\:column-gap-6 {
    column-gap: 3rem !important;
  }
  .sm\\:column-gap-7 {
    column-gap: 4rem !important;
  }
  .sm\\:column-gap-8 {
    column-gap: 5rem !important;
  }
}
@media screen and (min-width: 768px) {
  .md\\:gap-0 {
    gap: 0rem !important;
  }
  .md\\:gap-1 {
    gap: 0.25rem !important;
  }
  .md\\:gap-2 {
    gap: 0.5rem !important;
  }
  .md\\:gap-3 {
    gap: 1rem !important;
  }
  .md\\:gap-4 {
    gap: 1.5rem !important;
  }
  .md\\:gap-5 {
    gap: 2rem !important;
  }
  .md\\:gap-6 {
    gap: 3rem !important;
  }
  .md\\:gap-7 {
    gap: 4rem !important;
  }
  .md\\:gap-8 {
    gap: 5rem !important;
  }
  .md\\:row-gap-0 {
    row-gap: 0rem !important;
  }
  .md\\:row-gap-1 {
    row-gap: 0.25rem !important;
  }
  .md\\:row-gap-2 {
    row-gap: 0.5rem !important;
  }
  .md\\:row-gap-3 {
    row-gap: 1rem !important;
  }
  .md\\:row-gap-4 {
    row-gap: 1.5rem !important;
  }
  .md\\:row-gap-5 {
    row-gap: 2rem !important;
  }
  .md\\:row-gap-6 {
    row-gap: 3rem !important;
  }
  .md\\:row-gap-7 {
    row-gap: 4rem !important;
  }
  .md\\:row-gap-8 {
    row-gap: 5rem !important;
  }
  .md\\:column-gap-0 {
    column-gap: 0rem !important;
  }
  .md\\:column-gap-1 {
    column-gap: 0.25rem !important;
  }
  .md\\:column-gap-2 {
    column-gap: 0.5rem !important;
  }
  .md\\:column-gap-3 {
    column-gap: 1rem !important;
  }
  .md\\:column-gap-4 {
    column-gap: 1.5rem !important;
  }
  .md\\:column-gap-5 {
    column-gap: 2rem !important;
  }
  .md\\:column-gap-6 {
    column-gap: 3rem !important;
  }
  .md\\:column-gap-7 {
    column-gap: 4rem !important;
  }
  .md\\:column-gap-8 {
    column-gap: 5rem !important;
  }
}
@media screen and (min-width: 992px) {
  .lg\\:gap-0 {
    gap: 0rem !important;
  }
  .lg\\:gap-1 {
    gap: 0.25rem !important;
  }
  .lg\\:gap-2 {
    gap: 0.5rem !important;
  }
  .lg\\:gap-3 {
    gap: 1rem !important;
  }
  .lg\\:gap-4 {
    gap: 1.5rem !important;
  }
  .lg\\:gap-5 {
    gap: 2rem !important;
  }
  .lg\\:gap-6 {
    gap: 3rem !important;
  }
  .lg\\:gap-7 {
    gap: 4rem !important;
  }
  .lg\\:gap-8 {
    gap: 5rem !important;
  }
  .lg\\:row-gap-0 {
    row-gap: 0rem !important;
  }
  .lg\\:row-gap-1 {
    row-gap: 0.25rem !important;
  }
  .lg\\:row-gap-2 {
    row-gap: 0.5rem !important;
  }
  .lg\\:row-gap-3 {
    row-gap: 1rem !important;
  }
  .lg\\:row-gap-4 {
    row-gap: 1.5rem !important;
  }
  .lg\\:row-gap-5 {
    row-gap: 2rem !important;
  }
  .lg\\:row-gap-6 {
    row-gap: 3rem !important;
  }
  .lg\\:row-gap-7 {
    row-gap: 4rem !important;
  }
  .lg\\:row-gap-8 {
    row-gap: 5rem !important;
  }
  .lg\\:column-gap-0 {
    column-gap: 0rem !important;
  }
  .lg\\:column-gap-1 {
    column-gap: 0.25rem !important;
  }
  .lg\\:column-gap-2 {
    column-gap: 0.5rem !important;
  }
  .lg\\:column-gap-3 {
    column-gap: 1rem !important;
  }
  .lg\\:column-gap-4 {
    column-gap: 1.5rem !important;
  }
  .lg\\:column-gap-5 {
    column-gap: 2rem !important;
  }
  .lg\\:column-gap-6 {
    column-gap: 3rem !important;
  }
  .lg\\:column-gap-7 {
    column-gap: 4rem !important;
  }
  .lg\\:column-gap-8 {
    column-gap: 5rem !important;
  }
}
@media screen and (min-width: 1200px) {
  .xl\\:gap-0 {
    gap: 0rem !important;
  }
  .xl\\:gap-1 {
    gap: 0.25rem !important;
  }
  .xl\\:gap-2 {
    gap: 0.5rem !important;
  }
  .xl\\:gap-3 {
    gap: 1rem !important;
  }
  .xl\\:gap-4 {
    gap: 1.5rem !important;
  }
  .xl\\:gap-5 {
    gap: 2rem !important;
  }
  .xl\\:gap-6 {
    gap: 3rem !important;
  }
  .xl\\:gap-7 {
    gap: 4rem !important;
  }
  .xl\\:gap-8 {
    gap: 5rem !important;
  }
  .xl\\:row-gap-0 {
    row-gap: 0rem !important;
  }
  .xl\\:row-gap-1 {
    row-gap: 0.25rem !important;
  }
  .xl\\:row-gap-2 {
    row-gap: 0.5rem !important;
  }
  .xl\\:row-gap-3 {
    row-gap: 1rem !important;
  }
  .xl\\:row-gap-4 {
    row-gap: 1.5rem !important;
  }
  .xl\\:row-gap-5 {
    row-gap: 2rem !important;
  }
  .xl\\:row-gap-6 {
    row-gap: 3rem !important;
  }
  .xl\\:row-gap-7 {
    row-gap: 4rem !important;
  }
  .xl\\:row-gap-8 {
    row-gap: 5rem !important;
  }
  .xl\\:column-gap-0 {
    column-gap: 0rem !important;
  }
  .xl\\:column-gap-1 {
    column-gap: 0.25rem !important;
  }
  .xl\\:column-gap-2 {
    column-gap: 0.5rem !important;
  }
  .xl\\:column-gap-3 {
    column-gap: 1rem !important;
  }
  .xl\\:column-gap-4 {
    column-gap: 1.5rem !important;
  }
  .xl\\:column-gap-5 {
    column-gap: 2rem !important;
  }
  .xl\\:column-gap-6 {
    column-gap: 3rem !important;
  }
  .xl\\:column-gap-7 {
    column-gap: 4rem !important;
  }
  .xl\\:column-gap-8 {
    column-gap: 5rem !important;
  }
}
@media screen and (min-width: 576px) {
  .sm\\:text-center {
    text-align: center !important;
  }
  .sm\\:text-justify {
    text-align: justify !important;
  }
  .sm\\:text-left {
    text-align: left !important;
  }
  .sm\\:text-right {
    text-align: right !important;
  }
}
@media screen and (min-width: 768px) {
  .md\\:text-center {
    text-align: center !important;
  }
  .md\\:text-justify {
    text-align: justify !important;
  }
  .md\\:text-left {
    text-align: left !important;
  }
  .md\\:text-right {
    text-align: right !important;
  }
}
@media screen and (min-width: 992px) {
  .lg\\:text-center {
    text-align: center !important;
  }
  .lg\\:text-justify {
    text-align: justify !important;
  }
  .lg\\:text-left {
    text-align: left !important;
  }
  .lg\\:text-right {
    text-align: right !important;
  }
}
@media screen and (min-width: 1200px) {
  .xl\\:text-center {
    text-align: center !important;
  }
  .xl\\:text-justify {
    text-align: justify !important;
  }
  .xl\\:text-left {
    text-align: left !important;
  }
  .xl\\:text-right {
    text-align: right !important;
  }
}
.footer-eleven {
  padding-top: 30px;
  padding-bottom: 100px;
  background-color: var(--dark-1);
  position: relative;
  border-top: 2px solid black;
}
.footer-eleven h3 {
  color: var(--primary);
}

@media only screen and (min-width: 768px) and (max-width: 991px), (max-width: 767px) {
  .footer-eleven {
    padding-top: 30px;
    padding-bottom: 70px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .footer-eleven .footer-widget {
    margin-top: 40px;
  }
}
@media (max-width: 1199px) {
  .footer-eleven .footer-widget {
    margin-top: 40px;
    /*text-align: center;*/
  }
  .footer-eleven .footer-widget.f-about {
    margin-top: 40px;
    text-align: center;
  }
}
.footer-eleven .footer-widget h4 {
  font-weight: 700;
  margin-bottom: 6px;
  color: var(--primary);
}

@media only screen and (min-width: 768px) and (max-width: 991px), (max-width: 767px) {
  .footer-eleven .footer-widget h4 {
    margin-bottom: 6px;
  }
}
.footer-eleven .f-about {
  padding-right: 30px;
}

@media (max-width: 767px) {
  .footer-eleven .f-about {
    padding: 0;
  }
}
.footer-eleven .f-about p {
  /*color: var(--dark-3);*/
  color: var(--light-1);
  margin-top: 20px;
}

.footer-eleven .f-about .copyright-text {
  /*color: var(--dark-3);*/
  color: var(--light-1);
  margin-top: 20px;
}
@media (max-width: 1199px) {
  .footer-eleven .f-about .copyright-text .visualage {
    display: flex;
    width: -moz-fit-content;
    width: fit-content;
    margin: auto;
  }
}
.footer-eleven .f-about .copyright-text .visualage {
  display: flex;
  width: -moz-fit-content;
  width: fit-content;
}

.footer-eleven .f-about .copyright-text span {
  display: block;
}

@media (max-width: 767px) {
  .footer-eleven .f-about .copyright-text {
    margin-top: 20px;
  }
}
.footer-eleven .f-about .copyright-text a {
  color: var(--light-1);
}

.footer-eleven .f-about .copyright-text a:hover {
  color: var(--visualage-1);
}

.footer-eleven .f-link li {
  display: block;
  margin-bottom: 6px;
}

.footer-eleven .f-link li:last-child {
  margin: 0 0 25px 0;
}

.footer-eleven .f-link li a {
  /*color: var(--dark-3);*/
  color: var(--light-1);
  transition: all 0.4s ease-out 0s;
}

.footer-eleven .f-link li a:hover {
  color: var(--primary);
}

@media only screen and (min-width: 1200px) and (max-width: 1399px), only screen and (min-width: 1400px) {
  .footer-eleven .newsletter {
    padding-left: 80px;
  }
}
.footer-eleven .newsletter p {
  color: var(--dark-3);
}

.footer-eleven .newsletter-form {
  margin-top: 30px;
  position: relative;
}

.footer-eleven .newsletter-form input {
  height: 55px;
  width: 100%;
  border-radius: 8px;
  border: 1px solid var(--gray-4);
  box-shadow: none;
  text-shadow: none;
  padding-left: 18px;
  padding-right: 65px;
  transition: all 0.4s ease;
}

.footer-eleven .newsletter-form input:focus {
  border-color: var(--primary);
}

.footer-eleven .newsletter-form .button {
  position: absolute;
  right: 7px;
  top: 50%;
  transform: translateY(-50%);
}

.footer-eleven .newsletter-form .sub-btn {
  height: 42px;
  width: 42px;
  border-radius: 6px;
  background-color: var(--primary);
  color: var(--white);
  text-align: center;
  line-height: 42px;
  border: none;
  box-shadow: none;
  text-shadow: none;
  font-size: 17px;
  transition: all 0.4s ease;
}

.footer-eleven .newsletter-form .sub-btn:hover {
  color: var(--white);
  background-color: var(--primary-dark);
}

.insight {
  padding: 0.5rem 0.5rem 0.5rem 3rem !important;
}
.insight .pi.pi-info-circle {
  color: var(--primary);
  font-size: xx-large;
}

@media (max-width: 991px) {
  .insight {
    padding: 0.5rem !important;
  }
}
.p-span-12 {
  width: 100% !important;
}

.m-0 {
  margin: 0rem !important;
}

.m-1 {
  margin: 0.25rem !important;
}

.m-2 {
  margin: 0.5rem !important;
}

.m-3 {
  margin: 1rem !important;
}

.m-4 {
  margin: 1.5rem !important;
}

.m-5 {
  margin: 2rem !important;
}

.m-6 {
  margin: 3rem !important;
}

.m-7 {
  margin: 4rem !important;
}

.m-8 {
  margin: 5rem !important;
}

.-m-1 {
  margin: -0.25rem !important;
}

.-m-2 {
  margin: -0.5rem !important;
}

.-m-3 {
  margin: -1rem !important;
}

.-m-4 {
  margin: -1.5rem !important;
}

.-m-5 {
  margin: -2rem !important;
}

.-m-6 {
  margin: -3rem !important;
}

.-m-7 {
  margin: -4rem !important;
}

.-m-8 {
  margin: -5rem !important;
}

.m-auto {
  margin: auto !important;
}

.mt-0 {
  margin-top: 0rem !important;
}

.mt-1 {
  margin-top: 0.25rem !important;
}

.mt-2 {
  margin-top: 0.5rem !important;
}

.mt-3 {
  margin-top: 1rem !important;
}

.mt-4 {
  margin-top: 1.5rem !important;
}

.mt-5 {
  margin-top: 2rem !important;
}

.mt-6 {
  margin-top: 3rem !important;
}

.mt-7 {
  margin-top: 4rem !important;
}

.mt-8 {
  margin-top: 5rem !important;
}

.-mt-1 {
  margin-top: -0.25rem !important;
}

.-mt-2 {
  margin-top: -0.5rem !important;
}

.-mt-3 {
  margin-top: -1rem !important;
}

.-mt-4 {
  margin-top: -1.5rem !important;
}

.-mt-5 {
  margin-top: -2rem !important;
}

.-mt-6 {
  margin-top: -3rem !important;
}

.-mt-7 {
  margin-top: -4rem !important;
}

.-mt-8 {
  margin-top: -5rem !important;
}

.mt-auto {
  margin-top: auto !important;
}

.mr-0 {
  margin-right: 0rem !important;
}

.mr-1 {
  margin-right: 0.25rem !important;
}

.mr-2 {
  margin-right: 0.5rem !important;
}

.mr-3 {
  margin-right: 1rem !important;
}

.mr-4 {
  margin-right: 1.5rem !important;
}

.mr-5 {
  margin-right: 2rem !important;
}

.mr-6 {
  margin-right: 3rem !important;
}

.mr-7 {
  margin-right: 4rem !important;
}

.mr-8 {
  margin-right: 5rem !important;
}

.-mr-1 {
  margin-right: -0.25rem !important;
}

.-mr-2 {
  margin-right: -0.5rem !important;
}

.-mr-3 {
  margin-right: -1rem !important;
}

.-mr-4 {
  margin-right: -1.5rem !important;
}

.-mr-5 {
  margin-right: -2rem !important;
}

.-mr-6 {
  margin-right: -3rem !important;
}

.-mr-7 {
  margin-right: -4rem !important;
}

.-mr-8 {
  margin-right: -5rem !important;
}

.mr-auto {
  margin-right: auto !important;
}

.ml-0 {
  margin-left: 0rem !important;
}

.ml-1 {
  margin-left: 0.25rem !important;
}

.ml-2 {
  margin-left: 0.5rem !important;
}

.ml-3 {
  margin-left: 1rem !important;
}

.ml-4 {
  margin-left: 1.5rem !important;
}

.ml-5 {
  margin-left: 2rem !important;
}

.ml-6 {
  margin-left: 3rem !important;
}

.ml-7 {
  margin-left: 4rem !important;
}

.ml-8 {
  margin-left: 5rem !important;
}

.-ml-1 {
  margin-left: -0.25rem !important;
}

.-ml-2 {
  margin-left: -0.5rem !important;
}

.-ml-3 {
  margin-left: -1rem !important;
}

.-ml-4 {
  margin-left: -1.5rem !important;
}

.-ml-5 {
  margin-left: -2rem !important;
}

.-ml-6 {
  margin-left: -3rem !important;
}

.-ml-7 {
  margin-left: -4rem !important;
}

.-ml-8 {
  margin-left: -5rem !important;
}

.ml-auto {
  margin-left: auto !important;
}

.mb-0 {
  margin-bottom: 0rem !important;
}

.mb-1 {
  margin-bottom: 0.25rem !important;
}

.mb-2 {
  margin-bottom: 0.5rem !important;
}

.mb-3 {
  margin-bottom: 1rem !important;
}

.mb-4 {
  margin-bottom: 1.5rem !important;
}

.mb-5 {
  margin-bottom: 2rem !important;
}

.mb-6 {
  margin-bottom: 3rem !important;
}

.mb-7 {
  margin-bottom: 4rem !important;
}

.mb-8 {
  margin-bottom: 5rem !important;
}

.-mb-1 {
  margin-bottom: -0.25rem !important;
}

.-mb-2 {
  margin-bottom: -0.5rem !important;
}

.-mb-3 {
  margin-bottom: -1rem !important;
}

.-mb-4 {
  margin-bottom: -1.5rem !important;
}

.-mb-5 {
  margin-bottom: -2rem !important;
}

.-mb-6 {
  margin-bottom: -3rem !important;
}

.-mb-7 {
  margin-bottom: -4rem !important;
}

.-mb-8 {
  margin-bottom: -5rem !important;
}

.mb-auto {
  margin-bottom: auto !important;
}

.mx-0 {
  margin-left: 0rem !important;
  margin-right: 0rem !important;
}

.mx-1 {
  margin-left: 0.25rem !important;
  margin-right: 0.25rem !important;
}

.mx-2 {
  margin-left: 0.5rem !important;
  margin-right: 0.5rem !important;
}

.mx-3 {
  margin-left: 1rem !important;
  margin-right: 1rem !important;
}

.mx-4 {
  margin-left: 1.5rem !important;
  margin-right: 1.5rem !important;
}

.mx-5 {
  margin-left: 2rem !important;
  margin-right: 2rem !important;
}

.mx-6 {
  margin-left: 3rem !important;
  margin-right: 3rem !important;
}

.mx-7 {
  margin-left: 4rem !important;
  margin-right: 4rem !important;
}

.mx-8 {
  margin-left: 5rem !important;
  margin-right: 5rem !important;
}

.-mx-1 {
  margin-left: -0.25rem !important;
  margin-right: -0.25rem !important;
}

.-mx-2 {
  margin-left: -0.5rem !important;
  margin-right: -0.5rem !important;
}

.-mx-3 {
  margin-left: -1rem !important;
  margin-right: -1rem !important;
}

.-mx-4 {
  margin-left: -1.5rem !important;
  margin-right: -1.5rem !important;
}

.-mx-5 {
  margin-left: -2rem !important;
  margin-right: -2rem !important;
}

.-mx-6 {
  margin-left: -3rem !important;
  margin-right: -3rem !important;
}

.-mx-7 {
  margin-left: -4rem !important;
  margin-right: -4rem !important;
}

.-mx-8 {
  margin-left: -5rem !important;
  margin-right: -5rem !important;
}

.mx-auto {
  margin-left: auto !important;
  margin-right: auto !important;
}

.my-0 {
  margin-top: 0rem !important;
  margin-bottom: 0rem !important;
}

.my-1 {
  margin-top: 0.25rem !important;
  margin-bottom: 0.25rem !important;
}

.my-2 {
  margin-top: 0.5rem !important;
  margin-bottom: 0.5rem !important;
}

.my-3 {
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;
}

.my-4 {
  margin-top: 1.5rem !important;
  margin-bottom: 1.5rem !important;
}

.my-5 {
  margin-top: 2rem !important;
  margin-bottom: 2rem !important;
}

.my-6 {
  margin-top: 3rem !important;
  margin-bottom: 3rem !important;
}

.my-7 {
  margin-top: 4rem !important;
  margin-bottom: 4rem !important;
}

.my-8 {
  margin-top: 5rem !important;
  margin-bottom: 5rem !important;
}

.-my-1 {
  margin-top: -0.25rem !important;
  margin-bottom: -0.25rem !important;
}

.-my-2 {
  margin-top: -0.5rem !important;
  margin-bottom: -0.5rem !important;
}

.-my-3 {
  margin-top: -1rem !important;
  margin-bottom: -1rem !important;
}

.-my-4 {
  margin-top: -1.5rem !important;
  margin-bottom: -1.5rem !important;
}

.-my-5 {
  margin-top: -2rem !important;
  margin-bottom: -2rem !important;
}

.-my-6 {
  margin-top: -3rem !important;
  margin-bottom: -3rem !important;
}

.-my-7 {
  margin-top: -4rem !important;
  margin-bottom: -4rem !important;
}

.-my-8 {
  margin-top: -5rem !important;
  margin-bottom: -5rem !important;
}

.my-auto {
  margin-top: auto !important;
  margin-bottom: auto !important;
}

@media screen and (min-width: 576px) {
  .sm\\:m-0 {
    margin: 0rem !important;
  }
  .sm\\:m-1 {
    margin: 0.25rem !important;
  }
  .sm\\:m-2 {
    margin: 0.5rem !important;
  }
  .sm\\:m-3 {
    margin: 1rem !important;
  }
  .sm\\:m-4 {
    margin: 1.5rem !important;
  }
  .sm\\:m-5 {
    margin: 2rem !important;
  }
  .sm\\:m-6 {
    margin: 3rem !important;
  }
  .sm\\:m-7 {
    margin: 4rem !important;
  }
  .sm\\:m-8 {
    margin: 5rem !important;
  }
  .sm\\:-m-1 {
    margin: -0.25rem !important;
  }
  .sm\\:-m-2 {
    margin: -0.5rem !important;
  }
  .sm\\:-m-3 {
    margin: -1rem !important;
  }
  .sm\\:-m-4 {
    margin: -1.5rem !important;
  }
  .sm\\:-m-5 {
    margin: -2rem !important;
  }
  .sm\\:-m-6 {
    margin: -3rem !important;
  }
  .sm\\:-m-7 {
    margin: -4rem !important;
  }
  .sm\\:-m-8 {
    margin: -5rem !important;
  }
  .sm\\:m-auto {
    margin: auto !important;
  }
  .sm\\:mt-0 {
    margin-top: 0rem !important;
  }
  .sm\\:mt-1 {
    margin-top: 0.25rem !important;
  }
  .sm\\:mt-2 {
    margin-top: 0.5rem !important;
  }
  .sm\\:mt-3 {
    margin-top: 1rem !important;
  }
  .sm\\:mt-4 {
    margin-top: 1.5rem !important;
  }
  .sm\\:mt-5 {
    margin-top: 2rem !important;
  }
  .sm\\:mt-6 {
    margin-top: 3rem !important;
  }
  .sm\\:mt-7 {
    margin-top: 4rem !important;
  }
  .sm\\:mt-8 {
    margin-top: 5rem !important;
  }
  .sm\\:-mt-1 {
    margin-top: -0.25rem !important;
  }
  .sm\\:-mt-2 {
    margin-top: -0.5rem !important;
  }
  .sm\\:-mt-3 {
    margin-top: -1rem !important;
  }
  .sm\\:-mt-4 {
    margin-top: -1.5rem !important;
  }
  .sm\\:-mt-5 {
    margin-top: -2rem !important;
  }
  .sm\\:-mt-6 {
    margin-top: -3rem !important;
  }
  .sm\\:-mt-7 {
    margin-top: -4rem !important;
  }
  .sm\\:-mt-8 {
    margin-top: -5rem !important;
  }
  .sm\\:mt-auto {
    margin-top: auto !important;
  }
  .sm\\:mr-0 {
    margin-right: 0rem !important;
  }
  .sm\\:mr-1 {
    margin-right: 0.25rem !important;
  }
  .sm\\:mr-2 {
    margin-right: 0.5rem !important;
  }
  .sm\\:mr-3 {
    margin-right: 1rem !important;
  }
  .sm\\:mr-4 {
    margin-right: 1.5rem !important;
  }
  .sm\\:mr-5 {
    margin-right: 2rem !important;
  }
  .sm\\:mr-6 {
    margin-right: 3rem !important;
  }
  .sm\\:mr-7 {
    margin-right: 4rem !important;
  }
  .sm\\:mr-8 {
    margin-right: 5rem !important;
  }
  .sm\\:-mr-1 {
    margin-right: -0.25rem !important;
  }
  .sm\\:-mr-2 {
    margin-right: -0.5rem !important;
  }
  .sm\\:-mr-3 {
    margin-right: -1rem !important;
  }
  .sm\\:-mr-4 {
    margin-right: -1.5rem !important;
  }
  .sm\\:-mr-5 {
    margin-right: -2rem !important;
  }
  .sm\\:-mr-6 {
    margin-right: -3rem !important;
  }
  .sm\\:-mr-7 {
    margin-right: -4rem !important;
  }
  .sm\\:-mr-8 {
    margin-right: -5rem !important;
  }
  .sm\\:mr-auto {
    margin-right: auto !important;
  }
  .sm\\:ml-0 {
    margin-left: 0rem !important;
  }
  .sm\\:ml-1 {
    margin-left: 0.25rem !important;
  }
  .sm\\:ml-2 {
    margin-left: 0.5rem !important;
  }
  .sm\\:ml-3 {
    margin-left: 1rem !important;
  }
  .sm\\:ml-4 {
    margin-left: 1.5rem !important;
  }
  .sm\\:ml-5 {
    margin-left: 2rem !important;
  }
  .sm\\:ml-6 {
    margin-left: 3rem !important;
  }
  .sm\\:ml-7 {
    margin-left: 4rem !important;
  }
  .sm\\:ml-8 {
    margin-left: 5rem !important;
  }
  .sm\\:-ml-1 {
    margin-left: -0.25rem !important;
  }
  .sm\\:-ml-2 {
    margin-left: -0.5rem !important;
  }
  .sm\\:-ml-3 {
    margin-left: -1rem !important;
  }
  .sm\\:-ml-4 {
    margin-left: -1.5rem !important;
  }
  .sm\\:-ml-5 {
    margin-left: -2rem !important;
  }
  .sm\\:-ml-6 {
    margin-left: -3rem !important;
  }
  .sm\\:-ml-7 {
    margin-left: -4rem !important;
  }
  .sm\\:-ml-8 {
    margin-left: -5rem !important;
  }
  .sm\\:ml-auto {
    margin-left: auto !important;
  }
  .sm\\:mb-0 {
    margin-bottom: 0rem !important;
  }
  .sm\\:mb-1 {
    margin-bottom: 0.25rem !important;
  }
  .sm\\:mb-2 {
    margin-bottom: 0.5rem !important;
  }
  .sm\\:mb-3 {
    margin-bottom: 1rem !important;
  }
  .sm\\:mb-4 {
    margin-bottom: 1.5rem !important;
  }
  .sm\\:mb-5 {
    margin-bottom: 2rem !important;
  }
  .sm\\:mb-6 {
    margin-bottom: 3rem !important;
  }
  .sm\\:mb-7 {
    margin-bottom: 4rem !important;
  }
  .sm\\:mb-8 {
    margin-bottom: 5rem !important;
  }
  .sm\\:-mb-1 {
    margin-bottom: -0.25rem !important;
  }
  .sm\\:-mb-2 {
    margin-bottom: -0.5rem !important;
  }
  .sm\\:-mb-3 {
    margin-bottom: -1rem !important;
  }
  .sm\\:-mb-4 {
    margin-bottom: -1.5rem !important;
  }
  .sm\\:-mb-5 {
    margin-bottom: -2rem !important;
  }
  .sm\\:-mb-6 {
    margin-bottom: -3rem !important;
  }
  .sm\\:-mb-7 {
    margin-bottom: -4rem !important;
  }
  .sm\\:-mb-8 {
    margin-bottom: -5rem !important;
  }
  .sm\\:mb-auto {
    margin-bottom: auto !important;
  }
  .sm\\:mx-0 {
    margin-left: 0rem !important;
    margin-right: 0rem !important;
  }
  .sm\\:mx-1 {
    margin-left: 0.25rem !important;
    margin-right: 0.25rem !important;
  }
  .sm\\:mx-2 {
    margin-left: 0.5rem !important;
    margin-right: 0.5rem !important;
  }
  .sm\\:mx-3 {
    margin-left: 1rem !important;
    margin-right: 1rem !important;
  }
  .sm\\:mx-4 {
    margin-left: 1.5rem !important;
    margin-right: 1.5rem !important;
  }
  .sm\\:mx-5 {
    margin-left: 2rem !important;
    margin-right: 2rem !important;
  }
  .sm\\:mx-6 {
    margin-left: 3rem !important;
    margin-right: 3rem !important;
  }
  .sm\\:mx-7 {
    margin-left: 4rem !important;
    margin-right: 4rem !important;
  }
  .sm\\:mx-8 {
    margin-left: 5rem !important;
    margin-right: 5rem !important;
  }
  .sm\\:-mx-1 {
    margin-left: -0.25rem !important;
    margin-right: -0.25rem !important;
  }
  .sm\\:-mx-2 {
    margin-left: -0.5rem !important;
    margin-right: -0.5rem !important;
  }
  .sm\\:-mx-3 {
    margin-left: -1rem !important;
    margin-right: -1rem !important;
  }
  .sm\\:-mx-4 {
    margin-left: -1.5rem !important;
    margin-right: -1.5rem !important;
  }
  .sm\\:-mx-5 {
    margin-left: -2rem !important;
    margin-right: -2rem !important;
  }
  .sm\\:-mx-6 {
    margin-left: -3rem !important;
    margin-right: -3rem !important;
  }
  .sm\\:-mx-7 {
    margin-left: -4rem !important;
    margin-right: -4rem !important;
  }
  .sm\\:-mx-8 {
    margin-left: -5rem !important;
    margin-right: -5rem !important;
  }
  .sm\\:mx-auto {
    margin-left: auto !important;
    margin-right: auto !important;
  }
  .sm\\:my-0 {
    margin-top: 0rem !important;
    margin-bottom: 0rem !important;
  }
  .sm\\:my-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .sm\\:my-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .sm\\:my-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .sm\\:my-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .sm\\:my-5 {
    margin-top: 2rem !important;
    margin-bottom: 2rem !important;
  }
  .sm\\:my-6 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .sm\\:my-7 {
    margin-top: 4rem !important;
    margin-bottom: 4rem !important;
  }
  .sm\\:my-8 {
    margin-top: 5rem !important;
    margin-bottom: 5rem !important;
  }
  .sm\\:-my-1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }
  .sm\\:-my-2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }
  .sm\\:-my-3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }
  .sm\\:-my-4 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }
  .sm\\:-my-5 {
    margin-top: -2rem !important;
    margin-bottom: -2rem !important;
  }
  .sm\\:-my-6 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }
  .sm\\:-my-7 {
    margin-top: -4rem !important;
    margin-bottom: -4rem !important;
  }
  .sm\\:-my-8 {
    margin-top: -5rem !important;
    margin-bottom: -5rem !important;
  }
  .sm\\:my-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
}
@media screen and (min-width: 768px) {
  .md\\:m-0 {
    margin: 0rem !important;
  }
  .md\\:m-1 {
    margin: 0.25rem !important;
  }
  .md\\:m-2 {
    margin: 0.5rem !important;
  }
  .md\\:m-3 {
    margin: 1rem !important;
  }
  .md\\:m-4 {
    margin: 1.5rem !important;
  }
  .md\\:m-5 {
    margin: 2rem !important;
  }
  .md\\:m-6 {
    margin: 3rem !important;
  }
  .md\\:m-7 {
    margin: 4rem !important;
  }
  .md\\:m-8 {
    margin: 5rem !important;
  }
  .md\\:-m-1 {
    margin: -0.25rem !important;
  }
  .md\\:-m-2 {
    margin: -0.5rem !important;
  }
  .md\\:-m-3 {
    margin: -1rem !important;
  }
  .md\\:-m-4 {
    margin: -1.5rem !important;
  }
  .md\\:-m-5 {
    margin: -2rem !important;
  }
  .md\\:-m-6 {
    margin: -3rem !important;
  }
  .md\\:-m-7 {
    margin: -4rem !important;
  }
  .md\\:-m-8 {
    margin: -5rem !important;
  }
  .md\\:m-auto {
    margin: auto !important;
  }
  .md\\:mt-0 {
    margin-top: 0rem !important;
  }
  .md\\:mt-1 {
    margin-top: 0.25rem !important;
  }
  .md\\:mt-2 {
    margin-top: 0.5rem !important;
  }
  .md\\:mt-3 {
    margin-top: 1rem !important;
  }
  .md\\:mt-4 {
    margin-top: 1.5rem !important;
  }
  .md\\:mt-5 {
    margin-top: 2rem !important;
  }
  .md\\:mt-6 {
    margin-top: 3rem !important;
  }
  .md\\:mt-7 {
    margin-top: 4rem !important;
  }
  .md\\:mt-8 {
    margin-top: 5rem !important;
  }
  .md\\:-mt-1 {
    margin-top: -0.25rem !important;
  }
  .md\\:-mt-2 {
    margin-top: -0.5rem !important;
  }
  .md\\:-mt-3 {
    margin-top: -1rem !important;
  }
  .md\\:-mt-4 {
    margin-top: -1.5rem !important;
  }
  .md\\:-mt-5 {
    margin-top: -2rem !important;
  }
  .md\\:-mt-6 {
    margin-top: -3rem !important;
  }
  .md\\:-mt-7 {
    margin-top: -4rem !important;
  }
  .md\\:-mt-8 {
    margin-top: -5rem !important;
  }
  .md\\:mt-auto {
    margin-top: auto !important;
  }
  .md\\:mr-0 {
    margin-right: 0rem !important;
  }
  .md\\:mr-1 {
    margin-right: 0.25rem !important;
  }
  .md\\:mr-2 {
    margin-right: 0.5rem !important;
  }
  .md\\:mr-3 {
    margin-right: 1rem !important;
  }
  .md\\:mr-4 {
    margin-right: 1.5rem !important;
  }
  .md\\:mr-5 {
    margin-right: 2rem !important;
  }
  .md\\:mr-6 {
    margin-right: 3rem !important;
  }
  .md\\:mr-7 {
    margin-right: 4rem !important;
  }
  .md\\:mr-8 {
    margin-right: 5rem !important;
  }
  .md\\:-mr-1 {
    margin-right: -0.25rem !important;
  }
  .md\\:-mr-2 {
    margin-right: -0.5rem !important;
  }
  .md\\:-mr-3 {
    margin-right: -1rem !important;
  }
  .md\\:-mr-4 {
    margin-right: -1.5rem !important;
  }
  .md\\:-mr-5 {
    margin-right: -2rem !important;
  }
  .md\\:-mr-6 {
    margin-right: -3rem !important;
  }
  .md\\:-mr-7 {
    margin-right: -4rem !important;
  }
  .md\\:-mr-8 {
    margin-right: -5rem !important;
  }
  .md\\:mr-auto {
    margin-right: auto !important;
  }
  .md\\:ml-0 {
    margin-left: 0rem !important;
  }
  .md\\:ml-1 {
    margin-left: 0.25rem !important;
  }
  .md\\:ml-2 {
    margin-left: 0.5rem !important;
  }
  .md\\:ml-3 {
    margin-left: 1rem !important;
  }
  .md\\:ml-4 {
    margin-left: 1.5rem !important;
  }
  .md\\:ml-5 {
    margin-left: 2rem !important;
  }
  .md\\:ml-6 {
    margin-left: 3rem !important;
  }
  .md\\:ml-7 {
    margin-left: 4rem !important;
  }
  .md\\:ml-8 {
    margin-left: 5rem !important;
  }
  .md\\:-ml-1 {
    margin-left: -0.25rem !important;
  }
  .md\\:-ml-2 {
    margin-left: -0.5rem !important;
  }
  .md\\:-ml-3 {
    margin-left: -1rem !important;
  }
  .md\\:-ml-4 {
    margin-left: -1.5rem !important;
  }
  .md\\:-ml-5 {
    margin-left: -2rem !important;
  }
  .md\\:-ml-6 {
    margin-left: -3rem !important;
  }
  .md\\:-ml-7 {
    margin-left: -4rem !important;
  }
  .md\\:-ml-8 {
    margin-left: -5rem !important;
  }
  .md\\:ml-auto {
    margin-left: auto !important;
  }
  .md\\:mb-0 {
    margin-bottom: 0rem !important;
  }
  .md\\:mb-1 {
    margin-bottom: 0.25rem !important;
  }
  .md\\:mb-2 {
    margin-bottom: 0.5rem !important;
  }
  .md\\:mb-3 {
    margin-bottom: 1rem !important;
  }
  .md\\:mb-4 {
    margin-bottom: 1.5rem !important;
  }
  .md\\:mb-5 {
    margin-bottom: 2rem !important;
  }
  .md\\:mb-6 {
    margin-bottom: 3rem !important;
  }
  .md\\:mb-7 {
    margin-bottom: 4rem !important;
  }
  .md\\:mb-8 {
    margin-bottom: 5rem !important;
  }
  .md\\:-mb-1 {
    margin-bottom: -0.25rem !important;
  }
  .md\\:-mb-2 {
    margin-bottom: -0.5rem !important;
  }
  .md\\:-mb-3 {
    margin-bottom: -1rem !important;
  }
  .md\\:-mb-4 {
    margin-bottom: -1.5rem !important;
  }
  .md\\:-mb-5 {
    margin-bottom: -2rem !important;
  }
  .md\\:-mb-6 {
    margin-bottom: -3rem !important;
  }
  .md\\:-mb-7 {
    margin-bottom: -4rem !important;
  }
  .md\\:-mb-8 {
    margin-bottom: -5rem !important;
  }
  .md\\:mb-auto {
    margin-bottom: auto !important;
  }
  .md\\:mx-0 {
    margin-left: 0rem !important;
    margin-right: 0rem !important;
  }
  .md\\:mx-1 {
    margin-left: 0.25rem !important;
    margin-right: 0.25rem !important;
  }
  .md\\:mx-2 {
    margin-left: 0.5rem !important;
    margin-right: 0.5rem !important;
  }
  .md\\:mx-3 {
    margin-left: 1rem !important;
    margin-right: 1rem !important;
  }
  .md\\:mx-4 {
    margin-left: 1.5rem !important;
    margin-right: 1.5rem !important;
  }
  .md\\:mx-5 {
    margin-left: 2rem !important;
    margin-right: 2rem !important;
  }
  .md\\:mx-6 {
    margin-left: 3rem !important;
    margin-right: 3rem !important;
  }
  .md\\:mx-7 {
    margin-left: 4rem !important;
    margin-right: 4rem !important;
  }
  .md\\:mx-8 {
    margin-left: 5rem !important;
    margin-right: 5rem !important;
  }
  .md\\:-mx-1 {
    margin-left: -0.25rem !important;
    margin-right: -0.25rem !important;
  }
  .md\\:-mx-2 {
    margin-left: -0.5rem !important;
    margin-right: -0.5rem !important;
  }
  .md\\:-mx-3 {
    margin-left: -1rem !important;
    margin-right: -1rem !important;
  }
  .md\\:-mx-4 {
    margin-left: -1.5rem !important;
    margin-right: -1.5rem !important;
  }
  .md\\:-mx-5 {
    margin-left: -2rem !important;
    margin-right: -2rem !important;
  }
  .md\\:-mx-6 {
    margin-left: -3rem !important;
    margin-right: -3rem !important;
  }
  .md\\:-mx-7 {
    margin-left: -4rem !important;
    margin-right: -4rem !important;
  }
  .md\\:-mx-8 {
    margin-left: -5rem !important;
    margin-right: -5rem !important;
  }
  .md\\:mx-auto {
    margin-left: auto !important;
    margin-right: auto !important;
  }
  .md\\:my-0 {
    margin-top: 0rem !important;
    margin-bottom: 0rem !important;
  }
  .md\\:my-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .md\\:my-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .md\\:my-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .md\\:my-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .md\\:my-5 {
    margin-top: 2rem !important;
    margin-bottom: 2rem !important;
  }
  .md\\:my-6 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .md\\:my-7 {
    margin-top: 4rem !important;
    margin-bottom: 4rem !important;
  }
  .md\\:my-8 {
    margin-top: 5rem !important;
    margin-bottom: 5rem !important;
  }
  .md\\:-my-1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }
  .md\\:-my-2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }
  .md\\:-my-3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }
  .md\\:-my-4 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }
  .md\\:-my-5 {
    margin-top: -2rem !important;
    margin-bottom: -2rem !important;
  }
  .md\\:-my-6 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }
  .md\\:-my-7 {
    margin-top: -4rem !important;
    margin-bottom: -4rem !important;
  }
  .md\\:-my-8 {
    margin-top: -5rem !important;
    margin-bottom: -5rem !important;
  }
  .md\\:my-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
}
@media screen and (min-width: 992px) {
  .lg\\:m-0 {
    margin: 0rem !important;
  }
  .lg\\:m-1 {
    margin: 0.25rem !important;
  }
  .lg\\:m-2 {
    margin: 0.5rem !important;
  }
  .lg\\:m-3 {
    margin: 1rem !important;
  }
  .lg\\:m-4 {
    margin: 1.5rem !important;
  }
  .lg\\:m-5 {
    margin: 2rem !important;
  }
  .lg\\:m-6 {
    margin: 3rem !important;
  }
  .lg\\:m-7 {
    margin: 4rem !important;
  }
  .lg\\:m-8 {
    margin: 5rem !important;
  }
  .lg\\:-m-1 {
    margin: -0.25rem !important;
  }
  .lg\\:-m-2 {
    margin: -0.5rem !important;
  }
  .lg\\:-m-3 {
    margin: -1rem !important;
  }
  .lg\\:-m-4 {
    margin: -1.5rem !important;
  }
  .lg\\:-m-5 {
    margin: -2rem !important;
  }
  .lg\\:-m-6 {
    margin: -3rem !important;
  }
  .lg\\:-m-7 {
    margin: -4rem !important;
  }
  .lg\\:-m-8 {
    margin: -5rem !important;
  }
  .lg\\:m-auto {
    margin: auto !important;
  }
  .lg\\:mt-0 {
    margin-top: 0rem !important;
  }
  .lg\\:mt-1 {
    margin-top: 0.25rem !important;
  }
  .lg\\:mt-2 {
    margin-top: 0.5rem !important;
  }
  .lg\\:mt-3 {
    margin-top: 1rem !important;
  }
  .lg\\:mt-4 {
    margin-top: 1.5rem !important;
  }
  .lg\\:mt-5 {
    margin-top: 2rem !important;
  }
  .lg\\:mt-6 {
    margin-top: 3rem !important;
  }
  .lg\\:mt-7 {
    margin-top: 4rem !important;
  }
  .lg\\:mt-8 {
    margin-top: 5rem !important;
  }
  .lg\\:-mt-1 {
    margin-top: -0.25rem !important;
  }
  .lg\\:-mt-2 {
    margin-top: -0.5rem !important;
  }
  .lg\\:-mt-3 {
    margin-top: -1rem !important;
  }
  .lg\\:-mt-4 {
    margin-top: -1.5rem !important;
  }
  .lg\\:-mt-5 {
    margin-top: -2rem !important;
  }
  .lg\\:-mt-6 {
    margin-top: -3rem !important;
  }
  .lg\\:-mt-7 {
    margin-top: -4rem !important;
  }
  .lg\\:-mt-8 {
    margin-top: -5rem !important;
  }
  .lg\\:mt-auto {
    margin-top: auto !important;
  }
  .lg\\:mr-0 {
    margin-right: 0rem !important;
  }
  .lg\\:mr-1 {
    margin-right: 0.25rem !important;
  }
  .lg\\:mr-2 {
    margin-right: 0.5rem !important;
  }
  .lg\\:mr-3 {
    margin-right: 1rem !important;
  }
  .lg\\:mr-4 {
    margin-right: 1.5rem !important;
  }
  .lg\\:mr-5 {
    margin-right: 2rem !important;
  }
  .lg\\:mr-6 {
    margin-right: 3rem !important;
  }
  .lg\\:mr-7 {
    margin-right: 4rem !important;
  }
  .lg\\:mr-8 {
    margin-right: 5rem !important;
  }
  .lg\\:-mr-1 {
    margin-right: -0.25rem !important;
  }
  .lg\\:-mr-2 {
    margin-right: -0.5rem !important;
  }
  .lg\\:-mr-3 {
    margin-right: -1rem !important;
  }
  .lg\\:-mr-4 {
    margin-right: -1.5rem !important;
  }
  .lg\\:-mr-5 {
    margin-right: -2rem !important;
  }
  .lg\\:-mr-6 {
    margin-right: -3rem !important;
  }
  .lg\\:-mr-7 {
    margin-right: -4rem !important;
  }
  .lg\\:-mr-8 {
    margin-right: -5rem !important;
  }
  .lg\\:mr-auto {
    margin-right: auto !important;
  }
  .lg\\:ml-0 {
    margin-left: 0rem !important;
  }
  .lg\\:ml-1 {
    margin-left: 0.25rem !important;
  }
  .lg\\:ml-2 {
    margin-left: 0.5rem !important;
  }
  .lg\\:ml-3 {
    margin-left: 1rem !important;
  }
  .lg\\:ml-4 {
    margin-left: 1.5rem !important;
  }
  .lg\\:ml-5 {
    margin-left: 2rem !important;
  }
  .lg\\:ml-6 {
    margin-left: 3rem !important;
  }
  .lg\\:ml-7 {
    margin-left: 4rem !important;
  }
  .lg\\:ml-8 {
    margin-left: 5rem !important;
  }
  .lg\\:-ml-1 {
    margin-left: -0.25rem !important;
  }
  .lg\\:-ml-2 {
    margin-left: -0.5rem !important;
  }
  .lg\\:-ml-3 {
    margin-left: -1rem !important;
  }
  .lg\\:-ml-4 {
    margin-left: -1.5rem !important;
  }
  .lg\\:-ml-5 {
    margin-left: -2rem !important;
  }
  .lg\\:-ml-6 {
    margin-left: -3rem !important;
  }
  .lg\\:-ml-7 {
    margin-left: -4rem !important;
  }
  .lg\\:-ml-8 {
    margin-left: -5rem !important;
  }
  .lg\\:ml-auto {
    margin-left: auto !important;
  }
  .lg\\:mb-0 {
    margin-bottom: 0rem !important;
  }
  .lg\\:mb-1 {
    margin-bottom: 0.25rem !important;
  }
  .lg\\:mb-2 {
    margin-bottom: 0.5rem !important;
  }
  .lg\\:mb-3 {
    margin-bottom: 1rem !important;
  }
  .lg\\:mb-4 {
    margin-bottom: 1.5rem !important;
  }
  .lg\\:mb-5 {
    margin-bottom: 2rem !important;
  }
  .lg\\:mb-6 {
    margin-bottom: 3rem !important;
  }
  .lg\\:mb-7 {
    margin-bottom: 4rem !important;
  }
  .lg\\:mb-8 {
    margin-bottom: 5rem !important;
  }
  .lg\\:-mb-1 {
    margin-bottom: -0.25rem !important;
  }
  .lg\\:-mb-2 {
    margin-bottom: -0.5rem !important;
  }
  .lg\\:-mb-3 {
    margin-bottom: -1rem !important;
  }
  .lg\\:-mb-4 {
    margin-bottom: -1.5rem !important;
  }
  .lg\\:-mb-5 {
    margin-bottom: -2rem !important;
  }
  .lg\\:-mb-6 {
    margin-bottom: -3rem !important;
  }
  .lg\\:-mb-7 {
    margin-bottom: -4rem !important;
  }
  .lg\\:-mb-8 {
    margin-bottom: -5rem !important;
  }
  .lg\\:mb-auto {
    margin-bottom: auto !important;
  }
  .lg\\:mx-0 {
    margin-left: 0rem !important;
    margin-right: 0rem !important;
  }
  .lg\\:mx-1 {
    margin-left: 0.25rem !important;
    margin-right: 0.25rem !important;
  }
  .lg\\:mx-2 {
    margin-left: 0.5rem !important;
    margin-right: 0.5rem !important;
  }
  .lg\\:mx-3 {
    margin-left: 1rem !important;
    margin-right: 1rem !important;
  }
  .lg\\:mx-4 {
    margin-left: 1.5rem !important;
    margin-right: 1.5rem !important;
  }
  .lg\\:mx-5 {
    margin-left: 2rem !important;
    margin-right: 2rem !important;
  }
  .lg\\:mx-6 {
    margin-left: 3rem !important;
    margin-right: 3rem !important;
  }
  .lg\\:mx-7 {
    margin-left: 4rem !important;
    margin-right: 4rem !important;
  }
  .lg\\:mx-8 {
    margin-left: 5rem !important;
    margin-right: 5rem !important;
  }
  .lg\\:-mx-1 {
    margin-left: -0.25rem !important;
    margin-right: -0.25rem !important;
  }
  .lg\\:-mx-2 {
    margin-left: -0.5rem !important;
    margin-right: -0.5rem !important;
  }
  .lg\\:-mx-3 {
    margin-left: -1rem !important;
    margin-right: -1rem !important;
  }
  .lg\\:-mx-4 {
    margin-left: -1.5rem !important;
    margin-right: -1.5rem !important;
  }
  .lg\\:-mx-5 {
    margin-left: -2rem !important;
    margin-right: -2rem !important;
  }
  .lg\\:-mx-6 {
    margin-left: -3rem !important;
    margin-right: -3rem !important;
  }
  .lg\\:-mx-7 {
    margin-left: -4rem !important;
    margin-right: -4rem !important;
  }
  .lg\\:-mx-8 {
    margin-left: -5rem !important;
    margin-right: -5rem !important;
  }
  .lg\\:mx-auto {
    margin-left: auto !important;
    margin-right: auto !important;
  }
  .lg\\:my-0 {
    margin-top: 0rem !important;
    margin-bottom: 0rem !important;
  }
  .lg\\:my-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .lg\\:my-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .lg\\:my-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .lg\\:my-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .lg\\:my-5 {
    margin-top: 2rem !important;
    margin-bottom: 2rem !important;
  }
  .lg\\:my-6 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .lg\\:my-7 {
    margin-top: 4rem !important;
    margin-bottom: 4rem !important;
  }
  .lg\\:my-8 {
    margin-top: 5rem !important;
    margin-bottom: 5rem !important;
  }
  .lg\\:-my-1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }
  .lg\\:-my-2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }
  .lg\\:-my-3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }
  .lg\\:-my-4 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }
  .lg\\:-my-5 {
    margin-top: -2rem !important;
    margin-bottom: -2rem !important;
  }
  .lg\\:-my-6 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }
  .lg\\:-my-7 {
    margin-top: -4rem !important;
    margin-bottom: -4rem !important;
  }
  .lg\\:-my-8 {
    margin-top: -5rem !important;
    margin-bottom: -5rem !important;
  }
  .lg\\:my-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
}
@media screen and (min-width: 1200px) {
  .xl\\:m-0 {
    margin: 0rem !important;
  }
  .xl\\:m-1 {
    margin: 0.25rem !important;
  }
  .xl\\:m-2 {
    margin: 0.5rem !important;
  }
  .xl\\:m-3 {
    margin: 1rem !important;
  }
  .xl\\:m-4 {
    margin: 1.5rem !important;
  }
  .xl\\:m-5 {
    margin: 2rem !important;
  }
  .xl\\:m-6 {
    margin: 3rem !important;
  }
  .xl\\:m-7 {
    margin: 4rem !important;
  }
  .xl\\:m-8 {
    margin: 5rem !important;
  }
  .xl\\:-m-1 {
    margin: -0.25rem !important;
  }
  .xl\\:-m-2 {
    margin: -0.5rem !important;
  }
  .xl\\:-m-3 {
    margin: -1rem !important;
  }
  .xl\\:-m-4 {
    margin: -1.5rem !important;
  }
  .xl\\:-m-5 {
    margin: -2rem !important;
  }
  .xl\\:-m-6 {
    margin: -3rem !important;
  }
  .xl\\:-m-7 {
    margin: -4rem !important;
  }
  .xl\\:-m-8 {
    margin: -5rem !important;
  }
  .xl\\:m-auto {
    margin: auto !important;
  }
  .xl\\:mt-0 {
    margin-top: 0rem !important;
  }
  .xl\\:mt-1 {
    margin-top: 0.25rem !important;
  }
  .xl\\:mt-2 {
    margin-top: 0.5rem !important;
  }
  .xl\\:mt-3 {
    margin-top: 1rem !important;
  }
  .xl\\:mt-4 {
    margin-top: 1.5rem !important;
  }
  .xl\\:mt-5 {
    margin-top: 2rem !important;
  }
  .xl\\:mt-6 {
    margin-top: 3rem !important;
  }
  .xl\\:mt-7 {
    margin-top: 4rem !important;
  }
  .xl\\:mt-8 {
    margin-top: 5rem !important;
  }
  .xl\\:-mt-1 {
    margin-top: -0.25rem !important;
  }
  .xl\\:-mt-2 {
    margin-top: -0.5rem !important;
  }
  .xl\\:-mt-3 {
    margin-top: -1rem !important;
  }
  .xl\\:-mt-4 {
    margin-top: -1.5rem !important;
  }
  .xl\\:-mt-5 {
    margin-top: -2rem !important;
  }
  .xl\\:-mt-6 {
    margin-top: -3rem !important;
  }
  .xl\\:-mt-7 {
    margin-top: -4rem !important;
  }
  .xl\\:-mt-8 {
    margin-top: -5rem !important;
  }
  .xl\\:mt-auto {
    margin-top: auto !important;
  }
  .xl\\:mr-0 {
    margin-right: 0rem !important;
  }
  .xl\\:mr-1 {
    margin-right: 0.25rem !important;
  }
  .xl\\:mr-2 {
    margin-right: 0.5rem !important;
  }
  .xl\\:mr-3 {
    margin-right: 1rem !important;
  }
  .xl\\:mr-4 {
    margin-right: 1.5rem !important;
  }
  .xl\\:mr-5 {
    margin-right: 2rem !important;
  }
  .xl\\:mr-6 {
    margin-right: 3rem !important;
  }
  .xl\\:mr-7 {
    margin-right: 4rem !important;
  }
  .xl\\:mr-8 {
    margin-right: 5rem !important;
  }
  .xl\\:-mr-1 {
    margin-right: -0.25rem !important;
  }
  .xl\\:-mr-2 {
    margin-right: -0.5rem !important;
  }
  .xl\\:-mr-3 {
    margin-right: -1rem !important;
  }
  .xl\\:-mr-4 {
    margin-right: -1.5rem !important;
  }
  .xl\\:-mr-5 {
    margin-right: -2rem !important;
  }
  .xl\\:-mr-6 {
    margin-right: -3rem !important;
  }
  .xl\\:-mr-7 {
    margin-right: -4rem !important;
  }
  .xl\\:-mr-8 {
    margin-right: -5rem !important;
  }
  .xl\\:mr-auto {
    margin-right: auto !important;
  }
  .xl\\:ml-0 {
    margin-left: 0rem !important;
  }
  .xl\\:ml-1 {
    margin-left: 0.25rem !important;
  }
  .xl\\:ml-2 {
    margin-left: 0.5rem !important;
  }
  .xl\\:ml-3 {
    margin-left: 1rem !important;
  }
  .xl\\:ml-4 {
    margin-left: 1.5rem !important;
  }
  .xl\\:ml-5 {
    margin-left: 2rem !important;
  }
  .xl\\:ml-6 {
    margin-left: 3rem !important;
  }
  .xl\\:ml-7 {
    margin-left: 4rem !important;
  }
  .xl\\:ml-8 {
    margin-left: 5rem !important;
  }
  .xl\\:-ml-1 {
    margin-left: -0.25rem !important;
  }
  .xl\\:-ml-2 {
    margin-left: -0.5rem !important;
  }
  .xl\\:-ml-3 {
    margin-left: -1rem !important;
  }
  .xl\\:-ml-4 {
    margin-left: -1.5rem !important;
  }
  .xl\\:-ml-5 {
    margin-left: -2rem !important;
  }
  .xl\\:-ml-6 {
    margin-left: -3rem !important;
  }
  .xl\\:-ml-7 {
    margin-left: -4rem !important;
  }
  .xl\\:-ml-8 {
    margin-left: -5rem !important;
  }
  .xl\\:ml-auto {
    margin-left: auto !important;
  }
  .xl\\:mb-0 {
    margin-bottom: 0rem !important;
  }
  .xl\\:mb-1 {
    margin-bottom: 0.25rem !important;
  }
  .xl\\:mb-2 {
    margin-bottom: 0.5rem !important;
  }
  .xl\\:mb-3 {
    margin-bottom: 1rem !important;
  }
  .xl\\:mb-4 {
    margin-bottom: 1.5rem !important;
  }
  .xl\\:mb-5 {
    margin-bottom: 2rem !important;
  }
  .xl\\:mb-6 {
    margin-bottom: 3rem !important;
  }
  .xl\\:mb-7 {
    margin-bottom: 4rem !important;
  }
  .xl\\:mb-8 {
    margin-bottom: 5rem !important;
  }
  .xl\\:-mb-1 {
    margin-bottom: -0.25rem !important;
  }
  .xl\\:-mb-2 {
    margin-bottom: -0.5rem !important;
  }
  .xl\\:-mb-3 {
    margin-bottom: -1rem !important;
  }
  .xl\\:-mb-4 {
    margin-bottom: -1.5rem !important;
  }
  .xl\\:-mb-5 {
    margin-bottom: -2rem !important;
  }
  .xl\\:-mb-6 {
    margin-bottom: -3rem !important;
  }
  .xl\\:-mb-7 {
    margin-bottom: -4rem !important;
  }
  .xl\\:-mb-8 {
    margin-bottom: -5rem !important;
  }
  .xl\\:mb-auto {
    margin-bottom: auto !important;
  }
  .xl\\:mx-0 {
    margin-left: 0rem !important;
    margin-right: 0rem !important;
  }
  .xl\\:mx-1 {
    margin-left: 0.25rem !important;
    margin-right: 0.25rem !important;
  }
  .xl\\:mx-2 {
    margin-left: 0.5rem !important;
    margin-right: 0.5rem !important;
  }
  .xl\\:mx-3 {
    margin-left: 1rem !important;
    margin-right: 1rem !important;
  }
  .xl\\:mx-4 {
    margin-left: 1.5rem !important;
    margin-right: 1.5rem !important;
  }
  .xl\\:mx-5 {
    margin-left: 2rem !important;
    margin-right: 2rem !important;
  }
  .xl\\:mx-6 {
    margin-left: 3rem !important;
    margin-right: 3rem !important;
  }
  .xl\\:mx-7 {
    margin-left: 4rem !important;
    margin-right: 4rem !important;
  }
  .xl\\:mx-8 {
    margin-left: 5rem !important;
    margin-right: 5rem !important;
  }
  .xl\\:-mx-1 {
    margin-left: -0.25rem !important;
    margin-right: -0.25rem !important;
  }
  .xl\\:-mx-2 {
    margin-left: -0.5rem !important;
    margin-right: -0.5rem !important;
  }
  .xl\\:-mx-3 {
    margin-left: -1rem !important;
    margin-right: -1rem !important;
  }
  .xl\\:-mx-4 {
    margin-left: -1.5rem !important;
    margin-right: -1.5rem !important;
  }
  .xl\\:-mx-5 {
    margin-left: -2rem !important;
    margin-right: -2rem !important;
  }
  .xl\\:-mx-6 {
    margin-left: -3rem !important;
    margin-right: -3rem !important;
  }
  .xl\\:-mx-7 {
    margin-left: -4rem !important;
    margin-right: -4rem !important;
  }
  .xl\\:-mx-8 {
    margin-left: -5rem !important;
    margin-right: -5rem !important;
  }
  .xl\\:mx-auto {
    margin-left: auto !important;
    margin-right: auto !important;
  }
  .xl\\:my-0 {
    margin-top: 0rem !important;
    margin-bottom: 0rem !important;
  }
  .xl\\:my-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .xl\\:my-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .xl\\:my-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .xl\\:my-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .xl\\:my-5 {
    margin-top: 2rem !important;
    margin-bottom: 2rem !important;
  }
  .xl\\:my-6 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .xl\\:my-7 {
    margin-top: 4rem !important;
    margin-bottom: 4rem !important;
  }
  .xl\\:my-8 {
    margin-top: 5rem !important;
    margin-bottom: 5rem !important;
  }
  .xl\\:-my-1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }
  .xl\\:-my-2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }
  .xl\\:-my-3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }
  .xl\\:-my-4 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }
  .xl\\:-my-5 {
    margin-top: -2rem !important;
    margin-bottom: -2rem !important;
  }
  .xl\\:-my-6 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }
  .xl\\:-my-7 {
    margin-top: -4rem !important;
    margin-bottom: -4rem !important;
  }
  .xl\\:-my-8 {
    margin-top: -5rem !important;
    margin-bottom: -5rem !important;
  }
  .xl\\:my-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/secure/orders/orders.component.scss"],"names":[],"mappings":"AACI;EACI,sBAAA;AAAR;AAEI;EACI,8BAAA;EACA,iCAAA;AAAR;AAEI;EACI,sBAAA;AAAR;AAEI;EACI,gCAAA;EACA,uBAAA;AAAR;AAEI;EACI,8CAAA;AAAR;AAEI;EACI,6BAAA;AAAR;AAEI;EACI,8BAAA;AAAR;AAEI;EACI,kCAAA;AAAR;AAEI;EACI,wBAAA;AAAR;AAEI;EACI,sBAAA;AAAR;AAEI;EACI,6CAAA;AAAR;AAEI;EACI,6CAAA;AAAR;AAEI;EACI,4CAAA;AAAR;AAEI;EACI,4CAAA;AAAR;AAEI;EACI,8CAAA;AAAR;AAEI;EACI,8CAAA;AAAR;AAEI;EACI,8CAAA;AAAR;AAEI;EACI,8CAAA;AAAR;AAEI;EACI,2CAAA;AAAR;AAEI;EACI,2CAAA;AAAR;AAEI;EACI,gBAAA;EACA,kBAAA;AAAR;AAEI;EACI,sCAAA;AAAR;AAEI;EACI,qBAAA;EACA,iBAAA;AAAR;AAEI;EACI,6CAAA;AAAR;AAEI;EACI,0BAAA;AAAR;AAEI;EACI,2BAAA;AAAR;AAEI;EACI,cAAA;EACA,kBAAA;EACA,oCAAA;EACA,mBAAA;EACA,mBAAA;AAAR;AAEI;EACI,2BAAA;AAAR;AAEI;EACI,qCAAA;AAAR;AAEI;EACI,oCAAA;EACA,4BAAA;AAAR;AAEI;EACI,0BAAA;AAAR;AAEI;EACI,uBAAA;AAAR;AAEI;EACI,6BAAA;AAAR;AAEI;EACI,4BAAA;EACA,mBAAA;AAAR;AAEI;EACI,8BAAA;AAAR;AAEI;EACI,2BAAA;EACA,8BAAA;AAAR;AAEI;EACI,uBAAA;AAAR;AAEI;EACI,sBAAA;AAAR;AAEI;EACI,mBAAA;AAAR;AAEI;EACI,yBAAA;AAAR;AAEI;EACI,oCAAA;AAAR;AAEI;EACI,gBAAA;AAAR;AAEI;EACI,2BAAA;AAAR;AAEI;EACI,6BAAA;AAAR;AAEI;EACI,8BAAA;AAAR;AAEI;EACI,2BAAA;AAAR;AAEI;EACI,4BAAA;AAAR;AAEI;EACI,wBAAA;AAAR;AAEI;EACI,sCAAA;EACA,uCAAA;AAAR;AAEI;EACI,+CAAA;AAAR;AAEI;EACI,cAAA;EACA,aAAA;EACA,WAAA;AAAR;AAEI;EACI,6BAAA;AAAR;AAEI;EACI,2BAAA;AAAR;AAEI;EACI,8BAAA;AAAR;AAEI;EACI,gDAAA;AAAR;AAEI;EACI,eAAA;EACA,cAAA;EACA,aAAA;AAAR;AAEI;EACI,aAAA;EACA,eAAA;EACA,iBAAA;AAAR;AAEI;EACI,eAAA;EACA,cAAA;EACA,aAAA;AAAR;AAEI;EACI,sBAAA;AAAR;AAEI;EACI,UAAA;AAAR;AAEI;EACI,6BAAA;EACA,gCAAA;AAAR;AAEI;EACI,8BAAA;AAAR;AAEI;EACI,yCAAA;AAAR;AAEI;EACI,sCAAA;AAAR;AAEI;EACI,sCAAA;AAAR;AAEI;EACI,2CAAA;EACA,iDAAA;AAAR;AAEI;EACI,2CAAA;EACA,iDAAA;AAAR;AAEI;EACI,sCAAA;EACA,sDAAA;AAAR;AAEI;EACI,sCAAA;EACA,sDAAA;AAAR;AAEI;EACI,iCAAA;AAAR;AAEI;EACI,iCAAA;AAAR;AAEI;EACI,6CAAA;AAAR;AAEI;EACI,6CAAA;AAAR;AAEI;EACI,sBAAA;AAAR;AAEI;EACI,sBAAA;AAAR;AAEI;EACI,6BAAA;AAAR;AAEI;EACI,6BAAA;AAAR;AAEI;EACI,mCAAA;AAAR;AAEI;EACI,mCAAA;AAAR;AAEI;EACI,6CAAA;AAAR;AAEI;EACI,6CAAA;AAAR;AAEI;EACI,kDAAA;AAAR;AAEI;EACI,kDAAA;AAAR;AAEI;EACI,mDAAA;AAAR;AAEI;EACI,mDAAA;AAAR;AAEI;EACI,gDAAA;AAAR;AAEI;EACI,gDAAA;AAAR;AAEI;EACI,mDAAA;AAAR;AAEI;EACI,mDAAA;AAAR;AAEI;EACI,iDAAA;AAAR;AAEI;EACI,iDAAA;AAAR;AAEI;EACI,8CAAA;AAAR;AAEI;EACI,8CAAA;AAAR;;AAIA;EACE;IACE,8BAAA;EADF;EAIA;IACE,sCAAA;EAFF;EAKA;IACE,iCAAA;EAHF;EAMA;IACE,yCAAA;EAJF;AACF;AAOA;EACE;IACE,8BAAA;EALF;EAQA;IACE,sCAAA;EANF;EASA;IACE,iCAAA;EAPF;EAUA;IACE,yCAAA;EARF;AACF;AAWA;EACE;IACE,8BAAA;EATF;EAYA;IACE,sCAAA;EAVF;EAaA;IACE,iCAAA;EAXF;EAcA;IACE,yCAAA;EAZF;AACF;AAeA;EACE,mBAAA;AAbF;;AAgBA;EACE,mBAAA;AAbF;;AAgBA;EACE,mBAAA;AAbF;;AAgBA;EACE,mBAAA;AAbF;;AAgBA;EACE,mBAAA;AAbF;;AAgBA;EACE,mBAAA;AAbF;;AAgBA;EACE,mBAAA;AAbF;;AAgBA;EACE;IACE,mBAAA;EAbF;EAgBA;IACE,mBAAA;EAdF;EAiBA;IACE,mBAAA;EAfF;EAkBA;IACE,mBAAA;EAhBF;EAmBA;IACE,mBAAA;EAjBF;EAoBA;IACE,mBAAA;EAlBF;EAqBA;IACE,mBAAA;EAnBF;AACF;AAsBA;EACE;IACE,mBAAA;EApBF;EAuBA;IACE,mBAAA;EArBF;EAwBA;IACE,mBAAA;EAtBF;EAyBA;IACE,mBAAA;EAvBF;EA0BA;IACE,mBAAA;EAxBF;EA2BA;IACE,mBAAA;EAzBF;EA4BA;IACE,mBAAA;EA1BF;AACF;AA6BA;EACE;IACE,mBAAA;EA3BF;EA8BA;IACE,mBAAA;EA5BF;EA+BA;IACE,mBAAA;EA7BF;EAgCA;IACE,mBAAA;EA9BF;EAiCA;IACE,mBAAA;EA/BF;EAkCA;IACE,mBAAA;EAhCF;EAmCA;IACE,mBAAA;EAjCF;AACF;AAoCA;EACE;IACE,mBAAA;EAlCF;EAqCA;IACE,mBAAA;EAnCF;EAsCA;IACE,mBAAA;EApCF;EAuCA;IACE,mBAAA;EArCF;EAwCA;IACE,mBAAA;EAtCF;EAyCA;IACE,mBAAA;EAvCF;EA0CA;IACE,mBAAA;EAxCF;AACF;AA2CA;EACE,uBAAA;AAzCF;;AA4CA;EACE,yBAAA;AAzCF;;AA4CA;EACE,yBAAA;AAzCF;;AA4CA;EACE,qBAAA;AAzCF;;AA4CA;EACE;IACE,uBAAA;EAzCF;EA4CA;IACE,yBAAA;EA1CF;EA6CA;IACE,yBAAA;EA3CF;EA8CA;IACE,qBAAA;EA5CF;AACF;AA+CA;EACE;IACE,uBAAA;EA7CF;EAgDA;IACE,yBAAA;EA9CF;EAiDA;IACE,yBAAA;EA/CF;EAkDA;IACE,qBAAA;EAhDF;AACF;AAmDA;EACE;IACE,uBAAA;EAjDF;EAoDA;IACE,yBAAA;EAlDF;EAqDA;IACE,yBAAA;EAnDF;EAsDA;IACE,qBAAA;EApDF;AACF;AAuDA;EACE;IACE,uBAAA;EArDF;EAwDA;IACE,yBAAA;EAtDF;EAyDA;IACE,yBAAA;EAvDF;EA0DA;IACE,qBAAA;EAxDF;AACF;AA2DA;EACE,uBAAA;AAzDF;;AA4DA;EACE,uBAAA;AAzDF;;AA4DA;EACE;IACE,uBAAA;EAzDF;EA4DA;IACE,uBAAA;EA1DF;AACF;AA6DA;EACE;IACE,uBAAA;EA3DF;EA8DA;IACE,uBAAA;EA5DF;AACF;AA+DA;EACE;IACE,uBAAA;EA7DF;EAgEA;IACE,uBAAA;EA9DF;AACF;AAiEA;EACE;IACE,uBAAA;EA/DF;EAkEA;IACE,uBAAA;EAhEF;AACF;AAmEA;EACE,yBAAA;AAjEF;;AAoEA;EACE,yBAAA;AAjEF;;AAoEA;EACE;IACE,yBAAA;EAjEF;EAoEA;IACE,yBAAA;EAlEF;AACF;AAqEA;EACE;IACE,yBAAA;EAnEF;EAsEA;IACE,yBAAA;EApEF;AACF;AAuEA;EACE;IACE,yBAAA;EArEF;EAwEA;IACE,yBAAA;EAtEF;AACF;AAyEA;EACE;IACE,yBAAA;EAvEF;EA0EA;IACE,yBAAA;EAxEF;AACF;AA2EA;EACE,oBAAA;AAzEF;;AA4EA;EACE,uBAAA;AAzEF;;AA4EA;EACE,sBAAA;AAzEF;;AA4EA;EACE,oBAAA;AAzEF;;AA4EA;EACE,sBAAA;AAzEF;;AA4EA;EACE,oBAAA;AAzEF;;AA4EA;EACE,oBAAA;AAzEF;;AA4EA;EACE,oBAAA;AAzEF;;AA4EA;EACE,oBAAA;AAzEF;;AA4EA;EACE,wBAAA;AAzEF;;AA4EA;EACE,2BAAA;AAzEF;;AA4EA;EACE,0BAAA;AAzEF;;AA4EA;EACE,wBAAA;AAzEF;;AA4EA;EACE,0BAAA;AAzEF;;AA4EA;EACE,wBAAA;AAzEF;;AA4EA;EACE,wBAAA;AAzEF;;AA4EA;EACE,wBAAA;AAzEF;;AA4EA;EACE,wBAAA;AAzEF;;AA4EA;EACE,2BAAA;AAzEF;;AA4EA;EACE,8BAAA;AAzEF;;AA4EA;EACE,6BAAA;AAzEF;;AA4EA;EACE,2BAAA;AAzEF;;AA4EA;EACE,6BAAA;AAzEF;;AA4EA;EACE,2BAAA;AAzEF;;AA4EA;EACE,2BAAA;AAzEF;;AA4EA;EACE,2BAAA;AAzEF;;AA4EA;EACE,2BAAA;AAzEF;;AA4EA;EACE;IACE,oBAAA;EAzEF;EA4EA;IACE,uBAAA;EA1EF;EA6EA;IACE,sBAAA;EA3EF;EA8EA;IACE,oBAAA;EA5EF;EA+EA;IACE,sBAAA;EA7EF;EAgFA;IACE,oBAAA;EA9EF;EAiFA;IACE,oBAAA;EA/EF;EAkFA;IACE,oBAAA;EAhFF;EAmFA;IACE,oBAAA;EAjFF;EAoFA;IACE,wBAAA;EAlFF;EAqFA;IACE,2BAAA;EAnFF;EAsFA;IACE,0BAAA;EApFF;EAuFA;IACE,wBAAA;EArFF;EAwFA;IACE,0BAAA;EAtFF;EAyFA;IACE,wBAAA;EAvFF;EA0FA;IACE,wBAAA;EAxFF;EA2FA;IACE,wBAAA;EAzFF;EA4FA;IACE,wBAAA;EA1FF;EA6FA;IACE,2BAAA;EA3FF;EA8FA;IACE,8BAAA;EA5FF;EA+FA;IACE,6BAAA;EA7FF;EAgGA;IACE,2BAAA;EA9FF;EAiGA;IACE,6BAAA;EA/FF;EAkGA;IACE,2BAAA;EAhGF;EAmGA;IACE,2BAAA;EAjGF;EAoGA;IACE,2BAAA;EAlGF;EAqGA;IACE,2BAAA;EAnGF;AACF;AAsGA;EACE;IACE,oBAAA;EApGF;EAuGA;IACE,uBAAA;EArGF;EAwGA;IACE,sBAAA;EAtGF;EAyGA;IACE,oBAAA;EAvGF;EA0GA;IACE,sBAAA;EAxGF;EA2GA;IACE,oBAAA;EAzGF;EA4GA;IACE,oBAAA;EA1GF;EA6GA;IACE,oBAAA;EA3GF;EA8GA;IACE,oBAAA;EA5GF;EA+GA;IACE,wBAAA;EA7GF;EAgHA;IACE,2BAAA;EA9GF;EAiHA;IACE,0BAAA;EA/GF;EAkHA;IACE,wBAAA;EAhHF;EAmHA;IACE,0BAAA;EAjHF;EAoHA;IACE,wBAAA;EAlHF;EAqHA;IACE,wBAAA;EAnHF;EAsHA;IACE,wBAAA;EApHF;EAuHA;IACE,wBAAA;EArHF;EAwHA;IACE,2BAAA;EAtHF;EAyHA;IACE,8BAAA;EAvHF;EA0HA;IACE,6BAAA;EAxHF;EA2HA;IACE,2BAAA;EAzHF;EA4HA;IACE,6BAAA;EA1HF;EA6HA;IACE,2BAAA;EA3HF;EA8HA;IACE,2BAAA;EA5HF;EA+HA;IACE,2BAAA;EA7HF;EAgIA;IACE,2BAAA;EA9HF;AACF;AAiIA;EACE;IACE,oBAAA;EA/HF;EAkIA;IACE,uBAAA;EAhIF;EAmIA;IACE,sBAAA;EAjIF;EAoIA;IACE,oBAAA;EAlIF;EAqIA;IACE,sBAAA;EAnIF;EAsIA;IACE,oBAAA;EApIF;EAuIA;IACE,oBAAA;EArIF;EAwIA;IACE,oBAAA;EAtIF;EAyIA;IACE,oBAAA;EAvIF;EA0IA;IACE,wBAAA;EAxIF;EA2IA;IACE,2BAAA;EAzIF;EA4IA;IACE,0BAAA;EA1IF;EA6IA;IACE,wBAAA;EA3IF;EA8IA;IACE,0BAAA;EA5IF;EA+IA;IACE,wBAAA;EA7IF;EAgJA;IACE,wBAAA;EA9IF;EAiJA;IACE,wBAAA;EA/IF;EAkJA;IACE,wBAAA;EAhJF;EAmJA;IACE,2BAAA;EAjJF;EAoJA;IACE,8BAAA;EAlJF;EAqJA;IACE,6BAAA;EAnJF;EAsJA;IACE,2BAAA;EApJF;EAuJA;IACE,6BAAA;EArJF;EAwJA;IACE,2BAAA;EAtJF;EAyJA;IACE,2BAAA;EAvJF;EA0JA;IACE,2BAAA;EAxJF;EA2JA;IACE,2BAAA;EAzJF;AACF;AA4JA;EACE;IACE,oBAAA;EA1JF;EA6JA;IACE,uBAAA;EA3JF;EA8JA;IACE,sBAAA;EA5JF;EA+JA;IACE,oBAAA;EA7JF;EAgKA;IACE,sBAAA;EA9JF;EAiKA;IACE,oBAAA;EA/JF;EAkKA;IACE,oBAAA;EAhKF;EAmKA;IACE,oBAAA;EAjKF;EAoKA;IACE,oBAAA;EAlKF;EAqKA;IACE,wBAAA;EAnKF;EAsKA;IACE,2BAAA;EApKF;EAuKA;IACE,0BAAA;EArKF;EAwKA;IACE,wBAAA;EAtKF;EAyKA;IACE,0BAAA;EAvKF;EA0KA;IACE,wBAAA;EAxKF;EA2KA;IACE,wBAAA;EAzKF;EA4KA;IACE,wBAAA;EA1KF;EA6KA;IACE,wBAAA;EA3KF;EA8KA;IACE,2BAAA;EA5KF;EA+KA;IACE,8BAAA;EA7KF;EAgLA;IACE,6BAAA;EA9KF;EAiLA;IACE,2BAAA;EA/KF;EAkLA;IACE,6BAAA;EAhLF;EAmLA;IACE,2BAAA;EAjLF;EAoLA;IACE,2BAAA;EAlLF;EAqLA;IACE,2BAAA;EAnLF;EAsLA;IACE,2BAAA;EApLF;AACF;AAuLA;EACE;IACE,6BAAA;EArLF;EAwLA;IACE,8BAAA;EAtLF;EAyLA;IACE,2BAAA;EAvLF;EA0LA;IACE,4BAAA;EAxLF;AACF;AA2LA;EACE;IACE,6BAAA;EAzLF;EA4LA;IACE,8BAAA;EA1LF;EA6LA;IACE,2BAAA;EA3LF;EA8LA;IACE,4BAAA;EA5LF;AACF;AA+LA;EACE;IACE,6BAAA;EA7LF;EAgMA;IACE,8BAAA;EA9LF;EAiMA;IACE,2BAAA;EA/LF;EAkMA;IACE,4BAAA;EAhMF;AACF;AAmMA;EACE;IACE,6BAAA;EAjMF;EAoMA;IACE,8BAAA;EAlMF;EAqMA;IACE,2BAAA;EAnMF;EAsMA;IACE,4BAAA;EApMF;AACF;AAuMA;EACE,iBAAA;EACA,qBAAA;EACA,+BAAA;EACA,kBAAA;EACA,2BAAA;AArMF;AAuME;EACE,qBAAA;AArMJ;;AAwMA;EACE;IACE,iBAAA;IACA,oBAAA;EArMF;AACF;AAuMA;EACE;IACE,gBAAA;EArMF;AACF;AAuMA;EACE;IACE,gBAAA;IACA,sBAAA;EArMF;EAwMA;IACE,gBAAA;IACA,kBAAA;EAtMF;AACF;AAwMA;EACE,gBAAA;EACA,kBAAA;EACA,qBAAA;AAtMF;;AAwMA;EACE;IACE,kBAAA;EArMF;AACF;AAuMA;EACE,mBAAA;AArMF;;AAuMA;EACE;IACE,UAAA;EApMF;AACF;AAsMA;EACE,wBAAA;EACA,qBAAA;EACA,gBAAA;AApMF;;AAsMA;EACE,wBAAA;EACA,qBAAA;EACA,gBAAA;AAnMF;AAqME;EACE;IACE,aAAA;IACA,uBAAA;IAAA,kBAAA;IACA,YAAA;EAnMJ;AACF;AAsME;EACE,aAAA;EACA,uBAAA;EAAA,kBAAA;AApMJ;;AAuMA;EACE,cAAA;AApMF;;AAsMA;EACE;IACE,gBAAA;EAnMF;AACF;AAqMA;EACE,qBAAA;AAnMF;;AAqMA;EACE,yBAAA;AAlMF;;AAoMA;EACE,cAAA;EACA,kBAAA;AAjMF;;AAmMA;EACE,kBAAA;AAhMF;;AAkMA;EACE,wBAAA;EACA,qBAAA;EAKA,gCAAA;AA/LF;;AAiMA;EACE,qBAAA;AA9LF;;AAgMA;EACE;IACE,kBAAA;EA7LF;AACF;AA+LA;EACE,oBAAA;AA7LF;;AA+LA;EACE,gBAAA;EACA,kBAAA;AA5LF;;AA8LA;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,+BAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;AA3LF;;AA6LA;EACE,4BAAA;AA1LF;;AA4LA;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;AAzLF;;AA2LA;EACI,YAAA;EACA,WAAA;EACA,kBAAA;EACA,gCAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,yBAAA;AAxLJ;;AA0LA;EACI,mBAAA;EACA,qCAAA;AAvLJ;;AAyLA;EACI,6CAAA;AAtLJ;AAwLI;EACI,qBAAA;EACA,mBAAA;AAtLR;;AAyLA;EACI;IACI,0BAAA;EAtLN;AACF;AAwLA;EACI,sBAAA;AAtLJ;;AAyLA;EACE,uBAAA;AAtLF;;AAyLA;EACE,0BAAA;AAtLF;;AAyLA;EACE,yBAAA;AAtLF;;AAyLA;EACE,uBAAA;AAtLF;;AAyLA;EACE,yBAAA;AAtLF;;AAyLA;EACE,uBAAA;AAtLF;;AAyLA;EACE,uBAAA;AAtLF;;AAyLA;EACE,uBAAA;AAtLF;;AAyLA;EACE,uBAAA;AAtLF;;AAyLA;EACE,2BAAA;AAtLF;;AAyLA;EACE,0BAAA;AAtLF;;AAyLA;EACE,wBAAA;AAtLF;;AAyLA;EACE,0BAAA;AAtLF;;AAyLA;EACE,wBAAA;AAtLF;;AAyLA;EACE,wBAAA;AAtLF;;AAyLA;EACE,wBAAA;AAtLF;;AAyLA;EACE,wBAAA;AAtLF;;AAyLA;EACE,uBAAA;AAtLF;;AAyLA;EACE,2BAAA;AAtLF;;AAyLA;EACE,8BAAA;AAtLF;;AAyLA;EACE,6BAAA;AAtLF;;AAyLA;EACE,2BAAA;AAtLF;;AAyLA;EACE,6BAAA;AAtLF;;AAyLA;EACE,2BAAA;AAtLF;;AAyLA;EACE,2BAAA;AAtLF;;AAyLA;EACE,2BAAA;AAtLF;;AAyLA;EACE,2BAAA;AAtLF;;AAyLA;EACE,+BAAA;AAtLF;;AAyLA;EACE,8BAAA;AAtLF;;AAyLA;EACE,4BAAA;AAtLF;;AAyLA;EACE,8BAAA;AAtLF;;AAyLA;EACE,4BAAA;AAtLF;;AAyLA;EACE,4BAAA;AAtLF;;AAyLA;EACE,4BAAA;AAtLF;;AAyLA;EACE,4BAAA;AAtLF;;AAyLA;EACE,2BAAA;AAtLF;;AAyLA;EACE,6BAAA;AAtLF;;AAyLA;EACE,gCAAA;AAtLF;;AAyLA;EACE,+BAAA;AAtLF;;AAyLA;EACE,6BAAA;AAtLF;;AAyLA;EACE,+BAAA;AAtLF;;AAyLA;EACE,6BAAA;AAtLF;;AAyLA;EACE,6BAAA;AAtLF;;AAyLA;EACE,6BAAA;AAtLF;;AAyLA;EACE,6BAAA;AAtLF;;AAyLA;EACE,iCAAA;AAtLF;;AAyLA;EACE,gCAAA;AAtLF;;AAyLA;EACE,8BAAA;AAtLF;;AAyLA;EACE,gCAAA;AAtLF;;AAyLA;EACE,8BAAA;AAtLF;;AAyLA;EACE,8BAAA;AAtLF;;AAyLA;EACE,8BAAA;AAtLF;;AAyLA;EACE,8BAAA;AAtLF;;AAyLA;EACE,6BAAA;AAtLF;;AAyLA;EACE,4BAAA;AAtLF;;AAyLA;EACE,+BAAA;AAtLF;;AAyLA;EACE,8BAAA;AAtLF;;AAyLA;EACE,4BAAA;AAtLF;;AAyLA;EACE,8BAAA;AAtLF;;AAyLA;EACE,4BAAA;AAtLF;;AAyLA;EACE,4BAAA;AAtLF;;AAyLA;EACE,4BAAA;AAtLF;;AAyLA;EACE,4BAAA;AAtLF;;AAyLA;EACE,gCAAA;AAtLF;;AAyLA;EACE,+BAAA;AAtLF;;AAyLA;EACE,6BAAA;AAtLF;;AAyLA;EACE,+BAAA;AAtLF;;AAyLA;EACE,6BAAA;AAtLF;;AAyLA;EACE,6BAAA;AAtLF;;AAyLA;EACE,6BAAA;AAtLF;;AAyLA;EACE,6BAAA;AAtLF;;AAyLA;EACE,4BAAA;AAtLF;;AAyLA;EACE,8BAAA;AAtLF;;AAyLA;EACE,iCAAA;AAtLF;;AAyLA;EACE,gCAAA;AAtLF;;AAyLA;EACE,8BAAA;AAtLF;;AAyLA;EACE,gCAAA;AAtLF;;AAyLA;EACE,8BAAA;AAtLF;;AAyLA;EACE,8BAAA;AAtLF;;AAyLA;EACE,8BAAA;AAtLF;;AAyLA;EACE,8BAAA;AAtLF;;AAyLA;EACE,kCAAA;AAtLF;;AAyLA;EACE,iCAAA;AAtLF;;AAyLA;EACE,+BAAA;AAtLF;;AAyLA;EACE,iCAAA;AAtLF;;AAyLA;EACE,+BAAA;AAtLF;;AAyLA;EACE,+BAAA;AAtLF;;AAyLA;EACE,+BAAA;AAtLF;;AAyLA;EACE,+BAAA;AAtLF;;AAyLA;EACE,8BAAA;AAtLF;;AAyLA;EACE,4BAAA;EACA,6BAAA;AAtLF;;AAyLA;EACE,+BAAA;EACA,gCAAA;AAtLF;;AAyLA;EACE,8BAAA;EACA,+BAAA;AAtLF;;AAyLA;EACE,4BAAA;EACA,6BAAA;AAtLF;;AAyLA;EACE,8BAAA;EACA,+BAAA;AAtLF;;AAyLA;EACE,4BAAA;EACA,6BAAA;AAtLF;;AAyLA;EACE,4BAAA;EACA,6BAAA;AAtLF;;AAyLA;EACE,4BAAA;EACA,6BAAA;AAtLF;;AAyLA;EACE,4BAAA;EACA,6BAAA;AAtLF;;AAyLA;EACE,gCAAA;EACA,iCAAA;AAtLF;;AAyLA;EACE,+BAAA;EACA,gCAAA;AAtLF;;AAyLA;EACE,6BAAA;EACA,8BAAA;AAtLF;;AAyLA;EACE,+BAAA;EACA,gCAAA;AAtLF;;AAyLA;EACE,6BAAA;EACA,8BAAA;AAtLF;;AAyLA;EACE,6BAAA;EACA,8BAAA;AAtLF;;AAyLA;EACE,6BAAA;EACA,8BAAA;AAtLF;;AAyLA;EACE,6BAAA;EACA,8BAAA;AAtLF;;AAyLA;EACE,4BAAA;EACA,6BAAA;AAtLF;;AAyLA;EACE,2BAAA;EACA,8BAAA;AAtLF;;AAyLA;EACE,8BAAA;EACA,iCAAA;AAtLF;;AAyLA;EACE,6BAAA;EACA,gCAAA;AAtLF;;AAyLA;EACE,2BAAA;EACA,8BAAA;AAtLF;;AAyLA;EACE,6BAAA;EACA,gCAAA;AAtLF;;AAyLA;EACE,2BAAA;EACA,8BAAA;AAtLF;;AAyLA;EACE,2BAAA;EACA,8BAAA;AAtLF;;AAyLA;EACE,2BAAA;EACA,8BAAA;AAtLF;;AAyLA;EACE,2BAAA;EACA,8BAAA;AAtLF;;AAyLA;EACE,+BAAA;EACA,kCAAA;AAtLF;;AAyLA;EACE,8BAAA;EACA,iCAAA;AAtLF;;AAyLA;EACE,4BAAA;EACA,+BAAA;AAtLF;;AAyLA;EACE,8BAAA;EACA,iCAAA;AAtLF;;AAyLA;EACE,4BAAA;EACA,+BAAA;AAtLF;;AAyLA;EACE,4BAAA;EACA,+BAAA;AAtLF;;AAyLA;EACE,4BAAA;EACA,+BAAA;AAtLF;;AAyLA;EACE,4BAAA;EACA,+BAAA;AAtLF;;AAyLA;EACE,2BAAA;EACA,8BAAA;AAtLF;;AAyLA;EACE;IACE,uBAAA;EAtLF;EAyLA;IACE,0BAAA;EAvLF;EA0LA;IACE,yBAAA;EAxLF;EA2LA;IACE,uBAAA;EAzLF;EA4LA;IACE,yBAAA;EA1LF;EA6LA;IACE,uBAAA;EA3LF;EA8LA;IACE,uBAAA;EA5LF;EA+LA;IACE,uBAAA;EA7LF;EAgMA;IACE,uBAAA;EA9LF;EAiMA;IACE,2BAAA;EA/LF;EAkMA;IACE,0BAAA;EAhMF;EAmMA;IACE,wBAAA;EAjMF;EAoMA;IACE,0BAAA;EAlMF;EAqMA;IACE,wBAAA;EAnMF;EAsMA;IACE,wBAAA;EApMF;EAuMA;IACE,wBAAA;EArMF;EAwMA;IACE,wBAAA;EAtMF;EAyMA;IACE,uBAAA;EAvMF;EA0MA;IACE,2BAAA;EAxMF;EA2MA;IACE,8BAAA;EAzMF;EA4MA;IACE,6BAAA;EA1MF;EA6MA;IACE,2BAAA;EA3MF;EA8MA;IACE,6BAAA;EA5MF;EA+MA;IACE,2BAAA;EA7MF;EAgNA;IACE,2BAAA;EA9MF;EAiNA;IACE,2BAAA;EA/MF;EAkNA;IACE,2BAAA;EAhNF;EAmNA;IACE,+BAAA;EAjNF;EAoNA;IACE,8BAAA;EAlNF;EAqNA;IACE,4BAAA;EAnNF;EAsNA;IACE,8BAAA;EApNF;EAuNA;IACE,4BAAA;EArNF;EAwNA;IACE,4BAAA;EAtNF;EAyNA;IACE,4BAAA;EAvNF;EA0NA;IACE,4BAAA;EAxNF;EA2NA;IACE,2BAAA;EAzNF;EA4NA;IACE,6BAAA;EA1NF;EA6NA;IACE,gCAAA;EA3NF;EA8NA;IACE,+BAAA;EA5NF;EA+NA;IACE,6BAAA;EA7NF;EAgOA;IACE,+BAAA;EA9NF;EAiOA;IACE,6BAAA;EA/NF;EAkOA;IACE,6BAAA;EAhOF;EAmOA;IACE,6BAAA;EAjOF;EAoOA;IACE,6BAAA;EAlOF;EAqOA;IACE,iCAAA;EAnOF;EAsOA;IACE,gCAAA;EApOF;EAuOA;IACE,8BAAA;EArOF;EAwOA;IACE,gCAAA;EAtOF;EAyOA;IACE,8BAAA;EAvOF;EA0OA;IACE,8BAAA;EAxOF;EA2OA;IACE,8BAAA;EAzOF;EA4OA;IACE,8BAAA;EA1OF;EA6OA;IACE,6BAAA;EA3OF;EA8OA;IACE,4BAAA;EA5OF;EA+OA;IACE,+BAAA;EA7OF;EAgPA;IACE,8BAAA;EA9OF;EAiPA;IACE,4BAAA;EA/OF;EAkPA;IACE,8BAAA;EAhPF;EAmPA;IACE,4BAAA;EAjPF;EAoPA;IACE,4BAAA;EAlPF;EAqPA;IACE,4BAAA;EAnPF;EAsPA;IACE,4BAAA;EApPF;EAuPA;IACE,gCAAA;EArPF;EAwPA;IACE,+BAAA;EAtPF;EAyPA;IACE,6BAAA;EAvPF;EA0PA;IACE,+BAAA;EAxPF;EA2PA;IACE,6BAAA;EAzPF;EA4PA;IACE,6BAAA;EA1PF;EA6PA;IACE,6BAAA;EA3PF;EA8PA;IACE,6BAAA;EA5PF;EA+PA;IACE,4BAAA;EA7PF;EAgQA;IACE,8BAAA;EA9PF;EAiQA;IACE,iCAAA;EA/PF;EAkQA;IACE,gCAAA;EAhQF;EAmQA;IACE,8BAAA;EAjQF;EAoQA;IACE,gCAAA;EAlQF;EAqQA;IACE,8BAAA;EAnQF;EAsQA;IACE,8BAAA;EApQF;EAuQA;IACE,8BAAA;EArQF;EAwQA;IACE,8BAAA;EAtQF;EAyQA;IACE,kCAAA;EAvQF;EA0QA;IACE,iCAAA;EAxQF;EA2QA;IACE,+BAAA;EAzQF;EA4QA;IACE,iCAAA;EA1QF;EA6QA;IACE,+BAAA;EA3QF;EA8QA;IACE,+BAAA;EA5QF;EA+QA;IACE,+BAAA;EA7QF;EAgRA;IACE,+BAAA;EA9QF;EAiRA;IACE,8BAAA;EA/QF;EAkRA;IACE,4BAAA;IACA,6BAAA;EAhRF;EAmRA;IACE,+BAAA;IACA,gCAAA;EAjRF;EAoRA;IACE,8BAAA;IACA,+BAAA;EAlRF;EAqRA;IACE,4BAAA;IACA,6BAAA;EAnRF;EAsRA;IACE,8BAAA;IACA,+BAAA;EApRF;EAuRA;IACE,4BAAA;IACA,6BAAA;EArRF;EAwRA;IACE,4BAAA;IACA,6BAAA;EAtRF;EAyRA;IACE,4BAAA;IACA,6BAAA;EAvRF;EA0RA;IACE,4BAAA;IACA,6BAAA;EAxRF;EA2RA;IACE,gCAAA;IACA,iCAAA;EAzRF;EA4RA;IACE,+BAAA;IACA,gCAAA;EA1RF;EA6RA;IACE,6BAAA;IACA,8BAAA;EA3RF;EA8RA;IACE,+BAAA;IACA,gCAAA;EA5RF;EA+RA;IACE,6BAAA;IACA,8BAAA;EA7RF;EAgSA;IACE,6BAAA;IACA,8BAAA;EA9RF;EAiSA;IACE,6BAAA;IACA,8BAAA;EA/RF;EAkSA;IACE,6BAAA;IACA,8BAAA;EAhSF;EAmSA;IACE,4BAAA;IACA,6BAAA;EAjSF;EAoSA;IACE,2BAAA;IACA,8BAAA;EAlSF;EAqSA;IACE,8BAAA;IACA,iCAAA;EAnSF;EAsSA;IACE,6BAAA;IACA,gCAAA;EApSF;EAuSA;IACE,2BAAA;IACA,8BAAA;EArSF;EAwSA;IACE,6BAAA;IACA,gCAAA;EAtSF;EAySA;IACE,2BAAA;IACA,8BAAA;EAvSF;EA0SA;IACE,2BAAA;IACA,8BAAA;EAxSF;EA2SA;IACE,2BAAA;IACA,8BAAA;EAzSF;EA4SA;IACE,2BAAA;IACA,8BAAA;EA1SF;EA6SA;IACE,+BAAA;IACA,kCAAA;EA3SF;EA8SA;IACE,8BAAA;IACA,iCAAA;EA5SF;EA+SA;IACE,4BAAA;IACA,+BAAA;EA7SF;EAgTA;IACE,8BAAA;IACA,iCAAA;EA9SF;EAiTA;IACE,4BAAA;IACA,+BAAA;EA/SF;EAkTA;IACE,4BAAA;IACA,+BAAA;EAhTF;EAmTA;IACE,4BAAA;IACA,+BAAA;EAjTF;EAoTA;IACE,4BAAA;IACA,+BAAA;EAlTF;EAqTA;IACE,2BAAA;IACA,8BAAA;EAnTF;AACF;AAsTA;EACE;IACE,uBAAA;EApTF;EAuTA;IACE,0BAAA;EArTF;EAwTA;IACE,yBAAA;EAtTF;EAyTA;IACE,uBAAA;EAvTF;EA0TA;IACE,yBAAA;EAxTF;EA2TA;IACE,uBAAA;EAzTF;EA4TA;IACE,uBAAA;EA1TF;EA6TA;IACE,uBAAA;EA3TF;EA8TA;IACE,uBAAA;EA5TF;EA+TA;IACE,2BAAA;EA7TF;EAgUA;IACE,0BAAA;EA9TF;EAiUA;IACE,wBAAA;EA/TF;EAkUA;IACE,0BAAA;EAhUF;EAmUA;IACE,wBAAA;EAjUF;EAoUA;IACE,wBAAA;EAlUF;EAqUA;IACE,wBAAA;EAnUF;EAsUA;IACE,wBAAA;EApUF;EAuUA;IACE,uBAAA;EArUF;EAwUA;IACE,2BAAA;EAtUF;EAyUA;IACE,8BAAA;EAvUF;EA0UA;IACE,6BAAA;EAxUF;EA2UA;IACE,2BAAA;EAzUF;EA4UA;IACE,6BAAA;EA1UF;EA6UA;IACE,2BAAA;EA3UF;EA8UA;IACE,2BAAA;EA5UF;EA+UA;IACE,2BAAA;EA7UF;EAgVA;IACE,2BAAA;EA9UF;EAiVA;IACE,+BAAA;EA/UF;EAkVA;IACE,8BAAA;EAhVF;EAmVA;IACE,4BAAA;EAjVF;EAoVA;IACE,8BAAA;EAlVF;EAqVA;IACE,4BAAA;EAnVF;EAsVA;IACE,4BAAA;EApVF;EAuVA;IACE,4BAAA;EArVF;EAwVA;IACE,4BAAA;EAtVF;EAyVA;IACE,2BAAA;EAvVF;EA0VA;IACE,6BAAA;EAxVF;EA2VA;IACE,gCAAA;EAzVF;EA4VA;IACE,+BAAA;EA1VF;EA6VA;IACE,6BAAA;EA3VF;EA8VA;IACE,+BAAA;EA5VF;EA+VA;IACE,6BAAA;EA7VF;EAgWA;IACE,6BAAA;EA9VF;EAiWA;IACE,6BAAA;EA/VF;EAkWA;IACE,6BAAA;EAhWF;EAmWA;IACE,iCAAA;EAjWF;EAoWA;IACE,gCAAA;EAlWF;EAqWA;IACE,8BAAA;EAnWF;EAsWA;IACE,gCAAA;EApWF;EAuWA;IACE,8BAAA;EArWF;EAwWA;IACE,8BAAA;EAtWF;EAyWA;IACE,8BAAA;EAvWF;EA0WA;IACE,8BAAA;EAxWF;EA2WA;IACE,6BAAA;EAzWF;EA4WA;IACE,4BAAA;EA1WF;EA6WA;IACE,+BAAA;EA3WF;EA8WA;IACE,8BAAA;EA5WF;EA+WA;IACE,4BAAA;EA7WF;EAgXA;IACE,8BAAA;EA9WF;EAiXA;IACE,4BAAA;EA/WF;EAkXA;IACE,4BAAA;EAhXF;EAmXA;IACE,4BAAA;EAjXF;EAoXA;IACE,4BAAA;EAlXF;EAqXA;IACE,gCAAA;EAnXF;EAsXA;IACE,+BAAA;EApXF;EAuXA;IACE,6BAAA;EArXF;EAwXA;IACE,+BAAA;EAtXF;EAyXA;IACE,6BAAA;EAvXF;EA0XA;IACE,6BAAA;EAxXF;EA2XA;IACE,6BAAA;EAzXF;EA4XA;IACE,6BAAA;EA1XF;EA6XA;IACE,4BAAA;EA3XF;EA8XA;IACE,8BAAA;EA5XF;EA+XA;IACE,iCAAA;EA7XF;EAgYA;IACE,gCAAA;EA9XF;EAiYA;IACE,8BAAA;EA/XF;EAkYA;IACE,gCAAA;EAhYF;EAmYA;IACE,8BAAA;EAjYF;EAoYA;IACE,8BAAA;EAlYF;EAqYA;IACE,8BAAA;EAnYF;EAsYA;IACE,8BAAA;EApYF;EAuYA;IACE,kCAAA;EArYF;EAwYA;IACE,iCAAA;EAtYF;EAyYA;IACE,+BAAA;EAvYF;EA0YA;IACE,iCAAA;EAxYF;EA2YA;IACE,+BAAA;EAzYF;EA4YA;IACE,+BAAA;EA1YF;EA6YA;IACE,+BAAA;EA3YF;EA8YA;IACE,+BAAA;EA5YF;EA+YA;IACE,8BAAA;EA7YF;EAgZA;IACE,4BAAA;IACA,6BAAA;EA9YF;EAiZA;IACE,+BAAA;IACA,gCAAA;EA/YF;EAkZA;IACE,8BAAA;IACA,+BAAA;EAhZF;EAmZA;IACE,4BAAA;IACA,6BAAA;EAjZF;EAoZA;IACE,8BAAA;IACA,+BAAA;EAlZF;EAqZA;IACE,4BAAA;IACA,6BAAA;EAnZF;EAsZA;IACE,4BAAA;IACA,6BAAA;EApZF;EAuZA;IACE,4BAAA;IACA,6BAAA;EArZF;EAwZA;IACE,4BAAA;IACA,6BAAA;EAtZF;EAyZA;IACE,gCAAA;IACA,iCAAA;EAvZF;EA0ZA;IACE,+BAAA;IACA,gCAAA;EAxZF;EA2ZA;IACE,6BAAA;IACA,8BAAA;EAzZF;EA4ZA;IACE,+BAAA;IACA,gCAAA;EA1ZF;EA6ZA;IACE,6BAAA;IACA,8BAAA;EA3ZF;EA8ZA;IACE,6BAAA;IACA,8BAAA;EA5ZF;EA+ZA;IACE,6BAAA;IACA,8BAAA;EA7ZF;EAgaA;IACE,6BAAA;IACA,8BAAA;EA9ZF;EAiaA;IACE,4BAAA;IACA,6BAAA;EA/ZF;EAkaA;IACE,2BAAA;IACA,8BAAA;EAhaF;EAmaA;IACE,8BAAA;IACA,iCAAA;EAjaF;EAoaA;IACE,6BAAA;IACA,gCAAA;EAlaF;EAqaA;IACE,2BAAA;IACA,8BAAA;EAnaF;EAsaA;IACE,6BAAA;IACA,gCAAA;EApaF;EAuaA;IACE,2BAAA;IACA,8BAAA;EAraF;EAwaA;IACE,2BAAA;IACA,8BAAA;EAtaF;EAyaA;IACE,2BAAA;IACA,8BAAA;EAvaF;EA0aA;IACE,2BAAA;IACA,8BAAA;EAxaF;EA2aA;IACE,+BAAA;IACA,kCAAA;EAzaF;EA4aA;IACE,8BAAA;IACA,iCAAA;EA1aF;EA6aA;IACE,4BAAA;IACA,+BAAA;EA3aF;EA8aA;IACE,8BAAA;IACA,iCAAA;EA5aF;EA+aA;IACE,4BAAA;IACA,+BAAA;EA7aF;EAgbA;IACE,4BAAA;IACA,+BAAA;EA9aF;EAibA;IACE,4BAAA;IACA,+BAAA;EA/aF;EAkbA;IACE,4BAAA;IACA,+BAAA;EAhbF;EAmbA;IACE,2BAAA;IACA,8BAAA;EAjbF;AACF;AAobA;EACE;IACE,uBAAA;EAlbF;EAqbA;IACE,0BAAA;EAnbF;EAsbA;IACE,yBAAA;EApbF;EAubA;IACE,uBAAA;EArbF;EAwbA;IACE,yBAAA;EAtbF;EAybA;IACE,uBAAA;EAvbF;EA0bA;IACE,uBAAA;EAxbF;EA2bA;IACE,uBAAA;EAzbF;EA4bA;IACE,uBAAA;EA1bF;EA6bA;IACE,2BAAA;EA3bF;EA8bA;IACE,0BAAA;EA5bF;EA+bA;IACE,wBAAA;EA7bF;EAgcA;IACE,0BAAA;EA9bF;EAicA;IACE,wBAAA;EA/bF;EAkcA;IACE,wBAAA;EAhcF;EAmcA;IACE,wBAAA;EAjcF;EAocA;IACE,wBAAA;EAlcF;EAqcA;IACE,uBAAA;EAncF;EAscA;IACE,2BAAA;EApcF;EAucA;IACE,8BAAA;EArcF;EAwcA;IACE,6BAAA;EAtcF;EAycA;IACE,2BAAA;EAvcF;EA0cA;IACE,6BAAA;EAxcF;EA2cA;IACE,2BAAA;EAzcF;EA4cA;IACE,2BAAA;EA1cF;EA6cA;IACE,2BAAA;EA3cF;EA8cA;IACE,2BAAA;EA5cF;EA+cA;IACE,+BAAA;EA7cF;EAgdA;IACE,8BAAA;EA9cF;EAidA;IACE,4BAAA;EA/cF;EAkdA;IACE,8BAAA;EAhdF;EAmdA;IACE,4BAAA;EAjdF;EAodA;IACE,4BAAA;EAldF;EAqdA;IACE,4BAAA;EAndF;EAsdA;IACE,4BAAA;EApdF;EAudA;IACE,2BAAA;EArdF;EAwdA;IACE,6BAAA;EAtdF;EAydA;IACE,gCAAA;EAvdF;EA0dA;IACE,+BAAA;EAxdF;EA2dA;IACE,6BAAA;EAzdF;EA4dA;IACE,+BAAA;EA1dF;EA6dA;IACE,6BAAA;EA3dF;EA8dA;IACE,6BAAA;EA5dF;EA+dA;IACE,6BAAA;EA7dF;EAgeA;IACE,6BAAA;EA9dF;EAieA;IACE,iCAAA;EA/dF;EAkeA;IACE,gCAAA;EAheF;EAmeA;IACE,8BAAA;EAjeF;EAoeA;IACE,gCAAA;EAleF;EAqeA;IACE,8BAAA;EAneF;EAseA;IACE,8BAAA;EApeF;EAueA;IACE,8BAAA;EAreF;EAweA;IACE,8BAAA;EAteF;EAyeA;IACE,6BAAA;EAveF;EA0eA;IACE,4BAAA;EAxeF;EA2eA;IACE,+BAAA;EAzeF;EA4eA;IACE,8BAAA;EA1eF;EA6eA;IACE,4BAAA;EA3eF;EA8eA;IACE,8BAAA;EA5eF;EA+eA;IACE,4BAAA;EA7eF;EAgfA;IACE,4BAAA;EA9eF;EAifA;IACE,4BAAA;EA/eF;EAkfA;IACE,4BAAA;EAhfF;EAmfA;IACE,gCAAA;EAjfF;EAofA;IACE,+BAAA;EAlfF;EAqfA;IACE,6BAAA;EAnfF;EAsfA;IACE,+BAAA;EApfF;EAufA;IACE,6BAAA;EArfF;EAwfA;IACE,6BAAA;EAtfF;EAyfA;IACE,6BAAA;EAvfF;EA0fA;IACE,6BAAA;EAxfF;EA2fA;IACE,4BAAA;EAzfF;EA4fA;IACE,8BAAA;EA1fF;EA6fA;IACE,iCAAA;EA3fF;EA8fA;IACE,gCAAA;EA5fF;EA+fA;IACE,8BAAA;EA7fF;EAggBA;IACE,gCAAA;EA9fF;EAigBA;IACE,8BAAA;EA/fF;EAkgBA;IACE,8BAAA;EAhgBF;EAmgBA;IACE,8BAAA;EAjgBF;EAogBA;IACE,8BAAA;EAlgBF;EAqgBA;IACE,kCAAA;EAngBF;EAsgBA;IACE,iCAAA;EApgBF;EAugBA;IACE,+BAAA;EArgBF;EAwgBA;IACE,iCAAA;EAtgBF;EAygBA;IACE,+BAAA;EAvgBF;EA0gBA;IACE,+BAAA;EAxgBF;EA2gBA;IACE,+BAAA;EAzgBF;EA4gBA;IACE,+BAAA;EA1gBF;EA6gBA;IACE,8BAAA;EA3gBF;EA8gBA;IACE,4BAAA;IACA,6BAAA;EA5gBF;EA+gBA;IACE,+BAAA;IACA,gCAAA;EA7gBF;EAghBA;IACE,8BAAA;IACA,+BAAA;EA9gBF;EAihBA;IACE,4BAAA;IACA,6BAAA;EA/gBF;EAkhBA;IACE,8BAAA;IACA,+BAAA;EAhhBF;EAmhBA;IACE,4BAAA;IACA,6BAAA;EAjhBF;EAohBA;IACE,4BAAA;IACA,6BAAA;EAlhBF;EAqhBA;IACE,4BAAA;IACA,6BAAA;EAnhBF;EAshBA;IACE,4BAAA;IACA,6BAAA;EAphBF;EAuhBA;IACE,gCAAA;IACA,iCAAA;EArhBF;EAwhBA;IACE,+BAAA;IACA,gCAAA;EAthBF;EAyhBA;IACE,6BAAA;IACA,8BAAA;EAvhBF;EA0hBA;IACE,+BAAA;IACA,gCAAA;EAxhBF;EA2hBA;IACE,6BAAA;IACA,8BAAA;EAzhBF;EA4hBA;IACE,6BAAA;IACA,8BAAA;EA1hBF;EA6hBA;IACE,6BAAA;IACA,8BAAA;EA3hBF;EA8hBA;IACE,6BAAA;IACA,8BAAA;EA5hBF;EA+hBA;IACE,4BAAA;IACA,6BAAA;EA7hBF;EAgiBA;IACE,2BAAA;IACA,8BAAA;EA9hBF;EAiiBA;IACE,8BAAA;IACA,iCAAA;EA/hBF;EAkiBA;IACE,6BAAA;IACA,gCAAA;EAhiBF;EAmiBA;IACE,2BAAA;IACA,8BAAA;EAjiBF;EAoiBA;IACE,6BAAA;IACA,gCAAA;EAliBF;EAqiBA;IACE,2BAAA;IACA,8BAAA;EAniBF;EAsiBA;IACE,2BAAA;IACA,8BAAA;EApiBF;EAuiBA;IACE,2BAAA;IACA,8BAAA;EAriBF;EAwiBA;IACE,2BAAA;IACA,8BAAA;EAtiBF;EAyiBA;IACE,+BAAA;IACA,kCAAA;EAviBF;EA0iBA;IACE,8BAAA;IACA,iCAAA;EAxiBF;EA2iBA;IACE,4BAAA;IACA,+BAAA;EAziBF;EA4iBA;IACE,8BAAA;IACA,iCAAA;EA1iBF;EA6iBA;IACE,4BAAA;IACA,+BAAA;EA3iBF;EA8iBA;IACE,4BAAA;IACA,+BAAA;EA5iBF;EA+iBA;IACE,4BAAA;IACA,+BAAA;EA7iBF;EAgjBA;IACE,4BAAA;IACA,+BAAA;EA9iBF;EAijBA;IACE,2BAAA;IACA,8BAAA;EA/iBF;AACF;AAkjBA;EACE;IACE,uBAAA;EAhjBF;EAmjBA;IACE,0BAAA;EAjjBF;EAojBA;IACE,yBAAA;EAljBF;EAqjBA;IACE,uBAAA;EAnjBF;EAsjBA;IACE,yBAAA;EApjBF;EAujBA;IACE,uBAAA;EArjBF;EAwjBA;IACE,uBAAA;EAtjBF;EAyjBA;IACE,uBAAA;EAvjBF;EA0jBA;IACE,uBAAA;EAxjBF;EA2jBA;IACE,2BAAA;EAzjBF;EA4jBA;IACE,0BAAA;EA1jBF;EA6jBA;IACE,wBAAA;EA3jBF;EA8jBA;IACE,0BAAA;EA5jBF;EA+jBA;IACE,wBAAA;EA7jBF;EAgkBA;IACE,wBAAA;EA9jBF;EAikBA;IACE,wBAAA;EA/jBF;EAkkBA;IACE,wBAAA;EAhkBF;EAmkBA;IACE,uBAAA;EAjkBF;EAokBA;IACE,2BAAA;EAlkBF;EAqkBA;IACE,8BAAA;EAnkBF;EAskBA;IACE,6BAAA;EApkBF;EAukBA;IACE,2BAAA;EArkBF;EAwkBA;IACE,6BAAA;EAtkBF;EAykBA;IACE,2BAAA;EAvkBF;EA0kBA;IACE,2BAAA;EAxkBF;EA2kBA;IACE,2BAAA;EAzkBF;EA4kBA;IACE,2BAAA;EA1kBF;EA6kBA;IACE,+BAAA;EA3kBF;EA8kBA;IACE,8BAAA;EA5kBF;EA+kBA;IACE,4BAAA;EA7kBF;EAglBA;IACE,8BAAA;EA9kBF;EAilBA;IACE,4BAAA;EA/kBF;EAklBA;IACE,4BAAA;EAhlBF;EAmlBA;IACE,4BAAA;EAjlBF;EAolBA;IACE,4BAAA;EAllBF;EAqlBA;IACE,2BAAA;EAnlBF;EAslBA;IACE,6BAAA;EAplBF;EAulBA;IACE,gCAAA;EArlBF;EAwlBA;IACE,+BAAA;EAtlBF;EAylBA;IACE,6BAAA;EAvlBF;EA0lBA;IACE,+BAAA;EAxlBF;EA2lBA;IACE,6BAAA;EAzlBF;EA4lBA;IACE,6BAAA;EA1lBF;EA6lBA;IACE,6BAAA;EA3lBF;EA8lBA;IACE,6BAAA;EA5lBF;EA+lBA;IACE,iCAAA;EA7lBF;EAgmBA;IACE,gCAAA;EA9lBF;EAimBA;IACE,8BAAA;EA/lBF;EAkmBA;IACE,gCAAA;EAhmBF;EAmmBA;IACE,8BAAA;EAjmBF;EAomBA;IACE,8BAAA;EAlmBF;EAqmBA;IACE,8BAAA;EAnmBF;EAsmBA;IACE,8BAAA;EApmBF;EAumBA;IACE,6BAAA;EArmBF;EAwmBA;IACE,4BAAA;EAtmBF;EAymBA;IACE,+BAAA;EAvmBF;EA0mBA;IACE,8BAAA;EAxmBF;EA2mBA;IACE,4BAAA;EAzmBF;EA4mBA;IACE,8BAAA;EA1mBF;EA6mBA;IACE,4BAAA;EA3mBF;EA8mBA;IACE,4BAAA;EA5mBF;EA+mBA;IACE,4BAAA;EA7mBF;EAgnBA;IACE,4BAAA;EA9mBF;EAinBA;IACE,gCAAA;EA/mBF;EAknBA;IACE,+BAAA;EAhnBF;EAmnBA;IACE,6BAAA;EAjnBF;EAonBA;IACE,+BAAA;EAlnBF;EAqnBA;IACE,6BAAA;EAnnBF;EAsnBA;IACE,6BAAA;EApnBF;EAunBA;IACE,6BAAA;EArnBF;EAwnBA;IACE,6BAAA;EAtnBF;EAynBA;IACE,4BAAA;EAvnBF;EA0nBA;IACE,8BAAA;EAxnBF;EA2nBA;IACE,iCAAA;EAznBF;EA4nBA;IACE,gCAAA;EA1nBF;EA6nBA;IACE,8BAAA;EA3nBF;EA8nBA;IACE,gCAAA;EA5nBF;EA+nBA;IACE,8BAAA;EA7nBF;EAgoBA;IACE,8BAAA;EA9nBF;EAioBA;IACE,8BAAA;EA/nBF;EAkoBA;IACE,8BAAA;EAhoBF;EAmoBA;IACE,kCAAA;EAjoBF;EAooBA;IACE,iCAAA;EAloBF;EAqoBA;IACE,+BAAA;EAnoBF;EAsoBA;IACE,iCAAA;EApoBF;EAuoBA;IACE,+BAAA;EAroBF;EAwoBA;IACE,+BAAA;EAtoBF;EAyoBA;IACE,+BAAA;EAvoBF;EA0oBA;IACE,+BAAA;EAxoBF;EA2oBA;IACE,8BAAA;EAzoBF;EA4oBA;IACE,4BAAA;IACA,6BAAA;EA1oBF;EA6oBA;IACE,+BAAA;IACA,gCAAA;EA3oBF;EA8oBA;IACE,8BAAA;IACA,+BAAA;EA5oBF;EA+oBA;IACE,4BAAA;IACA,6BAAA;EA7oBF;EAgpBA;IACE,8BAAA;IACA,+BAAA;EA9oBF;EAipBA;IACE,4BAAA;IACA,6BAAA;EA/oBF;EAkpBA;IACE,4BAAA;IACA,6BAAA;EAhpBF;EAmpBA;IACE,4BAAA;IACA,6BAAA;EAjpBF;EAopBA;IACE,4BAAA;IACA,6BAAA;EAlpBF;EAqpBA;IACE,gCAAA;IACA,iCAAA;EAnpBF;EAspBA;IACE,+BAAA;IACA,gCAAA;EAppBF;EAupBA;IACE,6BAAA;IACA,8BAAA;EArpBF;EAwpBA;IACE,+BAAA;IACA,gCAAA;EAtpBF;EAypBA;IACE,6BAAA;IACA,8BAAA;EAvpBF;EA0pBA;IACE,6BAAA;IACA,8BAAA;EAxpBF;EA2pBA;IACE,6BAAA;IACA,8BAAA;EAzpBF;EA4pBA;IACE,6BAAA;IACA,8BAAA;EA1pBF;EA6pBA;IACE,4BAAA;IACA,6BAAA;EA3pBF;EA8pBA;IACE,2BAAA;IACA,8BAAA;EA5pBF;EA+pBA;IACE,8BAAA;IACA,iCAAA;EA7pBF;EAgqBA;IACE,6BAAA;IACA,gCAAA;EA9pBF;EAiqBA;IACE,2BAAA;IACA,8BAAA;EA/pBF;EAkqBA;IACE,6BAAA;IACA,gCAAA;EAhqBF;EAmqBA;IACE,2BAAA;IACA,8BAAA;EAjqBF;EAoqBA;IACE,2BAAA;IACA,8BAAA;EAlqBF;EAqqBA;IACE,2BAAA;IACA,8BAAA;EAnqBF;EAsqBA;IACE,2BAAA;IACA,8BAAA;EApqBF;EAuqBA;IACE,+BAAA;IACA,kCAAA;EArqBF;EAwqBA;IACE,8BAAA;IACA,iCAAA;EAtqBF;EAyqBA;IACE,4BAAA;IACA,+BAAA;EAvqBF;EA0qBA;IACE,8BAAA;IACA,iCAAA;EAxqBF;EA2qBA;IACE,4BAAA;IACA,+BAAA;EAzqBF;EA4qBA;IACE,4BAAA;IACA,+BAAA;EA1qBF;EA6qBA;IACE,4BAAA;IACA,+BAAA;EA3qBF;EA8qBA;IACE,4BAAA;IACA,+BAAA;EA5qBF;EA+qBA;IACE,2BAAA;IACA,8BAAA;EA7qBF;AACF","sourcesContent":[":host ::ng-deep {\n    .w-full {\n        width: 100% !important;\n    }\n    .py-4 {\n        padding-top: 1.5rem !important;\n        padding-bottom: 1.5rem !important;\n    }\n    .grid>.col, .grid>[class*=col] {\n        box-sizing: border-box;\n    }\n    .border-top-1 {\n        border-top-width: 1px !important;\n        border-top-style: solid;\n    }\n    .surface-border {\n        border-color: var(--surface-border) !important;\n    }\n    .border-circle {\n        border-radius: 50% !important;\n    }\n    .align-items-center {\n        align-items: center !important;\n    }\n    .justify-content-center {\n        justify-content: center !important;\n    }\n    .flex {\n        display: flex !important;\n    }\n    .text-white {\n        color: #fff !important;\n    }\n    .bg-green-100 {\n        background-color: var(--green-100) !important;\n    }\n    .bg-green-500 {\n        background-color: var(--green-500) !important;\n    }\n    .bg-blue-100 {\n        background-color: var(--blue-100) !important;\n    }\n    .bg-blue-500 {\n        background-color: var(--blue-500) !important;\n    }\n    .bg-yellow-100 {\n        background-color: var(--yellow-100) !important;\n    }\n    .bg-yellow-500 {\n        background-color: var(--yellow-500) !important;\n    }\n    .bg-orange-100 {\n        background-color: var(--orange-100) !important;\n    }\n    .bg-orange-500 {\n        background-color: var(--orange-500) !important;\n    }\n    .bg-red-100 {\n        background-color: var(--red-100) !important;\n    }\n    .bg-red-500 {\n        background-color: var(--red-500) !important;\n    }\n    .p-ripple {\n        overflow: hidden;\n        position: relative;\n    }\n    .text-primary {\n        color: var(--primary-color) !important;\n    }\n    a {\n        text-decoration: none;\n        line-height: 16px;\n    }\n    .border-primary {\n        border-color: var(--primary-color) !important;\n    }\n    .p-2 {\n        padding: .5rem !important;\n    }\n    .font-medium {\n        font-weight: 500 !important;\n    }\n    .p-ink {\n        display: block;\n        position: absolute;\n        background: rgba(255, 255, 255, .5);\n        border-radius: 100%;\n        transform: scale(0);\n    }\n    .font-light {\n        font-weight: 300 !important;\n    }\n    .transition-duration-150 {\n        transition-duration: .15s !important;\n    }\n    .select-none {\n        -webkit-user-select: none !important;\n        user-select: none !important;\n    }\n    .cursor-pointer {\n        cursor: pointer !important;\n    }\n    .w-10rem {\n        width: 10rem !important;\n    }\n    .border-round {\n        border-radius: 8px !important;\n    }\n    .border-1 {\n        border-width: 1px !important;\n        border-style: solid;\n    }\n    .text-sm {\n        font-size: .875rem !important;\n    }\n    .my-auto {\n        margin-top: auto !important;\n        margin-bottom: auto !important;\n    }\n    .h-8rem {\n        height: 8rem !important;\n    }\n    .w-8rem {\n        width: 8rem !important;\n    }\n    .line-normal {\n        line-height: normal;\n    }\n    .block {\n        display: block !important;\n    }\n    .text-700 {\n        color: var(--surface-700) !important;\n    }\n    .text-align-left {\n        text-align: left;\n    }\n    .text-left {\n        text-align: left !important;\n    }\n    .text-center {\n        text-align: center !important;\n    }\n    .text-justify {\n        text-align: justify!important\n    }\n    .text-left {\n        text-align: left!important\n    }\n    .text-right {\n        text-align: right!important\n    }\n    .flex {\n        display: flex !important;\n    }\n    .border-round-top {\n        border-top-left-radius: 8px !important;\n        border-top-right-radius: 8px !important;\n    }\n    .surface-100 {\n        background-color: var(--surface-100) !important;\n    }\n    .col-12 {\n        flex: 0 0 auto;\n        padding: 1rem;\n        width: 100%;\n    }\n    .border-round {\n        border-radius: 8px !important;\n    }\n    .shadow-2 {\n        border: 1px solid lightgray;\n    }\n    .mb-6 {\n        margin-bottom: 3rem !important;\n    }\n    .surface-card {\n        background-color: var(--surface-card) !important;\n    }\n    .grid-nogutter {\n        margin-right: 0;\n        margin-left: 0;\n        margin-top: 0;\n    }\n    .grid {\n        display: flex;\n        flex-wrap: wrap;\n        margin-top: -1rem;\n    }\n    .grid-nogutter {\n        margin-right: 0;\n        margin-left: 0;\n        margin-top: 0;\n    }\n    * {\n        box-sizing: border-box;\n    }\n    .grid-nogutter>.col,.grid-nogutter>[class*=col-] {\n        padding: 0\n    }\n    .my-4 {\n        margin-top: 1.5rem !important;\n        margin-bottom: 1.5rem !important;\n    }\n    .align-items-center {\n        align-items: center !important;\n    }\n    .justify-content-between {\n        justify-content: space-between !important;\n    }\n    .focus\\:text-primary:focus {\n        color: var(--primary-color)!important\n    }\n    .hover\\:text-primary:hover,.active\\:text-primary:active {\n        color: var(--primary-color)!important\n    }\n    .focus\\:bg-primary:focus {\n        color: var(--primary-color-text)!important;\n        background-color: var(--primary-color)!important\n    }\n    .hover\\:bg-primary:hover,.active\\:bg-primary:active {\n        color: var(--primary-color-text)!important;\n        background-color: var(--primary-color)!important\n    }\n    .focus\\:bg-primary-reverse:focus {\n        color: var(--primary-color)!important;\n        background-color: var(--primary-color-text)!important\n    }\n    .hover\\:bg-primary-reverse:hover,.active\\:bg-primary-reverse:active {\n        color: var(--primary-color)!important;\n        background-color: var(--primary-color-text)!important\n    }\n    .focus\\:bg-white:focus {\n        background-color: #fff!important\n    }\n    .hover\\:bg-white:hover,.active\\:bg-white:active {\n        background-color: #fff!important\n    }\n    .focus\\:border-primary:focus {\n        border-color: var(--primary-color)!important\n    }\n    .hover\\:border-primary:hover,.active\\:border-primary:active {\n        border-color: var(--primary-color)!important\n    }\n    .focus\\:text-white:focus {\n        color: #fff!important\n    }\n    .hover\\:text-white:hover,.active\\:text-white:active {\n        color: #fff!important\n    }\n    .focus\\:border-white:focus {\n        border-color: #fff!important\n    }\n    .hover\\:border-white:hover,.active\\:border-white:active {\n        border-color: #fff!important\n    }\n    .focus\\:text-color:focus {\n        color: var(--text-color)!important\n    }\n    .hover\\:text-color:hover,.active\\:text-color:active {\n        color: var(--text-color)!important\n    }\n    .focus\\:text-color-secondary:focus {\n        color: var(--text-color-secondary)!important\n    }\n    .hover\\:text-color-secondary:hover,.active\\:text-color-secondary:active {\n        color: var(--text-color-secondary)!important\n    }\n    .focus\\:surface-ground:focus {\n        background-color: var(--surface-ground)!important\n    }\n    .hover\\:surface-ground:hover,.active\\:surface-ground:active {\n        background-color: var(--surface-ground)!important\n    }\n    .focus\\:surface-section:focus {\n        background-color: var(--surface-section)!important\n    }\n    .hover\\:surface-section:hover,.active\\:surface-section:active {\n        background-color: var(--surface-section)!important\n    }\n    .focus\\:surface-card:focus {\n        background-color: var(--surface-card)!important\n    }\n    .hover\\:surface-card:hover,.active\\:surface-card:active {\n        background-color: var(--surface-card)!important\n    }\n    .focus\\:surface-overlay:focus {\n        background-color: var(--surface-overlay)!important\n    }\n    .hover\\:surface-overlay:hover,.active\\:surface-overlay:active {\n        background-color: var(--surface-overlay)!important\n    }\n    .focus\\:surface-hover:focus {\n        background-color: var(--surface-hover)!important\n    }\n    .hover\\:surface-hover:hover,.active\\:surface-hover:active {\n        background-color: var(--surface-hover)!important\n    }\n    .focus\\:surface-border:focus {\n        border-color: var(--surface-border)!important\n    }\n    .hover\\:surface-border:hover,.active\\:surface-border:active {\n        border-color: var(--surface-border)!important\n    }\n}\n\n@media screen and (min-width: 768px) {\n  .md\\:flex-row {\n    flex-direction:row!important\n  }\n\n  .md\\:flex-row-reverse {\n    flex-direction: row-reverse!important\n  }\n\n  .md\\:flex-column {\n    flex-direction: column!important\n  }\n\n  .md\\:flex-column-reverse {\n    flex-direction: column-reverse!important\n  }\n}\n\n@media screen and (min-width: 992px) {\n  .lg\\:flex-row {\n    flex-direction:row!important\n  }\n\n  .lg\\:flex-row-reverse {\n    flex-direction: row-reverse!important\n  }\n\n  .lg\\:flex-column {\n    flex-direction: column!important\n  }\n\n  .lg\\:flex-column-reverse {\n    flex-direction: column-reverse!important\n  }\n}\n\n@media screen and (min-width: 1200px) {\n  .xl\\:flex-row {\n    flex-direction:row!important\n  }\n\n  .xl\\:flex-row-reverse {\n    flex-direction: row-reverse!important\n  }\n\n  .xl\\:flex-column {\n    flex-direction: column!important\n  }\n\n  .xl\\:flex-column-reverse {\n    flex-direction: column-reverse!important\n  }\n}\n\n.flex-order-0 {\n  order: 0!important\n}\n\n.flex-order-1 {\n  order: 1!important\n}\n\n.flex-order-2 {\n  order: 2!important\n}\n\n.flex-order-3 {\n  order: 3!important\n}\n\n.flex-order-4 {\n  order: 4!important\n}\n\n.flex-order-5 {\n  order: 5!important\n}\n\n.flex-order-6 {\n  order: 6!important\n}\n\n@media screen and (min-width: 576px) {\n  .sm\\:flex-order-0 {\n    order:0!important\n  }\n\n  .sm\\:flex-order-1 {\n    order: 1!important\n  }\n\n  .sm\\:flex-order-2 {\n    order: 2!important\n  }\n\n  .sm\\:flex-order-3 {\n    order: 3!important\n  }\n\n  .sm\\:flex-order-4 {\n    order: 4!important\n  }\n\n  .sm\\:flex-order-5 {\n    order: 5!important\n  }\n\n  .sm\\:flex-order-6 {\n    order: 6!important\n  }\n}\n\n@media screen and (min-width: 768px) {\n  .md\\:flex-order-0 {\n    order:0!important\n  }\n\n  .md\\:flex-order-1 {\n    order: 1!important\n  }\n\n  .md\\:flex-order-2 {\n    order: 2!important\n  }\n\n  .md\\:flex-order-3 {\n    order: 3!important\n  }\n\n  .md\\:flex-order-4 {\n    order: 4!important\n  }\n\n  .md\\:flex-order-5 {\n    order: 5!important\n  }\n\n  .md\\:flex-order-6 {\n    order: 6!important\n  }\n}\n\n@media screen and (min-width: 992px) {\n  .lg\\:flex-order-0 {\n    order:0!important\n  }\n\n  .lg\\:flex-order-1 {\n    order: 1!important\n  }\n\n  .lg\\:flex-order-2 {\n    order: 2!important\n  }\n\n  .lg\\:flex-order-3 {\n    order: 3!important\n  }\n\n  .lg\\:flex-order-4 {\n    order: 4!important\n  }\n\n  .lg\\:flex-order-5 {\n    order: 5!important\n  }\n\n  .lg\\:flex-order-6 {\n    order: 6!important\n  }\n}\n\n@media screen and (min-width: 1200px) {\n  .xl\\:flex-order-0 {\n    order:0!important\n  }\n\n  .xl\\:flex-order-1 {\n    order: 1!important\n  }\n\n  .xl\\:flex-order-2 {\n    order: 2!important\n  }\n\n  .xl\\:flex-order-3 {\n    order: 3!important\n  }\n\n  .xl\\:flex-order-4 {\n    order: 4!important\n  }\n\n  .xl\\:flex-order-5 {\n    order: 5!important\n  }\n\n  .xl\\:flex-order-6 {\n    order: 6!important\n  }\n}\n\n.flex-1 {\n  flex: 1 1 0%!important\n}\n\n.flex-auto {\n  flex: 1 1 auto!important\n}\n\n.flex-initial {\n  flex: 0 1 auto!important\n}\n\n.flex-none {\n  flex: none!important\n}\n\n@media screen and (min-width: 576px) {\n  .sm\\:flex-1 {\n    flex:1 1 0%!important\n  }\n\n  .sm\\:flex-auto {\n    flex: 1 1 auto!important\n  }\n\n  .sm\\:flex-initial {\n    flex: 0 1 auto!important\n  }\n\n  .sm\\:flex-none {\n    flex: none!important\n  }\n}\n\n@media screen and (min-width: 768px) {\n  .md\\:flex-1 {\n    flex:1 1 0%!important\n  }\n\n  .md\\:flex-auto {\n    flex: 1 1 auto!important\n  }\n\n  .md\\:flex-initial {\n    flex: 0 1 auto!important\n  }\n\n  .md\\:flex-none {\n    flex: none!important\n  }\n}\n\n@media screen and (min-width: 992px) {\n  .lg\\:flex-1 {\n    flex:1 1 0%!important\n  }\n\n  .lg\\:flex-auto {\n    flex: 1 1 auto!important\n  }\n\n  .lg\\:flex-initial {\n    flex: 0 1 auto!important\n  }\n\n  .lg\\:flex-none {\n    flex: none!important\n  }\n}\n\n@media screen and (min-width: 1200px) {\n  .xl\\:flex-1 {\n    flex:1 1 0%!important\n  }\n\n  .xl\\:flex-auto {\n    flex: 1 1 auto!important\n  }\n\n  .xl\\:flex-initial {\n    flex: 0 1 auto!important\n  }\n\n  .xl\\:flex-none {\n    flex: none!important\n  }\n}\n\n.flex-grow-0 {\n  flex-grow: 0!important\n}\n\n.flex-grow-1 {\n  flex-grow: 1!important\n}\n\n@media screen and (min-width: 576px) {\n  .sm\\:flex-grow-0 {\n    flex-grow:0!important\n  }\n\n  .sm\\:flex-grow-1 {\n    flex-grow: 1!important\n  }\n}\n\n@media screen and (min-width: 768px) {\n  .md\\:flex-grow-0 {\n    flex-grow:0!important\n  }\n\n  .md\\:flex-grow-1 {\n    flex-grow: 1!important\n  }\n}\n\n@media screen and (min-width: 992px) {\n  .lg\\:flex-grow-0 {\n    flex-grow:0!important\n  }\n\n  .lg\\:flex-grow-1 {\n    flex-grow: 1!important\n  }\n}\n\n@media screen and (min-width: 1200px) {\n  .xl\\:flex-grow-0 {\n    flex-grow:0!important\n  }\n\n  .xl\\:flex-grow-1 {\n    flex-grow: 1!important\n  }\n}\n\n.flex-shrink-0 {\n  flex-shrink: 0!important\n}\n\n.flex-shrink-1 {\n  flex-shrink: 1!important\n}\n\n@media screen and (min-width: 576px) {\n  .sm\\:flex-shrink-0 {\n    flex-shrink:0!important\n  }\n\n  .sm\\:flex-shrink-1 {\n    flex-shrink: 1!important\n  }\n}\n\n@media screen and (min-width: 768px) {\n  .md\\:flex-shrink-0 {\n    flex-shrink:0!important\n  }\n\n  .md\\:flex-shrink-1 {\n    flex-shrink: 1!important\n  }\n}\n\n@media screen and (min-width: 992px) {\n  .lg\\:flex-shrink-0 {\n    flex-shrink:0!important\n  }\n\n  .lg\\:flex-shrink-1 {\n    flex-shrink: 1!important\n  }\n}\n\n@media screen and (min-width: 1200px) {\n  .xl\\:flex-shrink-0 {\n    flex-shrink:0!important\n  }\n\n  .xl\\:flex-shrink-1 {\n    flex-shrink: 1!important\n  }\n}\n\n.gap-0 {\n  gap: 0rem!important\n}\n\n.gap-1 {\n  gap: .25rem!important\n}\n\n.gap-2 {\n  gap: .5rem!important\n}\n\n.gap-3 {\n  gap: 1rem!important\n}\n\n.gap-4 {\n  gap: 1.5rem!important\n}\n\n.gap-5 {\n  gap: 2rem!important\n}\n\n.gap-6 {\n  gap: 3rem!important\n}\n\n.gap-7 {\n  gap: 4rem!important\n}\n\n.gap-8 {\n  gap: 5rem!important\n}\n\n.row-gap-0 {\n  row-gap: 0rem!important\n}\n\n.row-gap-1 {\n  row-gap: .25rem!important\n}\n\n.row-gap-2 {\n  row-gap: .5rem!important\n}\n\n.row-gap-3 {\n  row-gap: 1rem!important\n}\n\n.row-gap-4 {\n  row-gap: 1.5rem!important\n}\n\n.row-gap-5 {\n  row-gap: 2rem!important\n}\n\n.row-gap-6 {\n  row-gap: 3rem!important\n}\n\n.row-gap-7 {\n  row-gap: 4rem!important\n}\n\n.row-gap-8 {\n  row-gap: 5rem!important\n}\n\n.column-gap-0 {\n  column-gap: 0rem!important\n}\n\n.column-gap-1 {\n  column-gap: .25rem!important\n}\n\n.column-gap-2 {\n  column-gap: .5rem!important\n}\n\n.column-gap-3 {\n  column-gap: 1rem!important\n}\n\n.column-gap-4 {\n  column-gap: 1.5rem!important\n}\n\n.column-gap-5 {\n  column-gap: 2rem!important\n}\n\n.column-gap-6 {\n  column-gap: 3rem!important\n}\n\n.column-gap-7 {\n  column-gap: 4rem!important\n}\n\n.column-gap-8 {\n  column-gap: 5rem!important\n}\n\n@media screen and (min-width: 576px) {\n  .sm\\:gap-0 {\n    gap:0rem!important\n  }\n\n  .sm\\:gap-1 {\n    gap: .25rem!important\n  }\n\n  .sm\\:gap-2 {\n    gap: .5rem!important\n  }\n\n  .sm\\:gap-3 {\n    gap: 1rem!important\n  }\n\n  .sm\\:gap-4 {\n    gap: 1.5rem!important\n  }\n\n  .sm\\:gap-5 {\n    gap: 2rem!important\n  }\n\n  .sm\\:gap-6 {\n    gap: 3rem!important\n  }\n\n  .sm\\:gap-7 {\n    gap: 4rem!important\n  }\n\n  .sm\\:gap-8 {\n    gap: 5rem!important\n  }\n\n  .sm\\:row-gap-0 {\n    row-gap: 0rem!important\n  }\n\n  .sm\\:row-gap-1 {\n    row-gap: .25rem!important\n  }\n\n  .sm\\:row-gap-2 {\n    row-gap: .5rem!important\n  }\n\n  .sm\\:row-gap-3 {\n    row-gap: 1rem!important\n  }\n\n  .sm\\:row-gap-4 {\n    row-gap: 1.5rem!important\n  }\n\n  .sm\\:row-gap-5 {\n    row-gap: 2rem!important\n  }\n\n  .sm\\:row-gap-6 {\n    row-gap: 3rem!important\n  }\n\n  .sm\\:row-gap-7 {\n    row-gap: 4rem!important\n  }\n\n  .sm\\:row-gap-8 {\n    row-gap: 5rem!important\n  }\n\n  .sm\\:column-gap-0 {\n    column-gap: 0rem!important\n  }\n\n  .sm\\:column-gap-1 {\n    column-gap: .25rem!important\n  }\n\n  .sm\\:column-gap-2 {\n    column-gap: .5rem!important\n  }\n\n  .sm\\:column-gap-3 {\n    column-gap: 1rem!important\n  }\n\n  .sm\\:column-gap-4 {\n    column-gap: 1.5rem!important\n  }\n\n  .sm\\:column-gap-5 {\n    column-gap: 2rem!important\n  }\n\n  .sm\\:column-gap-6 {\n    column-gap: 3rem!important\n  }\n\n  .sm\\:column-gap-7 {\n    column-gap: 4rem!important\n  }\n\n  .sm\\:column-gap-8 {\n    column-gap: 5rem!important\n  }\n}\n\n@media screen and (min-width: 768px) {\n  .md\\:gap-0 {\n    gap:0rem!important\n  }\n\n  .md\\:gap-1 {\n    gap: .25rem!important\n  }\n\n  .md\\:gap-2 {\n    gap: .5rem!important\n  }\n\n  .md\\:gap-3 {\n    gap: 1rem!important\n  }\n\n  .md\\:gap-4 {\n    gap: 1.5rem!important\n  }\n\n  .md\\:gap-5 {\n    gap: 2rem!important\n  }\n\n  .md\\:gap-6 {\n    gap: 3rem!important\n  }\n\n  .md\\:gap-7 {\n    gap: 4rem!important\n  }\n\n  .md\\:gap-8 {\n    gap: 5rem!important\n  }\n\n  .md\\:row-gap-0 {\n    row-gap: 0rem!important\n  }\n\n  .md\\:row-gap-1 {\n    row-gap: .25rem!important\n  }\n\n  .md\\:row-gap-2 {\n    row-gap: .5rem!important\n  }\n\n  .md\\:row-gap-3 {\n    row-gap: 1rem!important\n  }\n\n  .md\\:row-gap-4 {\n    row-gap: 1.5rem!important\n  }\n\n  .md\\:row-gap-5 {\n    row-gap: 2rem!important\n  }\n\n  .md\\:row-gap-6 {\n    row-gap: 3rem!important\n  }\n\n  .md\\:row-gap-7 {\n    row-gap: 4rem!important\n  }\n\n  .md\\:row-gap-8 {\n    row-gap: 5rem!important\n  }\n\n  .md\\:column-gap-0 {\n    column-gap: 0rem!important\n  }\n\n  .md\\:column-gap-1 {\n    column-gap: .25rem!important\n  }\n\n  .md\\:column-gap-2 {\n    column-gap: .5rem!important\n  }\n\n  .md\\:column-gap-3 {\n    column-gap: 1rem!important\n  }\n\n  .md\\:column-gap-4 {\n    column-gap: 1.5rem!important\n  }\n\n  .md\\:column-gap-5 {\n    column-gap: 2rem!important\n  }\n\n  .md\\:column-gap-6 {\n    column-gap: 3rem!important\n  }\n\n  .md\\:column-gap-7 {\n    column-gap: 4rem!important\n  }\n\n  .md\\:column-gap-8 {\n    column-gap: 5rem!important\n  }\n}\n\n@media screen and (min-width: 992px) {\n  .lg\\:gap-0 {\n    gap:0rem!important\n  }\n\n  .lg\\:gap-1 {\n    gap: .25rem!important\n  }\n\n  .lg\\:gap-2 {\n    gap: .5rem!important\n  }\n\n  .lg\\:gap-3 {\n    gap: 1rem!important\n  }\n\n  .lg\\:gap-4 {\n    gap: 1.5rem!important\n  }\n\n  .lg\\:gap-5 {\n    gap: 2rem!important\n  }\n\n  .lg\\:gap-6 {\n    gap: 3rem!important\n  }\n\n  .lg\\:gap-7 {\n    gap: 4rem!important\n  }\n\n  .lg\\:gap-8 {\n    gap: 5rem!important\n  }\n\n  .lg\\:row-gap-0 {\n    row-gap: 0rem!important\n  }\n\n  .lg\\:row-gap-1 {\n    row-gap: .25rem!important\n  }\n\n  .lg\\:row-gap-2 {\n    row-gap: .5rem!important\n  }\n\n  .lg\\:row-gap-3 {\n    row-gap: 1rem!important\n  }\n\n  .lg\\:row-gap-4 {\n    row-gap: 1.5rem!important\n  }\n\n  .lg\\:row-gap-5 {\n    row-gap: 2rem!important\n  }\n\n  .lg\\:row-gap-6 {\n    row-gap: 3rem!important\n  }\n\n  .lg\\:row-gap-7 {\n    row-gap: 4rem!important\n  }\n\n  .lg\\:row-gap-8 {\n    row-gap: 5rem!important\n  }\n\n  .lg\\:column-gap-0 {\n    column-gap: 0rem!important\n  }\n\n  .lg\\:column-gap-1 {\n    column-gap: .25rem!important\n  }\n\n  .lg\\:column-gap-2 {\n    column-gap: .5rem!important\n  }\n\n  .lg\\:column-gap-3 {\n    column-gap: 1rem!important\n  }\n\n  .lg\\:column-gap-4 {\n    column-gap: 1.5rem!important\n  }\n\n  .lg\\:column-gap-5 {\n    column-gap: 2rem!important\n  }\n\n  .lg\\:column-gap-6 {\n    column-gap: 3rem!important\n  }\n\n  .lg\\:column-gap-7 {\n    column-gap: 4rem!important\n  }\n\n  .lg\\:column-gap-8 {\n    column-gap: 5rem!important\n  }\n}\n\n@media screen and (min-width: 1200px) {\n  .xl\\:gap-0 {\n    gap:0rem!important\n  }\n\n  .xl\\:gap-1 {\n    gap: .25rem!important\n  }\n\n  .xl\\:gap-2 {\n    gap: .5rem!important\n  }\n\n  .xl\\:gap-3 {\n    gap: 1rem!important\n  }\n\n  .xl\\:gap-4 {\n    gap: 1.5rem!important\n  }\n\n  .xl\\:gap-5 {\n    gap: 2rem!important\n  }\n\n  .xl\\:gap-6 {\n    gap: 3rem!important\n  }\n\n  .xl\\:gap-7 {\n    gap: 4rem!important\n  }\n\n  .xl\\:gap-8 {\n    gap: 5rem!important\n  }\n\n  .xl\\:row-gap-0 {\n    row-gap: 0rem!important\n  }\n\n  .xl\\:row-gap-1 {\n    row-gap: .25rem!important\n  }\n\n  .xl\\:row-gap-2 {\n    row-gap: .5rem!important\n  }\n\n  .xl\\:row-gap-3 {\n    row-gap: 1rem!important\n  }\n\n  .xl\\:row-gap-4 {\n    row-gap: 1.5rem!important\n  }\n\n  .xl\\:row-gap-5 {\n    row-gap: 2rem!important\n  }\n\n  .xl\\:row-gap-6 {\n    row-gap: 3rem!important\n  }\n\n  .xl\\:row-gap-7 {\n    row-gap: 4rem!important\n  }\n\n  .xl\\:row-gap-8 {\n    row-gap: 5rem!important\n  }\n\n  .xl\\:column-gap-0 {\n    column-gap: 0rem!important\n  }\n\n  .xl\\:column-gap-1 {\n    column-gap: .25rem!important\n  }\n\n  .xl\\:column-gap-2 {\n    column-gap: .5rem!important\n  }\n\n  .xl\\:column-gap-3 {\n    column-gap: 1rem!important\n  }\n\n  .xl\\:column-gap-4 {\n    column-gap: 1.5rem!important\n  }\n\n  .xl\\:column-gap-5 {\n    column-gap: 2rem!important\n  }\n\n  .xl\\:column-gap-6 {\n    column-gap: 3rem!important\n  }\n\n  .xl\\:column-gap-7 {\n    column-gap: 4rem!important\n  }\n\n  .xl\\:column-gap-8 {\n    column-gap: 5rem!important\n  }\n}\n\n@media screen and (min-width: 576px) {\n  .sm\\:text-center {\n    text-align:center!important\n  }\n\n  .sm\\:text-justify {\n    text-align: justify!important\n  }\n\n  .sm\\:text-left {\n    text-align: left!important\n  }\n\n  .sm\\:text-right {\n    text-align: right!important\n  }\n}\n\n@media screen and (min-width: 768px) {\n  .md\\:text-center {\n    text-align:center!important\n  }\n\n  .md\\:text-justify {\n    text-align: justify!important\n  }\n\n  .md\\:text-left {\n    text-align: left!important\n  }\n\n  .md\\:text-right {\n    text-align: right!important\n  }\n}\n\n@media screen and (min-width: 992px) {\n  .lg\\:text-center {\n    text-align:center!important\n  }\n\n  .lg\\:text-justify {\n    text-align: justify!important\n  }\n\n  .lg\\:text-left {\n    text-align: left!important\n  }\n\n  .lg\\:text-right {\n    text-align: right!important\n  }\n}\n\n@media screen and (min-width: 1200px) {\n  .xl\\:text-center {\n    text-align:center!important\n  }\n\n  .xl\\:text-justify {\n    text-align: justify!important\n  }\n\n  .xl\\:text-left {\n    text-align: left!important\n  }\n\n  .xl\\:text-right {\n    text-align: right!important\n  }\n}\n\n.footer-eleven {\n  padding-top: 30px;\n  padding-bottom: 100px;\n  background-color: var(--dark-1);\n  position: relative;\n  border-top: 2px solid black;\n\n  h3 {\n    color: var(--primary);\n  }\n}\n@media only screen and (min-width: 768px) and (max-width: 991px), (max-width: 767px) {\n  .footer-eleven {\n    padding-top: 30px;\n    padding-bottom: 70px;\n  }\n}\n@media only screen and (min-width: 768px) and (max-width: 991px) {\n  .footer-eleven .footer-widget {\n    margin-top: 40px;\n  }\n}\n@media (max-width: 1199px) {\n  .footer-eleven .footer-widget {\n    margin-top: 40px;\n    /*text-align: center;*/\n  }\n\n  .footer-eleven .footer-widget.f-about {\n    margin-top: 40px;\n    text-align: center;\n  }\n}\n.footer-eleven .footer-widget h4 {\n  font-weight: 700;\n  margin-bottom: 6px;\n  color: var(--primary);\n}\n@media only screen and (min-width: 768px) and (max-width: 991px), (max-width: 767px) {\n  .footer-eleven .footer-widget h4 {\n    margin-bottom: 6px;\n  }\n}\n.footer-eleven .f-about {\n  padding-right: 30px;\n}\n@media (max-width: 767px) {\n  .footer-eleven .f-about {\n    padding: 0;\n  }\n}\n.footer-eleven .f-about p {\n  /*color: var(--dark-3);*/\n  color: var(--light-1);\n  margin-top: 20px;\n}\n.footer-eleven .f-about .copyright-text {\n  /*color: var(--dark-3);*/\n  color: var(--light-1);\n  margin-top: 20px;\n\n  @media (max-width: 1199px) {\n    .visualage {\n      display: flex;\n      width: fit-content;\n      margin: auto;\n    }\n  }\n\n  .visualage {\n    display: flex;\n    width: fit-content;\n  }\n}\n.footer-eleven .f-about .copyright-text span {\n  display: block;\n}\n@media (max-width: 767px) {\n  .footer-eleven .f-about .copyright-text {\n    margin-top: 20px;\n  }\n}\n.footer-eleven .f-about .copyright-text a {\n  color: var(--light-1);\n}\n.footer-eleven .f-about .copyright-text a:hover {\n  color: var(--visualage-1);\n}\n.footer-eleven .f-link li {\n  display: block;\n  margin-bottom: 6px;\n}\n.footer-eleven .f-link li:last-child {\n  margin: 0 0 25px 0;\n}\n.footer-eleven .f-link li a {\n  /*color: var(--dark-3);*/\n  color: var(--light-1);\n  -webkit-transition: all 0.4s ease-out 0s;\n  -moz-transition: all 0.4s ease-out 0s;\n  -ms-transition: all 0.4s ease-out 0s;\n  -o-transition: all 0.4s ease-out 0s;\n  transition: all 0.4s ease-out 0s;\n}\n.footer-eleven .f-link li a:hover {\n  color: var(--primary);\n}\n@media only screen and (min-width: 1200px) and (max-width: 1399px), only screen and (min-width: 1400px) {\n  .footer-eleven .newsletter {\n    padding-left: 80px;\n  }\n}\n.footer-eleven .newsletter p {\n  color: var(--dark-3);\n}\n.footer-eleven .newsletter-form {\n  margin-top: 30px;\n  position: relative;\n}\n.footer-eleven .newsletter-form input {\n  height: 55px;\n  width: 100%;\n  border-radius: 8px;\n  border: 1px solid var(--gray-4);\n  box-shadow: none;\n  text-shadow: none;\n  padding-left: 18px;\n  padding-right: 65px;\n  transition: all 0.4s ease;\n}\n.footer-eleven .newsletter-form input:focus {\n  border-color: var(--primary);\n}\n.footer-eleven .newsletter-form .button {\n  position: absolute;\n  right: 7px;\n  top: 50%;\n  transform: translateY(-50%);\n}\n.footer-eleven .newsletter-form .sub-btn {\n    height: 42px;\n    width: 42px;\n    border-radius: 6px;\n    background-color: var(--primary);\n    color: var(--white);\n    text-align: center;\n    line-height: 42px;\n    border: none;\n    box-shadow: none;\n    text-shadow: none;\n    font-size: 17px;\n    transition: all 0.4s ease;\n}\n.footer-eleven .newsletter-form .sub-btn:hover {\n    color: var(--white);\n    background-color: var(--primary-dark);\n}\n.insight {\n    padding: 0.5rem 0.5rem 0.5rem 3rem !important;\n\n    .pi.pi-info-circle {\n        color: var(--primary);\n        font-size: xx-large;\n    }\n}\n@media (max-width: 991px) {\n    .insight {\n        padding: 0.5rem !important;\n    }\n}\n.p-span-12 {\n    width: 100% !important;\n}\n\n.m-0 {\n  margin: 0rem!important\n}\n\n.m-1 {\n  margin: .25rem!important\n}\n\n.m-2 {\n  margin: .5rem!important\n}\n\n.m-3 {\n  margin: 1rem!important\n}\n\n.m-4 {\n  margin: 1.5rem!important\n}\n\n.m-5 {\n  margin: 2rem!important\n}\n\n.m-6 {\n  margin: 3rem!important\n}\n\n.m-7 {\n  margin: 4rem!important\n}\n\n.m-8 {\n  margin: 5rem!important\n}\n\n.-m-1 {\n  margin: -.25rem!important\n}\n\n.-m-2 {\n  margin: -.5rem!important\n}\n\n.-m-3 {\n  margin: -1rem!important\n}\n\n.-m-4 {\n  margin: -1.5rem!important\n}\n\n.-m-5 {\n  margin: -2rem!important\n}\n\n.-m-6 {\n  margin: -3rem!important\n}\n\n.-m-7 {\n  margin: -4rem!important\n}\n\n.-m-8 {\n  margin: -5rem!important\n}\n\n.m-auto {\n  margin: auto!important\n}\n\n.mt-0 {\n  margin-top: 0rem!important\n}\n\n.mt-1 {\n  margin-top: .25rem!important\n}\n\n.mt-2 {\n  margin-top: .5rem!important\n}\n\n.mt-3 {\n  margin-top: 1rem!important\n}\n\n.mt-4 {\n  margin-top: 1.5rem!important\n}\n\n.mt-5 {\n  margin-top: 2rem!important\n}\n\n.mt-6 {\n  margin-top: 3rem!important\n}\n\n.mt-7 {\n  margin-top: 4rem!important\n}\n\n.mt-8 {\n  margin-top: 5rem!important\n}\n\n.-mt-1 {\n  margin-top: -.25rem!important\n}\n\n.-mt-2 {\n  margin-top: -.5rem!important\n}\n\n.-mt-3 {\n  margin-top: -1rem!important\n}\n\n.-mt-4 {\n  margin-top: -1.5rem!important\n}\n\n.-mt-5 {\n  margin-top: -2rem!important\n}\n\n.-mt-6 {\n  margin-top: -3rem!important\n}\n\n.-mt-7 {\n  margin-top: -4rem!important\n}\n\n.-mt-8 {\n  margin-top: -5rem!important\n}\n\n.mt-auto {\n  margin-top: auto!important\n}\n\n.mr-0 {\n  margin-right: 0rem!important\n}\n\n.mr-1 {\n  margin-right: .25rem!important\n}\n\n.mr-2 {\n  margin-right: .5rem!important\n}\n\n.mr-3 {\n  margin-right: 1rem!important\n}\n\n.mr-4 {\n  margin-right: 1.5rem!important\n}\n\n.mr-5 {\n  margin-right: 2rem!important\n}\n\n.mr-6 {\n  margin-right: 3rem!important\n}\n\n.mr-7 {\n  margin-right: 4rem!important\n}\n\n.mr-8 {\n  margin-right: 5rem!important\n}\n\n.-mr-1 {\n  margin-right: -.25rem!important\n}\n\n.-mr-2 {\n  margin-right: -.5rem!important\n}\n\n.-mr-3 {\n  margin-right: -1rem!important\n}\n\n.-mr-4 {\n  margin-right: -1.5rem!important\n}\n\n.-mr-5 {\n  margin-right: -2rem!important\n}\n\n.-mr-6 {\n  margin-right: -3rem!important\n}\n\n.-mr-7 {\n  margin-right: -4rem!important\n}\n\n.-mr-8 {\n  margin-right: -5rem!important\n}\n\n.mr-auto {\n  margin-right: auto!important\n}\n\n.ml-0 {\n  margin-left: 0rem!important\n}\n\n.ml-1 {\n  margin-left: .25rem!important\n}\n\n.ml-2 {\n  margin-left: .5rem!important\n}\n\n.ml-3 {\n  margin-left: 1rem!important\n}\n\n.ml-4 {\n  margin-left: 1.5rem!important\n}\n\n.ml-5 {\n  margin-left: 2rem!important\n}\n\n.ml-6 {\n  margin-left: 3rem!important\n}\n\n.ml-7 {\n  margin-left: 4rem!important\n}\n\n.ml-8 {\n  margin-left: 5rem!important\n}\n\n.-ml-1 {\n  margin-left: -.25rem!important\n}\n\n.-ml-2 {\n  margin-left: -.5rem!important\n}\n\n.-ml-3 {\n  margin-left: -1rem!important\n}\n\n.-ml-4 {\n  margin-left: -1.5rem!important\n}\n\n.-ml-5 {\n  margin-left: -2rem!important\n}\n\n.-ml-6 {\n  margin-left: -3rem!important\n}\n\n.-ml-7 {\n  margin-left: -4rem!important\n}\n\n.-ml-8 {\n  margin-left: -5rem!important\n}\n\n.ml-auto {\n  margin-left: auto!important\n}\n\n.mb-0 {\n  margin-bottom: 0rem!important\n}\n\n.mb-1 {\n  margin-bottom: .25rem!important\n}\n\n.mb-2 {\n  margin-bottom: .5rem!important\n}\n\n.mb-3 {\n  margin-bottom: 1rem!important\n}\n\n.mb-4 {\n  margin-bottom: 1.5rem!important\n}\n\n.mb-5 {\n  margin-bottom: 2rem!important\n}\n\n.mb-6 {\n  margin-bottom: 3rem!important\n}\n\n.mb-7 {\n  margin-bottom: 4rem!important\n}\n\n.mb-8 {\n  margin-bottom: 5rem!important\n}\n\n.-mb-1 {\n  margin-bottom: -.25rem!important\n}\n\n.-mb-2 {\n  margin-bottom: -.5rem!important\n}\n\n.-mb-3 {\n  margin-bottom: -1rem!important\n}\n\n.-mb-4 {\n  margin-bottom: -1.5rem!important\n}\n\n.-mb-5 {\n  margin-bottom: -2rem!important\n}\n\n.-mb-6 {\n  margin-bottom: -3rem!important\n}\n\n.-mb-7 {\n  margin-bottom: -4rem!important\n}\n\n.-mb-8 {\n  margin-bottom: -5rem!important\n}\n\n.mb-auto {\n  margin-bottom: auto!important\n}\n\n.mx-0 {\n  margin-left: 0rem!important;\n  margin-right: 0rem!important\n}\n\n.mx-1 {\n  margin-left: .25rem!important;\n  margin-right: .25rem!important\n}\n\n.mx-2 {\n  margin-left: .5rem!important;\n  margin-right: .5rem!important\n}\n\n.mx-3 {\n  margin-left: 1rem!important;\n  margin-right: 1rem!important\n}\n\n.mx-4 {\n  margin-left: 1.5rem!important;\n  margin-right: 1.5rem!important\n}\n\n.mx-5 {\n  margin-left: 2rem!important;\n  margin-right: 2rem!important\n}\n\n.mx-6 {\n  margin-left: 3rem!important;\n  margin-right: 3rem!important\n}\n\n.mx-7 {\n  margin-left: 4rem!important;\n  margin-right: 4rem!important\n}\n\n.mx-8 {\n  margin-left: 5rem!important;\n  margin-right: 5rem!important\n}\n\n.-mx-1 {\n  margin-left: -.25rem!important;\n  margin-right: -.25rem!important\n}\n\n.-mx-2 {\n  margin-left: -.5rem!important;\n  margin-right: -.5rem!important\n}\n\n.-mx-3 {\n  margin-left: -1rem!important;\n  margin-right: -1rem!important\n}\n\n.-mx-4 {\n  margin-left: -1.5rem!important;\n  margin-right: -1.5rem!important\n}\n\n.-mx-5 {\n  margin-left: -2rem!important;\n  margin-right: -2rem!important\n}\n\n.-mx-6 {\n  margin-left: -3rem!important;\n  margin-right: -3rem!important\n}\n\n.-mx-7 {\n  margin-left: -4rem!important;\n  margin-right: -4rem!important\n}\n\n.-mx-8 {\n  margin-left: -5rem!important;\n  margin-right: -5rem!important\n}\n\n.mx-auto {\n  margin-left: auto!important;\n  margin-right: auto!important\n}\n\n.my-0 {\n  margin-top: 0rem!important;\n  margin-bottom: 0rem!important\n}\n\n.my-1 {\n  margin-top: .25rem!important;\n  margin-bottom: .25rem!important\n}\n\n.my-2 {\n  margin-top: .5rem!important;\n  margin-bottom: .5rem!important\n}\n\n.my-3 {\n  margin-top: 1rem!important;\n  margin-bottom: 1rem!important\n}\n\n.my-4 {\n  margin-top: 1.5rem!important;\n  margin-bottom: 1.5rem!important\n}\n\n.my-5 {\n  margin-top: 2rem!important;\n  margin-bottom: 2rem!important\n}\n\n.my-6 {\n  margin-top: 3rem!important;\n  margin-bottom: 3rem!important\n}\n\n.my-7 {\n  margin-top: 4rem!important;\n  margin-bottom: 4rem!important\n}\n\n.my-8 {\n  margin-top: 5rem!important;\n  margin-bottom: 5rem!important\n}\n\n.-my-1 {\n  margin-top: -.25rem!important;\n  margin-bottom: -.25rem!important\n}\n\n.-my-2 {\n  margin-top: -.5rem!important;\n  margin-bottom: -.5rem!important\n}\n\n.-my-3 {\n  margin-top: -1rem!important;\n  margin-bottom: -1rem!important\n}\n\n.-my-4 {\n  margin-top: -1.5rem!important;\n  margin-bottom: -1.5rem!important\n}\n\n.-my-5 {\n  margin-top: -2rem!important;\n  margin-bottom: -2rem!important\n}\n\n.-my-6 {\n  margin-top: -3rem!important;\n  margin-bottom: -3rem!important\n}\n\n.-my-7 {\n  margin-top: -4rem!important;\n  margin-bottom: -4rem!important\n}\n\n.-my-8 {\n  margin-top: -5rem!important;\n  margin-bottom: -5rem!important\n}\n\n.my-auto {\n  margin-top: auto!important;\n  margin-bottom: auto!important\n}\n\n@media screen and (min-width: 576px) {\n  .sm\\:m-0 {\n    margin:0rem!important\n  }\n\n  .sm\\:m-1 {\n    margin: .25rem!important\n  }\n\n  .sm\\:m-2 {\n    margin: .5rem!important\n  }\n\n  .sm\\:m-3 {\n    margin: 1rem!important\n  }\n\n  .sm\\:m-4 {\n    margin: 1.5rem!important\n  }\n\n  .sm\\:m-5 {\n    margin: 2rem!important\n  }\n\n  .sm\\:m-6 {\n    margin: 3rem!important\n  }\n\n  .sm\\:m-7 {\n    margin: 4rem!important\n  }\n\n  .sm\\:m-8 {\n    margin: 5rem!important\n  }\n\n  .sm\\:-m-1 {\n    margin: -.25rem!important\n  }\n\n  .sm\\:-m-2 {\n    margin: -.5rem!important\n  }\n\n  .sm\\:-m-3 {\n    margin: -1rem!important\n  }\n\n  .sm\\:-m-4 {\n    margin: -1.5rem!important\n  }\n\n  .sm\\:-m-5 {\n    margin: -2rem!important\n  }\n\n  .sm\\:-m-6 {\n    margin: -3rem!important\n  }\n\n  .sm\\:-m-7 {\n    margin: -4rem!important\n  }\n\n  .sm\\:-m-8 {\n    margin: -5rem!important\n  }\n\n  .sm\\:m-auto {\n    margin: auto!important\n  }\n\n  .sm\\:mt-0 {\n    margin-top: 0rem!important\n  }\n\n  .sm\\:mt-1 {\n    margin-top: .25rem!important\n  }\n\n  .sm\\:mt-2 {\n    margin-top: .5rem!important\n  }\n\n  .sm\\:mt-3 {\n    margin-top: 1rem!important\n  }\n\n  .sm\\:mt-4 {\n    margin-top: 1.5rem!important\n  }\n\n  .sm\\:mt-5 {\n    margin-top: 2rem!important\n  }\n\n  .sm\\:mt-6 {\n    margin-top: 3rem!important\n  }\n\n  .sm\\:mt-7 {\n    margin-top: 4rem!important\n  }\n\n  .sm\\:mt-8 {\n    margin-top: 5rem!important\n  }\n\n  .sm\\:-mt-1 {\n    margin-top: -.25rem!important\n  }\n\n  .sm\\:-mt-2 {\n    margin-top: -.5rem!important\n  }\n\n  .sm\\:-mt-3 {\n    margin-top: -1rem!important\n  }\n\n  .sm\\:-mt-4 {\n    margin-top: -1.5rem!important\n  }\n\n  .sm\\:-mt-5 {\n    margin-top: -2rem!important\n  }\n\n  .sm\\:-mt-6 {\n    margin-top: -3rem!important\n  }\n\n  .sm\\:-mt-7 {\n    margin-top: -4rem!important\n  }\n\n  .sm\\:-mt-8 {\n    margin-top: -5rem!important\n  }\n\n  .sm\\:mt-auto {\n    margin-top: auto!important\n  }\n\n  .sm\\:mr-0 {\n    margin-right: 0rem!important\n  }\n\n  .sm\\:mr-1 {\n    margin-right: .25rem!important\n  }\n\n  .sm\\:mr-2 {\n    margin-right: .5rem!important\n  }\n\n  .sm\\:mr-3 {\n    margin-right: 1rem!important\n  }\n\n  .sm\\:mr-4 {\n    margin-right: 1.5rem!important\n  }\n\n  .sm\\:mr-5 {\n    margin-right: 2rem!important\n  }\n\n  .sm\\:mr-6 {\n    margin-right: 3rem!important\n  }\n\n  .sm\\:mr-7 {\n    margin-right: 4rem!important\n  }\n\n  .sm\\:mr-8 {\n    margin-right: 5rem!important\n  }\n\n  .sm\\:-mr-1 {\n    margin-right: -.25rem!important\n  }\n\n  .sm\\:-mr-2 {\n    margin-right: -.5rem!important\n  }\n\n  .sm\\:-mr-3 {\n    margin-right: -1rem!important\n  }\n\n  .sm\\:-mr-4 {\n    margin-right: -1.5rem!important\n  }\n\n  .sm\\:-mr-5 {\n    margin-right: -2rem!important\n  }\n\n  .sm\\:-mr-6 {\n    margin-right: -3rem!important\n  }\n\n  .sm\\:-mr-7 {\n    margin-right: -4rem!important\n  }\n\n  .sm\\:-mr-8 {\n    margin-right: -5rem!important\n  }\n\n  .sm\\:mr-auto {\n    margin-right: auto!important\n  }\n\n  .sm\\:ml-0 {\n    margin-left: 0rem!important\n  }\n\n  .sm\\:ml-1 {\n    margin-left: .25rem!important\n  }\n\n  .sm\\:ml-2 {\n    margin-left: .5rem!important\n  }\n\n  .sm\\:ml-3 {\n    margin-left: 1rem!important\n  }\n\n  .sm\\:ml-4 {\n    margin-left: 1.5rem!important\n  }\n\n  .sm\\:ml-5 {\n    margin-left: 2rem!important\n  }\n\n  .sm\\:ml-6 {\n    margin-left: 3rem!important\n  }\n\n  .sm\\:ml-7 {\n    margin-left: 4rem!important\n  }\n\n  .sm\\:ml-8 {\n    margin-left: 5rem!important\n  }\n\n  .sm\\:-ml-1 {\n    margin-left: -.25rem!important\n  }\n\n  .sm\\:-ml-2 {\n    margin-left: -.5rem!important\n  }\n\n  .sm\\:-ml-3 {\n    margin-left: -1rem!important\n  }\n\n  .sm\\:-ml-4 {\n    margin-left: -1.5rem!important\n  }\n\n  .sm\\:-ml-5 {\n    margin-left: -2rem!important\n  }\n\n  .sm\\:-ml-6 {\n    margin-left: -3rem!important\n  }\n\n  .sm\\:-ml-7 {\n    margin-left: -4rem!important\n  }\n\n  .sm\\:-ml-8 {\n    margin-left: -5rem!important\n  }\n\n  .sm\\:ml-auto {\n    margin-left: auto!important\n  }\n\n  .sm\\:mb-0 {\n    margin-bottom: 0rem!important\n  }\n\n  .sm\\:mb-1 {\n    margin-bottom: .25rem!important\n  }\n\n  .sm\\:mb-2 {\n    margin-bottom: .5rem!important\n  }\n\n  .sm\\:mb-3 {\n    margin-bottom: 1rem!important\n  }\n\n  .sm\\:mb-4 {\n    margin-bottom: 1.5rem!important\n  }\n\n  .sm\\:mb-5 {\n    margin-bottom: 2rem!important\n  }\n\n  .sm\\:mb-6 {\n    margin-bottom: 3rem!important\n  }\n\n  .sm\\:mb-7 {\n    margin-bottom: 4rem!important\n  }\n\n  .sm\\:mb-8 {\n    margin-bottom: 5rem!important\n  }\n\n  .sm\\:-mb-1 {\n    margin-bottom: -.25rem!important\n  }\n\n  .sm\\:-mb-2 {\n    margin-bottom: -.5rem!important\n  }\n\n  .sm\\:-mb-3 {\n    margin-bottom: -1rem!important\n  }\n\n  .sm\\:-mb-4 {\n    margin-bottom: -1.5rem!important\n  }\n\n  .sm\\:-mb-5 {\n    margin-bottom: -2rem!important\n  }\n\n  .sm\\:-mb-6 {\n    margin-bottom: -3rem!important\n  }\n\n  .sm\\:-mb-7 {\n    margin-bottom: -4rem!important\n  }\n\n  .sm\\:-mb-8 {\n    margin-bottom: -5rem!important\n  }\n\n  .sm\\:mb-auto {\n    margin-bottom: auto!important\n  }\n\n  .sm\\:mx-0 {\n    margin-left: 0rem!important;\n    margin-right: 0rem!important\n  }\n\n  .sm\\:mx-1 {\n    margin-left: .25rem!important;\n    margin-right: .25rem!important\n  }\n\n  .sm\\:mx-2 {\n    margin-left: .5rem!important;\n    margin-right: .5rem!important\n  }\n\n  .sm\\:mx-3 {\n    margin-left: 1rem!important;\n    margin-right: 1rem!important\n  }\n\n  .sm\\:mx-4 {\n    margin-left: 1.5rem!important;\n    margin-right: 1.5rem!important\n  }\n\n  .sm\\:mx-5 {\n    margin-left: 2rem!important;\n    margin-right: 2rem!important\n  }\n\n  .sm\\:mx-6 {\n    margin-left: 3rem!important;\n    margin-right: 3rem!important\n  }\n\n  .sm\\:mx-7 {\n    margin-left: 4rem!important;\n    margin-right: 4rem!important\n  }\n\n  .sm\\:mx-8 {\n    margin-left: 5rem!important;\n    margin-right: 5rem!important\n  }\n\n  .sm\\:-mx-1 {\n    margin-left: -.25rem!important;\n    margin-right: -.25rem!important\n  }\n\n  .sm\\:-mx-2 {\n    margin-left: -.5rem!important;\n    margin-right: -.5rem!important\n  }\n\n  .sm\\:-mx-3 {\n    margin-left: -1rem!important;\n    margin-right: -1rem!important\n  }\n\n  .sm\\:-mx-4 {\n    margin-left: -1.5rem!important;\n    margin-right: -1.5rem!important\n  }\n\n  .sm\\:-mx-5 {\n    margin-left: -2rem!important;\n    margin-right: -2rem!important\n  }\n\n  .sm\\:-mx-6 {\n    margin-left: -3rem!important;\n    margin-right: -3rem!important\n  }\n\n  .sm\\:-mx-7 {\n    margin-left: -4rem!important;\n    margin-right: -4rem!important\n  }\n\n  .sm\\:-mx-8 {\n    margin-left: -5rem!important;\n    margin-right: -5rem!important\n  }\n\n  .sm\\:mx-auto {\n    margin-left: auto!important;\n    margin-right: auto!important\n  }\n\n  .sm\\:my-0 {\n    margin-top: 0rem!important;\n    margin-bottom: 0rem!important\n  }\n\n  .sm\\:my-1 {\n    margin-top: .25rem!important;\n    margin-bottom: .25rem!important\n  }\n\n  .sm\\:my-2 {\n    margin-top: .5rem!important;\n    margin-bottom: .5rem!important\n  }\n\n  .sm\\:my-3 {\n    margin-top: 1rem!important;\n    margin-bottom: 1rem!important\n  }\n\n  .sm\\:my-4 {\n    margin-top: 1.5rem!important;\n    margin-bottom: 1.5rem!important\n  }\n\n  .sm\\:my-5 {\n    margin-top: 2rem!important;\n    margin-bottom: 2rem!important\n  }\n\n  .sm\\:my-6 {\n    margin-top: 3rem!important;\n    margin-bottom: 3rem!important\n  }\n\n  .sm\\:my-7 {\n    margin-top: 4rem!important;\n    margin-bottom: 4rem!important\n  }\n\n  .sm\\:my-8 {\n    margin-top: 5rem!important;\n    margin-bottom: 5rem!important\n  }\n\n  .sm\\:-my-1 {\n    margin-top: -.25rem!important;\n    margin-bottom: -.25rem!important\n  }\n\n  .sm\\:-my-2 {\n    margin-top: -.5rem!important;\n    margin-bottom: -.5rem!important\n  }\n\n  .sm\\:-my-3 {\n    margin-top: -1rem!important;\n    margin-bottom: -1rem!important\n  }\n\n  .sm\\:-my-4 {\n    margin-top: -1.5rem!important;\n    margin-bottom: -1.5rem!important\n  }\n\n  .sm\\:-my-5 {\n    margin-top: -2rem!important;\n    margin-bottom: -2rem!important\n  }\n\n  .sm\\:-my-6 {\n    margin-top: -3rem!important;\n    margin-bottom: -3rem!important\n  }\n\n  .sm\\:-my-7 {\n    margin-top: -4rem!important;\n    margin-bottom: -4rem!important\n  }\n\n  .sm\\:-my-8 {\n    margin-top: -5rem!important;\n    margin-bottom: -5rem!important\n  }\n\n  .sm\\:my-auto {\n    margin-top: auto!important;\n    margin-bottom: auto!important\n  }\n}\n\n@media screen and (min-width: 768px) {\n  .md\\:m-0 {\n    margin:0rem!important\n  }\n\n  .md\\:m-1 {\n    margin: .25rem!important\n  }\n\n  .md\\:m-2 {\n    margin: .5rem!important\n  }\n\n  .md\\:m-3 {\n    margin: 1rem!important\n  }\n\n  .md\\:m-4 {\n    margin: 1.5rem!important\n  }\n\n  .md\\:m-5 {\n    margin: 2rem!important\n  }\n\n  .md\\:m-6 {\n    margin: 3rem!important\n  }\n\n  .md\\:m-7 {\n    margin: 4rem!important\n  }\n\n  .md\\:m-8 {\n    margin: 5rem!important\n  }\n\n  .md\\:-m-1 {\n    margin: -.25rem!important\n  }\n\n  .md\\:-m-2 {\n    margin: -.5rem!important\n  }\n\n  .md\\:-m-3 {\n    margin: -1rem!important\n  }\n\n  .md\\:-m-4 {\n    margin: -1.5rem!important\n  }\n\n  .md\\:-m-5 {\n    margin: -2rem!important\n  }\n\n  .md\\:-m-6 {\n    margin: -3rem!important\n  }\n\n  .md\\:-m-7 {\n    margin: -4rem!important\n  }\n\n  .md\\:-m-8 {\n    margin: -5rem!important\n  }\n\n  .md\\:m-auto {\n    margin: auto!important\n  }\n\n  .md\\:mt-0 {\n    margin-top: 0rem!important\n  }\n\n  .md\\:mt-1 {\n    margin-top: .25rem!important\n  }\n\n  .md\\:mt-2 {\n    margin-top: .5rem!important\n  }\n\n  .md\\:mt-3 {\n    margin-top: 1rem!important\n  }\n\n  .md\\:mt-4 {\n    margin-top: 1.5rem!important\n  }\n\n  .md\\:mt-5 {\n    margin-top: 2rem!important\n  }\n\n  .md\\:mt-6 {\n    margin-top: 3rem!important\n  }\n\n  .md\\:mt-7 {\n    margin-top: 4rem!important\n  }\n\n  .md\\:mt-8 {\n    margin-top: 5rem!important\n  }\n\n  .md\\:-mt-1 {\n    margin-top: -.25rem!important\n  }\n\n  .md\\:-mt-2 {\n    margin-top: -.5rem!important\n  }\n\n  .md\\:-mt-3 {\n    margin-top: -1rem!important\n  }\n\n  .md\\:-mt-4 {\n    margin-top: -1.5rem!important\n  }\n\n  .md\\:-mt-5 {\n    margin-top: -2rem!important\n  }\n\n  .md\\:-mt-6 {\n    margin-top: -3rem!important\n  }\n\n  .md\\:-mt-7 {\n    margin-top: -4rem!important\n  }\n\n  .md\\:-mt-8 {\n    margin-top: -5rem!important\n  }\n\n  .md\\:mt-auto {\n    margin-top: auto!important\n  }\n\n  .md\\:mr-0 {\n    margin-right: 0rem!important\n  }\n\n  .md\\:mr-1 {\n    margin-right: .25rem!important\n  }\n\n  .md\\:mr-2 {\n    margin-right: .5rem!important\n  }\n\n  .md\\:mr-3 {\n    margin-right: 1rem!important\n  }\n\n  .md\\:mr-4 {\n    margin-right: 1.5rem!important\n  }\n\n  .md\\:mr-5 {\n    margin-right: 2rem!important\n  }\n\n  .md\\:mr-6 {\n    margin-right: 3rem!important\n  }\n\n  .md\\:mr-7 {\n    margin-right: 4rem!important\n  }\n\n  .md\\:mr-8 {\n    margin-right: 5rem!important\n  }\n\n  .md\\:-mr-1 {\n    margin-right: -.25rem!important\n  }\n\n  .md\\:-mr-2 {\n    margin-right: -.5rem!important\n  }\n\n  .md\\:-mr-3 {\n    margin-right: -1rem!important\n  }\n\n  .md\\:-mr-4 {\n    margin-right: -1.5rem!important\n  }\n\n  .md\\:-mr-5 {\n    margin-right: -2rem!important\n  }\n\n  .md\\:-mr-6 {\n    margin-right: -3rem!important\n  }\n\n  .md\\:-mr-7 {\n    margin-right: -4rem!important\n  }\n\n  .md\\:-mr-8 {\n    margin-right: -5rem!important\n  }\n\n  .md\\:mr-auto {\n    margin-right: auto!important\n  }\n\n  .md\\:ml-0 {\n    margin-left: 0rem!important\n  }\n\n  .md\\:ml-1 {\n    margin-left: .25rem!important\n  }\n\n  .md\\:ml-2 {\n    margin-left: .5rem!important\n  }\n\n  .md\\:ml-3 {\n    margin-left: 1rem!important\n  }\n\n  .md\\:ml-4 {\n    margin-left: 1.5rem!important\n  }\n\n  .md\\:ml-5 {\n    margin-left: 2rem!important\n  }\n\n  .md\\:ml-6 {\n    margin-left: 3rem!important\n  }\n\n  .md\\:ml-7 {\n    margin-left: 4rem!important\n  }\n\n  .md\\:ml-8 {\n    margin-left: 5rem!important\n  }\n\n  .md\\:-ml-1 {\n    margin-left: -.25rem!important\n  }\n\n  .md\\:-ml-2 {\n    margin-left: -.5rem!important\n  }\n\n  .md\\:-ml-3 {\n    margin-left: -1rem!important\n  }\n\n  .md\\:-ml-4 {\n    margin-left: -1.5rem!important\n  }\n\n  .md\\:-ml-5 {\n    margin-left: -2rem!important\n  }\n\n  .md\\:-ml-6 {\n    margin-left: -3rem!important\n  }\n\n  .md\\:-ml-7 {\n    margin-left: -4rem!important\n  }\n\n  .md\\:-ml-8 {\n    margin-left: -5rem!important\n  }\n\n  .md\\:ml-auto {\n    margin-left: auto!important\n  }\n\n  .md\\:mb-0 {\n    margin-bottom: 0rem!important\n  }\n\n  .md\\:mb-1 {\n    margin-bottom: .25rem!important\n  }\n\n  .md\\:mb-2 {\n    margin-bottom: .5rem!important\n  }\n\n  .md\\:mb-3 {\n    margin-bottom: 1rem!important\n  }\n\n  .md\\:mb-4 {\n    margin-bottom: 1.5rem!important\n  }\n\n  .md\\:mb-5 {\n    margin-bottom: 2rem!important\n  }\n\n  .md\\:mb-6 {\n    margin-bottom: 3rem!important\n  }\n\n  .md\\:mb-7 {\n    margin-bottom: 4rem!important\n  }\n\n  .md\\:mb-8 {\n    margin-bottom: 5rem!important\n  }\n\n  .md\\:-mb-1 {\n    margin-bottom: -.25rem!important\n  }\n\n  .md\\:-mb-2 {\n    margin-bottom: -.5rem!important\n  }\n\n  .md\\:-mb-3 {\n    margin-bottom: -1rem!important\n  }\n\n  .md\\:-mb-4 {\n    margin-bottom: -1.5rem!important\n  }\n\n  .md\\:-mb-5 {\n    margin-bottom: -2rem!important\n  }\n\n  .md\\:-mb-6 {\n    margin-bottom: -3rem!important\n  }\n\n  .md\\:-mb-7 {\n    margin-bottom: -4rem!important\n  }\n\n  .md\\:-mb-8 {\n    margin-bottom: -5rem!important\n  }\n\n  .md\\:mb-auto {\n    margin-bottom: auto!important\n  }\n\n  .md\\:mx-0 {\n    margin-left: 0rem!important;\n    margin-right: 0rem!important\n  }\n\n  .md\\:mx-1 {\n    margin-left: .25rem!important;\n    margin-right: .25rem!important\n  }\n\n  .md\\:mx-2 {\n    margin-left: .5rem!important;\n    margin-right: .5rem!important\n  }\n\n  .md\\:mx-3 {\n    margin-left: 1rem!important;\n    margin-right: 1rem!important\n  }\n\n  .md\\:mx-4 {\n    margin-left: 1.5rem!important;\n    margin-right: 1.5rem!important\n  }\n\n  .md\\:mx-5 {\n    margin-left: 2rem!important;\n    margin-right: 2rem!important\n  }\n\n  .md\\:mx-6 {\n    margin-left: 3rem!important;\n    margin-right: 3rem!important\n  }\n\n  .md\\:mx-7 {\n    margin-left: 4rem!important;\n    margin-right: 4rem!important\n  }\n\n  .md\\:mx-8 {\n    margin-left: 5rem!important;\n    margin-right: 5rem!important\n  }\n\n  .md\\:-mx-1 {\n    margin-left: -.25rem!important;\n    margin-right: -.25rem!important\n  }\n\n  .md\\:-mx-2 {\n    margin-left: -.5rem!important;\n    margin-right: -.5rem!important\n  }\n\n  .md\\:-mx-3 {\n    margin-left: -1rem!important;\n    margin-right: -1rem!important\n  }\n\n  .md\\:-mx-4 {\n    margin-left: -1.5rem!important;\n    margin-right: -1.5rem!important\n  }\n\n  .md\\:-mx-5 {\n    margin-left: -2rem!important;\n    margin-right: -2rem!important\n  }\n\n  .md\\:-mx-6 {\n    margin-left: -3rem!important;\n    margin-right: -3rem!important\n  }\n\n  .md\\:-mx-7 {\n    margin-left: -4rem!important;\n    margin-right: -4rem!important\n  }\n\n  .md\\:-mx-8 {\n    margin-left: -5rem!important;\n    margin-right: -5rem!important\n  }\n\n  .md\\:mx-auto {\n    margin-left: auto!important;\n    margin-right: auto!important\n  }\n\n  .md\\:my-0 {\n    margin-top: 0rem!important;\n    margin-bottom: 0rem!important\n  }\n\n  .md\\:my-1 {\n    margin-top: .25rem!important;\n    margin-bottom: .25rem!important\n  }\n\n  .md\\:my-2 {\n    margin-top: .5rem!important;\n    margin-bottom: .5rem!important\n  }\n\n  .md\\:my-3 {\n    margin-top: 1rem!important;\n    margin-bottom: 1rem!important\n  }\n\n  .md\\:my-4 {\n    margin-top: 1.5rem!important;\n    margin-bottom: 1.5rem!important\n  }\n\n  .md\\:my-5 {\n    margin-top: 2rem!important;\n    margin-bottom: 2rem!important\n  }\n\n  .md\\:my-6 {\n    margin-top: 3rem!important;\n    margin-bottom: 3rem!important\n  }\n\n  .md\\:my-7 {\n    margin-top: 4rem!important;\n    margin-bottom: 4rem!important\n  }\n\n  .md\\:my-8 {\n    margin-top: 5rem!important;\n    margin-bottom: 5rem!important\n  }\n\n  .md\\:-my-1 {\n    margin-top: -.25rem!important;\n    margin-bottom: -.25rem!important\n  }\n\n  .md\\:-my-2 {\n    margin-top: -.5rem!important;\n    margin-bottom: -.5rem!important\n  }\n\n  .md\\:-my-3 {\n    margin-top: -1rem!important;\n    margin-bottom: -1rem!important\n  }\n\n  .md\\:-my-4 {\n    margin-top: -1.5rem!important;\n    margin-bottom: -1.5rem!important\n  }\n\n  .md\\:-my-5 {\n    margin-top: -2rem!important;\n    margin-bottom: -2rem!important\n  }\n\n  .md\\:-my-6 {\n    margin-top: -3rem!important;\n    margin-bottom: -3rem!important\n  }\n\n  .md\\:-my-7 {\n    margin-top: -4rem!important;\n    margin-bottom: -4rem!important\n  }\n\n  .md\\:-my-8 {\n    margin-top: -5rem!important;\n    margin-bottom: -5rem!important\n  }\n\n  .md\\:my-auto {\n    margin-top: auto!important;\n    margin-bottom: auto!important\n  }\n}\n\n@media screen and (min-width: 992px) {\n  .lg\\:m-0 {\n    margin:0rem!important\n  }\n\n  .lg\\:m-1 {\n    margin: .25rem!important\n  }\n\n  .lg\\:m-2 {\n    margin: .5rem!important\n  }\n\n  .lg\\:m-3 {\n    margin: 1rem!important\n  }\n\n  .lg\\:m-4 {\n    margin: 1.5rem!important\n  }\n\n  .lg\\:m-5 {\n    margin: 2rem!important\n  }\n\n  .lg\\:m-6 {\n    margin: 3rem!important\n  }\n\n  .lg\\:m-7 {\n    margin: 4rem!important\n  }\n\n  .lg\\:m-8 {\n    margin: 5rem!important\n  }\n\n  .lg\\:-m-1 {\n    margin: -.25rem!important\n  }\n\n  .lg\\:-m-2 {\n    margin: -.5rem!important\n  }\n\n  .lg\\:-m-3 {\n    margin: -1rem!important\n  }\n\n  .lg\\:-m-4 {\n    margin: -1.5rem!important\n  }\n\n  .lg\\:-m-5 {\n    margin: -2rem!important\n  }\n\n  .lg\\:-m-6 {\n    margin: -3rem!important\n  }\n\n  .lg\\:-m-7 {\n    margin: -4rem!important\n  }\n\n  .lg\\:-m-8 {\n    margin: -5rem!important\n  }\n\n  .lg\\:m-auto {\n    margin: auto!important\n  }\n\n  .lg\\:mt-0 {\n    margin-top: 0rem!important\n  }\n\n  .lg\\:mt-1 {\n    margin-top: .25rem!important\n  }\n\n  .lg\\:mt-2 {\n    margin-top: .5rem!important\n  }\n\n  .lg\\:mt-3 {\n    margin-top: 1rem!important\n  }\n\n  .lg\\:mt-4 {\n    margin-top: 1.5rem!important\n  }\n\n  .lg\\:mt-5 {\n    margin-top: 2rem!important\n  }\n\n  .lg\\:mt-6 {\n    margin-top: 3rem!important\n  }\n\n  .lg\\:mt-7 {\n    margin-top: 4rem!important\n  }\n\n  .lg\\:mt-8 {\n    margin-top: 5rem!important\n  }\n\n  .lg\\:-mt-1 {\n    margin-top: -.25rem!important\n  }\n\n  .lg\\:-mt-2 {\n    margin-top: -.5rem!important\n  }\n\n  .lg\\:-mt-3 {\n    margin-top: -1rem!important\n  }\n\n  .lg\\:-mt-4 {\n    margin-top: -1.5rem!important\n  }\n\n  .lg\\:-mt-5 {\n    margin-top: -2rem!important\n  }\n\n  .lg\\:-mt-6 {\n    margin-top: -3rem!important\n  }\n\n  .lg\\:-mt-7 {\n    margin-top: -4rem!important\n  }\n\n  .lg\\:-mt-8 {\n    margin-top: -5rem!important\n  }\n\n  .lg\\:mt-auto {\n    margin-top: auto!important\n  }\n\n  .lg\\:mr-0 {\n    margin-right: 0rem!important\n  }\n\n  .lg\\:mr-1 {\n    margin-right: .25rem!important\n  }\n\n  .lg\\:mr-2 {\n    margin-right: .5rem!important\n  }\n\n  .lg\\:mr-3 {\n    margin-right: 1rem!important\n  }\n\n  .lg\\:mr-4 {\n    margin-right: 1.5rem!important\n  }\n\n  .lg\\:mr-5 {\n    margin-right: 2rem!important\n  }\n\n  .lg\\:mr-6 {\n    margin-right: 3rem!important\n  }\n\n  .lg\\:mr-7 {\n    margin-right: 4rem!important\n  }\n\n  .lg\\:mr-8 {\n    margin-right: 5rem!important\n  }\n\n  .lg\\:-mr-1 {\n    margin-right: -.25rem!important\n  }\n\n  .lg\\:-mr-2 {\n    margin-right: -.5rem!important\n  }\n\n  .lg\\:-mr-3 {\n    margin-right: -1rem!important\n  }\n\n  .lg\\:-mr-4 {\n    margin-right: -1.5rem!important\n  }\n\n  .lg\\:-mr-5 {\n    margin-right: -2rem!important\n  }\n\n  .lg\\:-mr-6 {\n    margin-right: -3rem!important\n  }\n\n  .lg\\:-mr-7 {\n    margin-right: -4rem!important\n  }\n\n  .lg\\:-mr-8 {\n    margin-right: -5rem!important\n  }\n\n  .lg\\:mr-auto {\n    margin-right: auto!important\n  }\n\n  .lg\\:ml-0 {\n    margin-left: 0rem!important\n  }\n\n  .lg\\:ml-1 {\n    margin-left: .25rem!important\n  }\n\n  .lg\\:ml-2 {\n    margin-left: .5rem!important\n  }\n\n  .lg\\:ml-3 {\n    margin-left: 1rem!important\n  }\n\n  .lg\\:ml-4 {\n    margin-left: 1.5rem!important\n  }\n\n  .lg\\:ml-5 {\n    margin-left: 2rem!important\n  }\n\n  .lg\\:ml-6 {\n    margin-left: 3rem!important\n  }\n\n  .lg\\:ml-7 {\n    margin-left: 4rem!important\n  }\n\n  .lg\\:ml-8 {\n    margin-left: 5rem!important\n  }\n\n  .lg\\:-ml-1 {\n    margin-left: -.25rem!important\n  }\n\n  .lg\\:-ml-2 {\n    margin-left: -.5rem!important\n  }\n\n  .lg\\:-ml-3 {\n    margin-left: -1rem!important\n  }\n\n  .lg\\:-ml-4 {\n    margin-left: -1.5rem!important\n  }\n\n  .lg\\:-ml-5 {\n    margin-left: -2rem!important\n  }\n\n  .lg\\:-ml-6 {\n    margin-left: -3rem!important\n  }\n\n  .lg\\:-ml-7 {\n    margin-left: -4rem!important\n  }\n\n  .lg\\:-ml-8 {\n    margin-left: -5rem!important\n  }\n\n  .lg\\:ml-auto {\n    margin-left: auto!important\n  }\n\n  .lg\\:mb-0 {\n    margin-bottom: 0rem!important\n  }\n\n  .lg\\:mb-1 {\n    margin-bottom: .25rem!important\n  }\n\n  .lg\\:mb-2 {\n    margin-bottom: .5rem!important\n  }\n\n  .lg\\:mb-3 {\n    margin-bottom: 1rem!important\n  }\n\n  .lg\\:mb-4 {\n    margin-bottom: 1.5rem!important\n  }\n\n  .lg\\:mb-5 {\n    margin-bottom: 2rem!important\n  }\n\n  .lg\\:mb-6 {\n    margin-bottom: 3rem!important\n  }\n\n  .lg\\:mb-7 {\n    margin-bottom: 4rem!important\n  }\n\n  .lg\\:mb-8 {\n    margin-bottom: 5rem!important\n  }\n\n  .lg\\:-mb-1 {\n    margin-bottom: -.25rem!important\n  }\n\n  .lg\\:-mb-2 {\n    margin-bottom: -.5rem!important\n  }\n\n  .lg\\:-mb-3 {\n    margin-bottom: -1rem!important\n  }\n\n  .lg\\:-mb-4 {\n    margin-bottom: -1.5rem!important\n  }\n\n  .lg\\:-mb-5 {\n    margin-bottom: -2rem!important\n  }\n\n  .lg\\:-mb-6 {\n    margin-bottom: -3rem!important\n  }\n\n  .lg\\:-mb-7 {\n    margin-bottom: -4rem!important\n  }\n\n  .lg\\:-mb-8 {\n    margin-bottom: -5rem!important\n  }\n\n  .lg\\:mb-auto {\n    margin-bottom: auto!important\n  }\n\n  .lg\\:mx-0 {\n    margin-left: 0rem!important;\n    margin-right: 0rem!important\n  }\n\n  .lg\\:mx-1 {\n    margin-left: .25rem!important;\n    margin-right: .25rem!important\n  }\n\n  .lg\\:mx-2 {\n    margin-left: .5rem!important;\n    margin-right: .5rem!important\n  }\n\n  .lg\\:mx-3 {\n    margin-left: 1rem!important;\n    margin-right: 1rem!important\n  }\n\n  .lg\\:mx-4 {\n    margin-left: 1.5rem!important;\n    margin-right: 1.5rem!important\n  }\n\n  .lg\\:mx-5 {\n    margin-left: 2rem!important;\n    margin-right: 2rem!important\n  }\n\n  .lg\\:mx-6 {\n    margin-left: 3rem!important;\n    margin-right: 3rem!important\n  }\n\n  .lg\\:mx-7 {\n    margin-left: 4rem!important;\n    margin-right: 4rem!important\n  }\n\n  .lg\\:mx-8 {\n    margin-left: 5rem!important;\n    margin-right: 5rem!important\n  }\n\n  .lg\\:-mx-1 {\n    margin-left: -.25rem!important;\n    margin-right: -.25rem!important\n  }\n\n  .lg\\:-mx-2 {\n    margin-left: -.5rem!important;\n    margin-right: -.5rem!important\n  }\n\n  .lg\\:-mx-3 {\n    margin-left: -1rem!important;\n    margin-right: -1rem!important\n  }\n\n  .lg\\:-mx-4 {\n    margin-left: -1.5rem!important;\n    margin-right: -1.5rem!important\n  }\n\n  .lg\\:-mx-5 {\n    margin-left: -2rem!important;\n    margin-right: -2rem!important\n  }\n\n  .lg\\:-mx-6 {\n    margin-left: -3rem!important;\n    margin-right: -3rem!important\n  }\n\n  .lg\\:-mx-7 {\n    margin-left: -4rem!important;\n    margin-right: -4rem!important\n  }\n\n  .lg\\:-mx-8 {\n    margin-left: -5rem!important;\n    margin-right: -5rem!important\n  }\n\n  .lg\\:mx-auto {\n    margin-left: auto!important;\n    margin-right: auto!important\n  }\n\n  .lg\\:my-0 {\n    margin-top: 0rem!important;\n    margin-bottom: 0rem!important\n  }\n\n  .lg\\:my-1 {\n    margin-top: .25rem!important;\n    margin-bottom: .25rem!important\n  }\n\n  .lg\\:my-2 {\n    margin-top: .5rem!important;\n    margin-bottom: .5rem!important\n  }\n\n  .lg\\:my-3 {\n    margin-top: 1rem!important;\n    margin-bottom: 1rem!important\n  }\n\n  .lg\\:my-4 {\n    margin-top: 1.5rem!important;\n    margin-bottom: 1.5rem!important\n  }\n\n  .lg\\:my-5 {\n    margin-top: 2rem!important;\n    margin-bottom: 2rem!important\n  }\n\n  .lg\\:my-6 {\n    margin-top: 3rem!important;\n    margin-bottom: 3rem!important\n  }\n\n  .lg\\:my-7 {\n    margin-top: 4rem!important;\n    margin-bottom: 4rem!important\n  }\n\n  .lg\\:my-8 {\n    margin-top: 5rem!important;\n    margin-bottom: 5rem!important\n  }\n\n  .lg\\:-my-1 {\n    margin-top: -.25rem!important;\n    margin-bottom: -.25rem!important\n  }\n\n  .lg\\:-my-2 {\n    margin-top: -.5rem!important;\n    margin-bottom: -.5rem!important\n  }\n\n  .lg\\:-my-3 {\n    margin-top: -1rem!important;\n    margin-bottom: -1rem!important\n  }\n\n  .lg\\:-my-4 {\n    margin-top: -1.5rem!important;\n    margin-bottom: -1.5rem!important\n  }\n\n  .lg\\:-my-5 {\n    margin-top: -2rem!important;\n    margin-bottom: -2rem!important\n  }\n\n  .lg\\:-my-6 {\n    margin-top: -3rem!important;\n    margin-bottom: -3rem!important\n  }\n\n  .lg\\:-my-7 {\n    margin-top: -4rem!important;\n    margin-bottom: -4rem!important\n  }\n\n  .lg\\:-my-8 {\n    margin-top: -5rem!important;\n    margin-bottom: -5rem!important\n  }\n\n  .lg\\:my-auto {\n    margin-top: auto!important;\n    margin-bottom: auto!important\n  }\n}\n\n@media screen and (min-width: 1200px) {\n  .xl\\:m-0 {\n    margin:0rem!important\n  }\n\n  .xl\\:m-1 {\n    margin: .25rem!important\n  }\n\n  .xl\\:m-2 {\n    margin: .5rem!important\n  }\n\n  .xl\\:m-3 {\n    margin: 1rem!important\n  }\n\n  .xl\\:m-4 {\n    margin: 1.5rem!important\n  }\n\n  .xl\\:m-5 {\n    margin: 2rem!important\n  }\n\n  .xl\\:m-6 {\n    margin: 3rem!important\n  }\n\n  .xl\\:m-7 {\n    margin: 4rem!important\n  }\n\n  .xl\\:m-8 {\n    margin: 5rem!important\n  }\n\n  .xl\\:-m-1 {\n    margin: -.25rem!important\n  }\n\n  .xl\\:-m-2 {\n    margin: -.5rem!important\n  }\n\n  .xl\\:-m-3 {\n    margin: -1rem!important\n  }\n\n  .xl\\:-m-4 {\n    margin: -1.5rem!important\n  }\n\n  .xl\\:-m-5 {\n    margin: -2rem!important\n  }\n\n  .xl\\:-m-6 {\n    margin: -3rem!important\n  }\n\n  .xl\\:-m-7 {\n    margin: -4rem!important\n  }\n\n  .xl\\:-m-8 {\n    margin: -5rem!important\n  }\n\n  .xl\\:m-auto {\n    margin: auto!important\n  }\n\n  .xl\\:mt-0 {\n    margin-top: 0rem!important\n  }\n\n  .xl\\:mt-1 {\n    margin-top: .25rem!important\n  }\n\n  .xl\\:mt-2 {\n    margin-top: .5rem!important\n  }\n\n  .xl\\:mt-3 {\n    margin-top: 1rem!important\n  }\n\n  .xl\\:mt-4 {\n    margin-top: 1.5rem!important\n  }\n\n  .xl\\:mt-5 {\n    margin-top: 2rem!important\n  }\n\n  .xl\\:mt-6 {\n    margin-top: 3rem!important\n  }\n\n  .xl\\:mt-7 {\n    margin-top: 4rem!important\n  }\n\n  .xl\\:mt-8 {\n    margin-top: 5rem!important\n  }\n\n  .xl\\:-mt-1 {\n    margin-top: -.25rem!important\n  }\n\n  .xl\\:-mt-2 {\n    margin-top: -.5rem!important\n  }\n\n  .xl\\:-mt-3 {\n    margin-top: -1rem!important\n  }\n\n  .xl\\:-mt-4 {\n    margin-top: -1.5rem!important\n  }\n\n  .xl\\:-mt-5 {\n    margin-top: -2rem!important\n  }\n\n  .xl\\:-mt-6 {\n    margin-top: -3rem!important\n  }\n\n  .xl\\:-mt-7 {\n    margin-top: -4rem!important\n  }\n\n  .xl\\:-mt-8 {\n    margin-top: -5rem!important\n  }\n\n  .xl\\:mt-auto {\n    margin-top: auto!important\n  }\n\n  .xl\\:mr-0 {\n    margin-right: 0rem!important\n  }\n\n  .xl\\:mr-1 {\n    margin-right: .25rem!important\n  }\n\n  .xl\\:mr-2 {\n    margin-right: .5rem!important\n  }\n\n  .xl\\:mr-3 {\n    margin-right: 1rem!important\n  }\n\n  .xl\\:mr-4 {\n    margin-right: 1.5rem!important\n  }\n\n  .xl\\:mr-5 {\n    margin-right: 2rem!important\n  }\n\n  .xl\\:mr-6 {\n    margin-right: 3rem!important\n  }\n\n  .xl\\:mr-7 {\n    margin-right: 4rem!important\n  }\n\n  .xl\\:mr-8 {\n    margin-right: 5rem!important\n  }\n\n  .xl\\:-mr-1 {\n    margin-right: -.25rem!important\n  }\n\n  .xl\\:-mr-2 {\n    margin-right: -.5rem!important\n  }\n\n  .xl\\:-mr-3 {\n    margin-right: -1rem!important\n  }\n\n  .xl\\:-mr-4 {\n    margin-right: -1.5rem!important\n  }\n\n  .xl\\:-mr-5 {\n    margin-right: -2rem!important\n  }\n\n  .xl\\:-mr-6 {\n    margin-right: -3rem!important\n  }\n\n  .xl\\:-mr-7 {\n    margin-right: -4rem!important\n  }\n\n  .xl\\:-mr-8 {\n    margin-right: -5rem!important\n  }\n\n  .xl\\:mr-auto {\n    margin-right: auto!important\n  }\n\n  .xl\\:ml-0 {\n    margin-left: 0rem!important\n  }\n\n  .xl\\:ml-1 {\n    margin-left: .25rem!important\n  }\n\n  .xl\\:ml-2 {\n    margin-left: .5rem!important\n  }\n\n  .xl\\:ml-3 {\n    margin-left: 1rem!important\n  }\n\n  .xl\\:ml-4 {\n    margin-left: 1.5rem!important\n  }\n\n  .xl\\:ml-5 {\n    margin-left: 2rem!important\n  }\n\n  .xl\\:ml-6 {\n    margin-left: 3rem!important\n  }\n\n  .xl\\:ml-7 {\n    margin-left: 4rem!important\n  }\n\n  .xl\\:ml-8 {\n    margin-left: 5rem!important\n  }\n\n  .xl\\:-ml-1 {\n    margin-left: -.25rem!important\n  }\n\n  .xl\\:-ml-2 {\n    margin-left: -.5rem!important\n  }\n\n  .xl\\:-ml-3 {\n    margin-left: -1rem!important\n  }\n\n  .xl\\:-ml-4 {\n    margin-left: -1.5rem!important\n  }\n\n  .xl\\:-ml-5 {\n    margin-left: -2rem!important\n  }\n\n  .xl\\:-ml-6 {\n    margin-left: -3rem!important\n  }\n\n  .xl\\:-ml-7 {\n    margin-left: -4rem!important\n  }\n\n  .xl\\:-ml-8 {\n    margin-left: -5rem!important\n  }\n\n  .xl\\:ml-auto {\n    margin-left: auto!important\n  }\n\n  .xl\\:mb-0 {\n    margin-bottom: 0rem!important\n  }\n\n  .xl\\:mb-1 {\n    margin-bottom: .25rem!important\n  }\n\n  .xl\\:mb-2 {\n    margin-bottom: .5rem!important\n  }\n\n  .xl\\:mb-3 {\n    margin-bottom: 1rem!important\n  }\n\n  .xl\\:mb-4 {\n    margin-bottom: 1.5rem!important\n  }\n\n  .xl\\:mb-5 {\n    margin-bottom: 2rem!important\n  }\n\n  .xl\\:mb-6 {\n    margin-bottom: 3rem!important\n  }\n\n  .xl\\:mb-7 {\n    margin-bottom: 4rem!important\n  }\n\n  .xl\\:mb-8 {\n    margin-bottom: 5rem!important\n  }\n\n  .xl\\:-mb-1 {\n    margin-bottom: -.25rem!important\n  }\n\n  .xl\\:-mb-2 {\n    margin-bottom: -.5rem!important\n  }\n\n  .xl\\:-mb-3 {\n    margin-bottom: -1rem!important\n  }\n\n  .xl\\:-mb-4 {\n    margin-bottom: -1.5rem!important\n  }\n\n  .xl\\:-mb-5 {\n    margin-bottom: -2rem!important\n  }\n\n  .xl\\:-mb-6 {\n    margin-bottom: -3rem!important\n  }\n\n  .xl\\:-mb-7 {\n    margin-bottom: -4rem!important\n  }\n\n  .xl\\:-mb-8 {\n    margin-bottom: -5rem!important\n  }\n\n  .xl\\:mb-auto {\n    margin-bottom: auto!important\n  }\n\n  .xl\\:mx-0 {\n    margin-left: 0rem!important;\n    margin-right: 0rem!important\n  }\n\n  .xl\\:mx-1 {\n    margin-left: .25rem!important;\n    margin-right: .25rem!important\n  }\n\n  .xl\\:mx-2 {\n    margin-left: .5rem!important;\n    margin-right: .5rem!important\n  }\n\n  .xl\\:mx-3 {\n    margin-left: 1rem!important;\n    margin-right: 1rem!important\n  }\n\n  .xl\\:mx-4 {\n    margin-left: 1.5rem!important;\n    margin-right: 1.5rem!important\n  }\n\n  .xl\\:mx-5 {\n    margin-left: 2rem!important;\n    margin-right: 2rem!important\n  }\n\n  .xl\\:mx-6 {\n    margin-left: 3rem!important;\n    margin-right: 3rem!important\n  }\n\n  .xl\\:mx-7 {\n    margin-left: 4rem!important;\n    margin-right: 4rem!important\n  }\n\n  .xl\\:mx-8 {\n    margin-left: 5rem!important;\n    margin-right: 5rem!important\n  }\n\n  .xl\\:-mx-1 {\n    margin-left: -.25rem!important;\n    margin-right: -.25rem!important\n  }\n\n  .xl\\:-mx-2 {\n    margin-left: -.5rem!important;\n    margin-right: -.5rem!important\n  }\n\n  .xl\\:-mx-3 {\n    margin-left: -1rem!important;\n    margin-right: -1rem!important\n  }\n\n  .xl\\:-mx-4 {\n    margin-left: -1.5rem!important;\n    margin-right: -1.5rem!important\n  }\n\n  .xl\\:-mx-5 {\n    margin-left: -2rem!important;\n    margin-right: -2rem!important\n  }\n\n  .xl\\:-mx-6 {\n    margin-left: -3rem!important;\n    margin-right: -3rem!important\n  }\n\n  .xl\\:-mx-7 {\n    margin-left: -4rem!important;\n    margin-right: -4rem!important\n  }\n\n  .xl\\:-mx-8 {\n    margin-left: -5rem!important;\n    margin-right: -5rem!important\n  }\n\n  .xl\\:mx-auto {\n    margin-left: auto!important;\n    margin-right: auto!important\n  }\n\n  .xl\\:my-0 {\n    margin-top: 0rem!important;\n    margin-bottom: 0rem!important\n  }\n\n  .xl\\:my-1 {\n    margin-top: .25rem!important;\n    margin-bottom: .25rem!important\n  }\n\n  .xl\\:my-2 {\n    margin-top: .5rem!important;\n    margin-bottom: .5rem!important\n  }\n\n  .xl\\:my-3 {\n    margin-top: 1rem!important;\n    margin-bottom: 1rem!important\n  }\n\n  .xl\\:my-4 {\n    margin-top: 1.5rem!important;\n    margin-bottom: 1.5rem!important\n  }\n\n  .xl\\:my-5 {\n    margin-top: 2rem!important;\n    margin-bottom: 2rem!important\n  }\n\n  .xl\\:my-6 {\n    margin-top: 3rem!important;\n    margin-bottom: 3rem!important\n  }\n\n  .xl\\:my-7 {\n    margin-top: 4rem!important;\n    margin-bottom: 4rem!important\n  }\n\n  .xl\\:my-8 {\n    margin-top: 5rem!important;\n    margin-bottom: 5rem!important\n  }\n\n  .xl\\:-my-1 {\n    margin-top: -.25rem!important;\n    margin-bottom: -.25rem!important\n  }\n\n  .xl\\:-my-2 {\n    margin-top: -.5rem!important;\n    margin-bottom: -.5rem!important\n  }\n\n  .xl\\:-my-3 {\n    margin-top: -1rem!important;\n    margin-bottom: -1rem!important\n  }\n\n  .xl\\:-my-4 {\n    margin-top: -1.5rem!important;\n    margin-bottom: -1.5rem!important\n  }\n\n  .xl\\:-my-5 {\n    margin-top: -2rem!important;\n    margin-bottom: -2rem!important\n  }\n\n  .xl\\:-my-6 {\n    margin-top: -3rem!important;\n    margin-bottom: -3rem!important\n  }\n\n  .xl\\:-my-7 {\n    margin-top: -4rem!important;\n    margin-bottom: -4rem!important\n  }\n\n  .xl\\:-my-8 {\n    margin-top: -5rem!important;\n    margin-bottom: -5rem!important\n  }\n\n  .xl\\:my-auto {\n    margin-top: auto!important;\n    margin-bottom: auto!important\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
